export default {
  "categories": ["smileys", "people", "animals", "food", "travel", "activities", "objects", "symbols", "flags"],
  "emoji": [{
    "emoji": "😀",
    "category": 0,
    "name": "visage rieur",
    "version": "1.0"
  }, {
    "emoji": "😃",
    "category": 0,
    "name": "visage souriant avec de grands yeux",
    "version": "1.0"
  }, {
    "emoji": "😄",
    "category": 0,
    "name": "visage très souriant aux yeux rieurs",
    "version": "1.0"
  }, {
    "emoji": "😁",
    "category": 0,
    "name": "visage souriant aux yeux rieurs",
    "version": "1.0"
  }, {
    "emoji": "😆",
    "category": 0,
    "name": "visage souriant avec yeux plissés",
    "version": "1.0"
  }, {
    "emoji": "😅",
    "category": 0,
    "name": "visage souriant avec une goutte de sueur",
    "version": "1.0"
  }, {
    "emoji": "🤣",
    "category": 0,
    "name": "se rouler par terre de rire",
    "version": "3.0"
  }, {
    "emoji": "😂",
    "category": 0,
    "name": "visage riant aux larmes",
    "version": "1.0"
  }, {
    "emoji": "🙂",
    "category": 0,
    "name": "visage avec un léger sourire",
    "version": "1.0"
  }, {
    "emoji": "🙃",
    "category": 0,
    "name": "tête à l’envers",
    "version": "1.0"
  }, {
    "emoji": "😉",
    "category": 0,
    "name": "visage faisant un clin d’œil",
    "version": "1.0"
  }, {
    "emoji": "😊",
    "category": 0,
    "name": "visage souriant avec yeux rieurs",
    "version": "1.0"
  }, {
    "emoji": "😇",
    "category": 0,
    "name": "visage souriant avec auréole",
    "version": "1.0"
  }, {
    "emoji": "🥰",
    "category": 0,
    "name": "visage souriant avec cœurs",
    "version": "11.0"
  }, {
    "emoji": "😍",
    "category": 0,
    "name": "visage souriant avec yeux en forme de cœur",
    "version": "1.0"
  }, {
    "emoji": "🤩",
    "category": 0,
    "name": "visage avec des étoiles à la place des yeux",
    "version": "5.0"
  }, {
    "emoji": "😘",
    "category": 0,
    "name": "visage envoyant un bisou",
    "version": "1.0"
  }, {
    "emoji": "😗",
    "category": 0,
    "name": "visage faisant un bisou",
    "version": "1.0"
  }, {
    "emoji": "☺️",
    "category": 0,
    "name": "smiling face",
    "version": "1.0"
  }, {
    "emoji": "😚",
    "category": 0,
    "name": "visage faisant un bisou avec les yeux fermés",
    "version": "1.0"
  }, {
    "emoji": "😙",
    "category": 0,
    "name": "visage aux yeux rieurs faisant un bisou",
    "version": "1.0"
  }, {
    "emoji": "🥲",
    "category": 0,
    "name": "visage souriant avec une larme",
    "version": "13.0"
  }, {
    "emoji": "😋",
    "category": 0,
    "name": "miam",
    "version": "1.0"
  }, {
    "emoji": "😛",
    "category": 0,
    "name": "visage qui tire la langue",
    "version": "1.0"
  }, {
    "emoji": "😜",
    "category": 0,
    "name": "visage qui tire la langue et fait un clin d’œil",
    "version": "1.0"
  }, {
    "emoji": "🤪",
    "category": 0,
    "name": "tête de fou",
    "version": "5.0"
  }, {
    "emoji": "😝",
    "category": 0,
    "name": "visage qui tire la langue les yeux plissés",
    "version": "1.0"
  }, {
    "emoji": "🤑",
    "category": 0,
    "name": "argent dans les yeux et la bouche",
    "version": "1.0"
  }, {
    "emoji": "🤗",
    "category": 0,
    "name": "visage qui fait un câlin",
    "version": "1.0"
  }, {
    "emoji": "🤭",
    "category": 0,
    "name": "visage avec une main sur la bouche",
    "version": "5.0"
  }, {
    "emoji": "🤫",
    "category": 0,
    "name": "visage avec un doigt sur la bouche",
    "version": "5.0"
  }, {
    "emoji": "🤔",
    "category": 0,
    "name": "visage en pleine réflexion",
    "version": "1.0"
  }, {
    "emoji": "🤐",
    "category": 0,
    "name": "visage avec bouche fermeture éclair",
    "version": "1.0"
  }, {
    "emoji": "🤨",
    "category": 0,
    "name": "visage avec les sourcils relevés",
    "version": "5.0"
  }, {
    "emoji": "😐",
    "category": 0,
    "name": "visage neutre",
    "version": "1.0"
  }, {
    "emoji": "😑",
    "category": 0,
    "name": "visage sans expression",
    "version": "1.0"
  }, {
    "emoji": "😶",
    "category": 0,
    "name": "visage sans bouche",
    "version": "1.0"
  }, {
    "emoji": "😏",
    "category": 0,
    "name": "visage avec un sourire malin",
    "version": "1.0"
  }, {
    "emoji": "😒",
    "category": 0,
    "name": "visage blasé",
    "version": "1.0"
  }, {
    "emoji": "🙄",
    "category": 0,
    "name": "visage roulant des yeux",
    "version": "1.0"
  }, {
    "emoji": "😬",
    "category": 0,
    "name": "visage grimaçant",
    "version": "1.0"
  }, {
    "emoji": "🤥",
    "category": 0,
    "name": "visage de menteur",
    "version": "3.0"
  }, {
    "emoji": "😌",
    "category": 0,
    "name": "visage soulagé",
    "version": "1.0"
  }, {
    "emoji": "😔",
    "category": 0,
    "name": "visage pensif",
    "version": "1.0"
  }, {
    "emoji": "😪",
    "category": 0,
    "name": "visage endormi",
    "version": "1.0"
  }, {
    "emoji": "🤤",
    "category": 0,
    "name": "visage qui bave",
    "version": "3.0"
  }, {
    "emoji": "😴",
    "category": 0,
    "name": "visage somnolent",
    "version": "1.0"
  }, {
    "emoji": "😷",
    "category": 0,
    "name": "visage avec masque",
    "version": "1.0"
  }, {
    "emoji": "🤒",
    "category": 0,
    "name": "visage avec thermomètre",
    "version": "1.0"
  }, {
    "emoji": "🤕",
    "category": 0,
    "name": "visage avec bandage autour de la tête",
    "version": "1.0"
  }, {
    "emoji": "🤢",
    "category": 0,
    "name": "visage nauséeux",
    "version": "3.0"
  }, {
    "emoji": "🤮",
    "category": 0,
    "name": "visage qui vomit",
    "version": "5.0"
  }, {
    "emoji": "🤧",
    "category": 0,
    "name": "visage qui éternue",
    "version": "3.0"
  }, {
    "emoji": "🥵",
    "category": 0,
    "name": "visage rouge et chaud",
    "version": "11.0"
  }, {
    "emoji": "🥶",
    "category": 0,
    "name": "visage bleu et froid",
    "version": "11.0"
  }, {
    "emoji": "🥴",
    "category": 0,
    "name": "visage éméché",
    "version": "11.0"
  }, {
    "emoji": "😵",
    "category": 0,
    "name": "visage étourdi",
    "version": "1.0"
  }, {
    "emoji": "🤯",
    "category": 0,
    "name": "tête qui explose",
    "version": "5.0"
  }, {
    "emoji": "🤠",
    "category": 0,
    "name": "visage avec chapeau de cowboy",
    "version": "3.0"
  }, {
    "emoji": "🥳",
    "category": 0,
    "name": "visage festif",
    "version": "11.0"
  }, {
    "emoji": "🥸",
    "category": 0,
    "name": "visage déguisé",
    "version": "13.0"
  }, {
    "emoji": "😎",
    "category": 0,
    "name": "visage avec lunettes de soleil",
    "version": "1.0"
  }, {
    "emoji": "🤓",
    "category": 0,
    "name": "visage de geek",
    "version": "1.0"
  }, {
    "emoji": "🧐",
    "category": 0,
    "name": "visage avec un monocle",
    "version": "5.0"
  }, {
    "emoji": "😕",
    "category": 0,
    "name": "visage confus",
    "version": "1.0"
  }, {
    "emoji": "😟",
    "category": 0,
    "name": "visage inquiet",
    "version": "1.0"
  }, {
    "emoji": "🙁",
    "category": 0,
    "name": "visage légèrement mécontent",
    "version": "1.0"
  }, {
    "emoji": "☹️",
    "category": 0,
    "name": "frowning face",
    "version": "1.0"
  }, {
    "emoji": "😮",
    "category": 0,
    "name": "visage avec bouche ouverte",
    "version": "1.0"
  }, {
    "emoji": "😯",
    "category": 0,
    "name": "visage ébahi",
    "version": "1.0"
  }, {
    "emoji": "😲",
    "category": 0,
    "name": "visage stupéfait",
    "version": "1.0"
  }, {
    "emoji": "😳",
    "category": 0,
    "name": "visage qui rougit",
    "version": "1.0"
  }, {
    "emoji": "🥺",
    "category": 0,
    "name": "visage implorant",
    "version": "11.0"
  }, {
    "emoji": "😦",
    "category": 0,
    "name": "visage mécontent avec bouche ouverte",
    "version": "1.0"
  }, {
    "emoji": "😧",
    "category": 0,
    "name": "visage angoissé",
    "version": "1.0"
  }, {
    "emoji": "😨",
    "category": 0,
    "name": "visage effrayé",
    "version": "1.0"
  }, {
    "emoji": "😰",
    "category": 0,
    "name": "visage anxieux avec goutte de sueur",
    "version": "1.0"
  }, {
    "emoji": "😥",
    "category": 0,
    "name": "visage triste mais soulagé",
    "version": "1.0"
  }, {
    "emoji": "😢",
    "category": 0,
    "name": "visage qui pleure",
    "version": "1.0"
  }, {
    "emoji": "😭",
    "category": 0,
    "name": "visage qui pleure à chaudes larmes",
    "version": "1.0"
  }, {
    "emoji": "😱",
    "category": 0,
    "name": "visage qui hurle de peur",
    "version": "1.0"
  }, {
    "emoji": "😖",
    "category": 0,
    "name": "visage déconcerté",
    "version": "1.0"
  }, {
    "emoji": "😣",
    "category": 0,
    "name": "visage persévérant",
    "version": "1.0"
  }, {
    "emoji": "😞",
    "category": 0,
    "name": "visage déçu",
    "version": "1.0"
  }, {
    "emoji": "😓",
    "category": 0,
    "name": "visage démoralisé avec goutte de sueur",
    "version": "1.0"
  }, {
    "emoji": "😩",
    "category": 0,
    "name": "visage épuisé",
    "version": "1.0"
  }, {
    "emoji": "😫",
    "category": 0,
    "name": "visage fatigué",
    "version": "1.0"
  }, {
    "emoji": "🥱",
    "category": 0,
    "name": "visage bâillant",
    "version": "12.0"
  }, {
    "emoji": "😤",
    "category": 0,
    "name": "visage avec fumée sortant des narines",
    "version": "1.0"
  }, {
    "emoji": "😡",
    "category": 0,
    "name": "visage boudeur",
    "version": "1.0"
  }, {
    "emoji": "😠",
    "category": 0,
    "name": "visage en colère",
    "version": "1.0"
  }, {
    "emoji": "🤬",
    "category": 0,
    "name": "visage avec des symboles dans la bouche",
    "version": "5.0"
  }, {
    "emoji": "😈",
    "category": 0,
    "name": "visage souriant avec des cornes",
    "version": "1.0"
  }, {
    "emoji": "👿",
    "category": 0,
    "name": "visage en colère avec des cornes",
    "version": "1.0"
  }, {
    "emoji": "💀",
    "category": 0,
    "name": "crâne",
    "version": "1.0"
  }, {
    "emoji": "☠️",
    "category": 0,
    "name": "skull and crossbones",
    "version": "1.0"
  }, {
    "emoji": "💩",
    "category": 0,
    "name": "tas de crotte",
    "version": "1.0"
  }, {
    "emoji": "🤡",
    "category": 0,
    "name": "visage de clown",
    "version": "3.0"
  }, {
    "emoji": "👹",
    "category": 0,
    "name": "ogre",
    "version": "1.0"
  }, {
    "emoji": "👺",
    "category": 0,
    "name": "monstre japonais",
    "version": "1.0"
  }, {
    "emoji": "👻",
    "category": 0,
    "name": "fantôme",
    "version": "1.0"
  }, {
    "emoji": "👽",
    "category": 0,
    "name": "alien",
    "version": "1.0"
  }, {
    "emoji": "👾",
    "category": 0,
    "name": "monstre de l’espace",
    "version": "1.0"
  }, {
    "emoji": "🤖",
    "category": 0,
    "name": "robot",
    "version": "1.0"
  }, {
    "emoji": "😺",
    "category": 0,
    "name": "chat qui sourit",
    "version": "1.0"
  }, {
    "emoji": "😸",
    "category": 0,
    "name": "chat qui sourit avec des yeux rieurs",
    "version": "1.0"
  }, {
    "emoji": "😹",
    "category": 0,
    "name": "chat qui pleure de joie",
    "version": "1.0"
  }, {
    "emoji": "😻",
    "category": 0,
    "name": "chat souriant aux yeux en cœurs",
    "version": "1.0"
  }, {
    "emoji": "😼",
    "category": 0,
    "name": "chat avec sourire en coin",
    "version": "1.0"
  }, {
    "emoji": "😽",
    "category": 0,
    "name": "chat qui fait un bisou",
    "version": "1.0"
  }, {
    "emoji": "🙀",
    "category": 0,
    "name": "chat fatigué",
    "version": "1.0"
  }, {
    "emoji": "😿",
    "category": 0,
    "name": "chat qui pleure",
    "version": "1.0"
  }, {
    "emoji": "😾",
    "category": 0,
    "name": "chat qui boude",
    "version": "1.0"
  }, {
    "emoji": "🙈",
    "category": 0,
    "name": "singe ne rien voir",
    "version": "1.0"
  }, {
    "emoji": "🙉",
    "category": 0,
    "name": "singe ne rien entendre",
    "version": "1.0"
  }, {
    "emoji": "🙊",
    "category": 0,
    "name": "singe ne rien dire",
    "version": "1.0"
  }, {
    "emoji": "💋",
    "category": 0,
    "name": "trace de rouge à lèvres",
    "version": "1.0"
  }, {
    "emoji": "💌",
    "category": 0,
    "name": "lettre d’amour",
    "version": "1.0"
  }, {
    "emoji": "💘",
    "category": 0,
    "name": "cœur et flèche",
    "version": "1.0"
  }, {
    "emoji": "💝",
    "category": 0,
    "name": "cœur avec ruban",
    "version": "1.0"
  }, {
    "emoji": "💖",
    "category": 0,
    "name": "cœur étincelant",
    "version": "1.0"
  }, {
    "emoji": "💗",
    "category": 0,
    "name": "cœur grandissant",
    "version": "1.0"
  }, {
    "emoji": "💓",
    "category": 0,
    "name": "cœur battant",
    "version": "1.0"
  }, {
    "emoji": "💞",
    "category": 0,
    "name": "cœurs qui tournent",
    "version": "1.0"
  }, {
    "emoji": "💕",
    "category": 0,
    "name": "deux cœurs",
    "version": "1.0"
  }, {
    "emoji": "💟",
    "category": 0,
    "name": "décoration avec cœur",
    "version": "1.0"
  }, {
    "emoji": "❣️",
    "category": 0,
    "name": "heart exclamation",
    "version": "1.0"
  }, {
    "emoji": "💔",
    "category": 0,
    "name": "cœur brisé",
    "version": "1.0"
  }, {
    "emoji": "❤️",
    "category": 0,
    "name": "red heart",
    "version": "1.0"
  }, {
    "emoji": "🧡",
    "category": 0,
    "name": "cœur orange",
    "version": "5.0"
  }, {
    "emoji": "💛",
    "category": 0,
    "name": "cœur jaune",
    "version": "1.0"
  }, {
    "emoji": "💚",
    "category": 0,
    "name": "cœur vert",
    "version": "1.0"
  }, {
    "emoji": "💙",
    "category": 0,
    "name": "cœur bleu",
    "version": "1.0"
  }, {
    "emoji": "💜",
    "category": 0,
    "name": "cœur violet",
    "version": "1.0"
  }, {
    "emoji": "🤎",
    "category": 0,
    "name": "cœur marron",
    "version": "12.0"
  }, {
    "emoji": "🖤",
    "category": 0,
    "name": "cœur noir",
    "version": "3.0"
  }, {
    "emoji": "🤍",
    "category": 0,
    "name": "cœur blanc",
    "version": "12.0"
  }, {
    "emoji": "💯",
    "category": 0,
    "name": "cent points",
    "version": "1.0"
  }, {
    "emoji": "💢",
    "category": 0,
    "name": "symbole de colère",
    "version": "1.0"
  }, {
    "emoji": "💥",
    "category": 0,
    "name": "explosion",
    "version": "1.0"
  }, {
    "emoji": "💫",
    "category": 0,
    "name": "étourdissement",
    "version": "1.0"
  }, {
    "emoji": "💦",
    "category": 0,
    "name": "gouttes de sueur",
    "version": "1.0"
  }, {
    "emoji": "💨",
    "category": 0,
    "name": "décamper",
    "version": "1.0"
  }, {
    "emoji": "🕳️",
    "category": 0,
    "name": "hole",
    "version": "1.0"
  }, {
    "emoji": "💣",
    "category": 0,
    "name": "bombe",
    "version": "1.0"
  }, {
    "emoji": "💬",
    "category": 0,
    "name": "bulle de parole",
    "version": "1.0"
  }, {
    "emoji": "👁️‍🗨️",
    "category": 0,
    "name": "eye in speech bubble",
    "version": "2.0"
  }, {
    "emoji": "🗨️",
    "category": 0,
    "name": "left speech bubble",
    "version": "2.0"
  }, {
    "emoji": "🗯️",
    "category": 0,
    "name": "right anger bubble",
    "version": "1.0"
  }, {
    "emoji": "💭",
    "category": 0,
    "name": "bulle de pensée",
    "version": "1.0"
  }, {
    "emoji": "💤",
    "category": 0,
    "name": "endormi",
    "version": "1.0"
  }, {
    "emoji": "👋",
    "category": 1,
    "name": "signe de la main",
    "variations": ["👋🏻", "👋🏼", "👋🏽", "👋🏾", "👋🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤚",
    "category": 1,
    "name": "dos de main levée",
    "variations": ["🤚🏻", "🤚🏼", "🤚🏽", "🤚🏾", "🤚🏿"],
    "version": "3.0"
  }, {
    "emoji": "🖐️",
    "category": 1,
    "name": "hand with fingers splayed",
    "variations": ["🖐🏻", "🖐🏼", "🖐🏽", "🖐🏾", "🖐🏿"],
    "version": "1.0"
  }, {
    "emoji": "✋",
    "category": 1,
    "name": "main levée",
    "variations": ["✋🏻", "✋🏼", "✋🏽", "✋🏾", "✋🏿"],
    "version": "1.0"
  }, {
    "emoji": "🖖",
    "category": 1,
    "name": "salut vulcain",
    "variations": ["🖖🏻", "🖖🏼", "🖖🏽", "🖖🏾", "🖖🏿"],
    "version": "1.0"
  }, {
    "emoji": "👌",
    "category": 1,
    "name": "ok",
    "variations": ["👌🏻", "👌🏼", "👌🏽", "👌🏾", "👌🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤌",
    "category": 1,
    "name": "bout des doigts joints",
    "variations": ["🤌🏻", "🤌🏼", "🤌🏽", "🤌🏾", "🤌🏿"],
    "version": "13.0"
  }, {
    "emoji": "🤏",
    "category": 1,
    "name": "pouce et index rapprochés",
    "variations": ["🤏🏻", "🤏🏼", "🤏🏽", "🤏🏾", "🤏🏿"],
    "version": "12.0"
  }, {
    "emoji": "✌️",
    "category": 1,
    "name": "victory hand",
    "variations": ["✌🏻", "✌🏼", "✌🏽", "✌🏾", "✌🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤞",
    "category": 1,
    "name": "doigts croisés",
    "variations": ["🤞🏻", "🤞🏼", "🤞🏽", "🤞🏾", "🤞🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤟",
    "category": 1,
    "name": "signe je t’aime",
    "variations": ["🤟🏻", "🤟🏼", "🤟🏽", "🤟🏾", "🤟🏿"],
    "version": "5.0"
  }, {
    "emoji": "🤘",
    "category": 1,
    "name": "cornes avec les doigts",
    "variations": ["🤘🏻", "🤘🏼", "🤘🏽", "🤘🏾", "🤘🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤙",
    "category": 1,
    "name": "signe appel téléphonique avec les doigts",
    "variations": ["🤙🏻", "🤙🏼", "🤙🏽", "🤙🏾", "🤙🏿"],
    "version": "3.0"
  }, {
    "emoji": "👈",
    "category": 1,
    "name": "main avec index pointant à gauche",
    "variations": ["👈🏻", "👈🏼", "👈🏽", "👈🏾", "👈🏿"],
    "version": "1.0"
  }, {
    "emoji": "👉",
    "category": 1,
    "name": "main avec index pointant à droite",
    "variations": ["👉🏻", "👉🏼", "👉🏽", "👉🏾", "👉🏿"],
    "version": "1.0"
  }, {
    "emoji": "👆",
    "category": 1,
    "name": "main avec index pointant vers le haut",
    "variations": ["👆🏻", "👆🏼", "👆🏽", "👆🏾", "👆🏿"],
    "version": "1.0"
  }, {
    "emoji": "🖕",
    "category": 1,
    "name": "doigt d’honneur",
    "variations": ["🖕🏻", "🖕🏼", "🖕🏽", "🖕🏾", "🖕🏿"],
    "version": "1.0"
  }, {
    "emoji": "👇",
    "category": 1,
    "name": "main avec index pointant vers le bas",
    "variations": ["👇🏻", "👇🏼", "👇🏽", "👇🏾", "👇🏿"],
    "version": "1.0"
  }, {
    "emoji": "☝️",
    "category": 1,
    "name": "index pointing up",
    "variations": ["☝🏻", "☝🏼", "☝🏽", "☝🏾", "☝🏿"],
    "version": "1.0"
  }, {
    "emoji": "👍",
    "category": 1,
    "name": "pouce vers le haut",
    "variations": ["👍🏻", "👍🏼", "👍🏽", "👍🏾", "👍🏿"],
    "version": "1.0"
  }, {
    "emoji": "👎",
    "category": 1,
    "name": "pouce vers le bas",
    "variations": ["👎🏻", "👎🏼", "👎🏽", "👎🏾", "👎🏿"],
    "version": "1.0"
  }, {
    "emoji": "✊",
    "category": 1,
    "name": "poing levé",
    "variations": ["✊🏻", "✊🏼", "✊🏽", "✊🏾", "✊🏿"],
    "version": "1.0"
  }, {
    "emoji": "👊",
    "category": 1,
    "name": "poing de face",
    "variations": ["👊🏻", "👊🏼", "👊🏽", "👊🏾", "👊🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤛",
    "category": 1,
    "name": "poing à gauche",
    "variations": ["🤛🏻", "🤛🏼", "🤛🏽", "🤛🏾", "🤛🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤜",
    "category": 1,
    "name": "poing à droite",
    "variations": ["🤜🏻", "🤜🏼", "🤜🏽", "🤜🏾", "🤜🏿"],
    "version": "3.0"
  }, {
    "emoji": "👏",
    "category": 1,
    "name": "applaudissements",
    "variations": ["👏🏻", "👏🏼", "👏🏽", "👏🏾", "👏🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙌",
    "category": 1,
    "name": "mains levées",
    "variations": ["🙌🏻", "🙌🏼", "🙌🏽", "🙌🏾", "🙌🏿"],
    "version": "1.0"
  }, {
    "emoji": "👐",
    "category": 1,
    "name": "mains ouvertes",
    "variations": ["👐🏻", "👐🏼", "👐🏽", "👐🏾", "👐🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤲",
    "category": 1,
    "name": "paume contre paume doigts vers le haut",
    "variations": ["🤲🏻", "🤲🏼", "🤲🏽", "🤲🏾", "🤲🏿"],
    "version": "5.0"
  }, {
    "emoji": "🤝",
    "category": 1,
    "name": "poignée de main",
    "version": "3.0"
  }, {
    "emoji": "🙏",
    "category": 1,
    "name": "mains en prière",
    "variations": ["🙏🏻", "🙏🏼", "🙏🏽", "🙏🏾", "🙏🏿"],
    "version": "1.0"
  }, {
    "emoji": "✍️",
    "category": 1,
    "name": "writing hand",
    "variations": ["✍🏻", "✍🏼", "✍🏽", "✍🏾", "✍🏿"],
    "version": "1.0"
  }, {
    "emoji": "💅",
    "category": 1,
    "name": "vernis à ongles",
    "variations": ["💅🏻", "💅🏼", "💅🏽", "💅🏾", "💅🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤳",
    "category": 1,
    "name": "selfie",
    "variations": ["🤳🏻", "🤳🏼", "🤳🏽", "🤳🏾", "🤳🏿"],
    "version": "3.0"
  }, {
    "emoji": "💪",
    "category": 1,
    "name": "biceps contracté",
    "variations": ["💪🏻", "💪🏼", "💪🏽", "💪🏾", "💪🏿"],
    "version": "1.0"
  }, {
    "emoji": "🦾",
    "category": 1,
    "name": "bras mécanique",
    "version": "12.0"
  }, {
    "emoji": "🦿",
    "category": 1,
    "name": "jambe mécanique",
    "version": "12.0"
  }, {
    "emoji": "🦵",
    "category": 1,
    "name": "jambe",
    "variations": ["🦵🏻", "🦵🏼", "🦵🏽", "🦵🏾", "🦵🏿"],
    "version": "11.0"
  }, {
    "emoji": "🦶",
    "category": 1,
    "name": "pied",
    "variations": ["🦶🏻", "🦶🏼", "🦶🏽", "🦶🏾", "🦶🏿"],
    "version": "11.0"
  }, {
    "emoji": "👂",
    "category": 1,
    "name": "oreille",
    "variations": ["👂🏻", "👂🏼", "👂🏽", "👂🏾", "👂🏿"],
    "version": "1.0"
  }, {
    "emoji": "🦻",
    "category": 1,
    "name": "oreille appareillée",
    "variations": ["🦻🏻", "🦻🏼", "🦻🏽", "🦻🏾", "🦻🏿"],
    "version": "12.0"
  }, {
    "emoji": "👃",
    "category": 1,
    "name": "nez",
    "variations": ["👃🏻", "👃🏼", "👃🏽", "👃🏾", "👃🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧠",
    "category": 1,
    "name": "cerveau",
    "version": "5.0"
  }, {
    "emoji": "🫀",
    "category": 1,
    "name": "cœur",
    "version": "13.0"
  }, {
    "emoji": "🫁",
    "category": 1,
    "name": "poumons",
    "version": "13.0"
  }, {
    "emoji": "🦷",
    "category": 1,
    "name": "dent",
    "version": "11.0"
  }, {
    "emoji": "🦴",
    "category": 1,
    "name": "os",
    "version": "11.0"
  }, {
    "emoji": "👀",
    "category": 1,
    "name": "yeux",
    "version": "1.0"
  }, {
    "emoji": "👁️",
    "category": 1,
    "name": "eye",
    "version": "1.0"
  }, {
    "emoji": "👅",
    "category": 1,
    "name": "langue",
    "version": "1.0"
  }, {
    "emoji": "👄",
    "category": 1,
    "name": "bouche",
    "version": "1.0"
  }, {
    "emoji": "👶",
    "category": 1,
    "name": "bébé",
    "variations": ["👶🏻", "👶🏼", "👶🏽", "👶🏾", "👶🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧒",
    "category": 1,
    "name": "enfant",
    "variations": ["🧒🏻", "🧒🏼", "🧒🏽", "🧒🏾", "🧒🏿"],
    "version": "5.0"
  }, {
    "emoji": "👦",
    "category": 1,
    "name": "garçon",
    "variations": ["👦🏻", "👦🏼", "👦🏽", "👦🏾", "👦🏿"],
    "version": "1.0"
  }, {
    "emoji": "👧",
    "category": 1,
    "name": "fille",
    "variations": ["👧🏻", "👧🏼", "👧🏽", "👧🏾", "👧🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧑",
    "category": 1,
    "name": "adulte",
    "variations": ["🧑🏻", "🧑🏼", "🧑🏽", "🧑🏾", "🧑🏿"],
    "version": "5.0"
  }, {
    "emoji": "👱",
    "category": 1,
    "name": "personne blonde",
    "variations": ["👱🏻", "👱🏼", "👱🏽", "👱🏾", "👱🏿"],
    "version": "1.0"
  }, {
    "emoji": "👨",
    "category": 1,
    "name": "homme",
    "variations": ["👨🏻", "👨🏼", "👨🏽", "👨🏾", "👨🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧔",
    "category": 1,
    "name": "personne barbue",
    "variations": ["🧔🏻", "🧔🏼", "🧔🏽", "🧔🏾", "🧔🏿"],
    "version": "5.0"
  }, {
    "emoji": "👨‍🦰",
    "category": 1,
    "name": "homme : cheveux roux",
    "variations": ["👨🏻‍🦰", "👨🏼‍🦰", "👨🏽‍🦰", "👨🏾‍🦰", "👨🏿‍🦰"],
    "version": "11.0"
  }, {
    "emoji": "👨‍🦱",
    "category": 1,
    "name": "homme : cheveux bouclés",
    "variations": ["👨🏻‍🦱", "👨🏼‍🦱", "👨🏽‍🦱", "👨🏾‍🦱", "👨🏿‍🦱"],
    "version": "11.0"
  }, {
    "emoji": "👨‍🦳",
    "category": 1,
    "name": "homme : cheveux blancs",
    "variations": ["👨🏻‍🦳", "👨🏼‍🦳", "👨🏽‍🦳", "👨🏾‍🦳", "👨🏿‍🦳"],
    "version": "11.0"
  }, {
    "emoji": "👨‍🦲",
    "category": 1,
    "name": "homme : chauve",
    "variations": ["👨🏻‍🦲", "👨🏼‍🦲", "👨🏽‍🦲", "👨🏾‍🦲", "👨🏿‍🦲"],
    "version": "11.0"
  }, {
    "emoji": "👩",
    "category": 1,
    "name": "femme",
    "variations": ["👩🏻", "👩🏼", "👩🏽", "👩🏾", "👩🏿"],
    "version": "1.0"
  }, {
    "emoji": "👩‍🦰",
    "category": 1,
    "name": "femme : cheveux roux",
    "variations": ["👩🏻‍🦰", "👩🏼‍🦰", "👩🏽‍🦰", "👩🏾‍🦰", "👩🏿‍🦰"],
    "version": "11.0"
  }, {
    "emoji": "🧑‍🦰",
    "category": 1,
    "name": "adulte : cheveux roux",
    "variations": ["🧑🏻‍🦰", "🧑🏼‍🦰", "🧑🏽‍🦰", "🧑🏾‍🦰", "🧑🏿‍🦰"],
    "version": "12.1"
  }, {
    "emoji": "👩‍🦱",
    "category": 1,
    "name": "femme : cheveux bouclés",
    "variations": ["👩🏻‍🦱", "👩🏼‍🦱", "👩🏽‍🦱", "👩🏾‍🦱", "👩🏿‍🦱"],
    "version": "11.0"
  }, {
    "emoji": "🧑‍🦱",
    "category": 1,
    "name": "adulte : cheveux bouclés",
    "variations": ["🧑🏻‍🦱", "🧑🏼‍🦱", "🧑🏽‍🦱", "🧑🏾‍🦱", "🧑🏿‍🦱"],
    "version": "12.1"
  }, {
    "emoji": "👩‍🦳",
    "category": 1,
    "name": "femme : cheveux blancs",
    "variations": ["👩🏻‍🦳", "👩🏼‍🦳", "👩🏽‍🦳", "👩🏾‍🦳", "👩🏿‍🦳"],
    "version": "11.0"
  }, {
    "emoji": "🧑‍🦳",
    "category": 1,
    "name": "adulte : cheveux blancs",
    "variations": ["🧑🏻‍🦳", "🧑🏼‍🦳", "🧑🏽‍🦳", "🧑🏾‍🦳", "🧑🏿‍🦳"],
    "version": "12.1"
  }, {
    "emoji": "👩‍🦲",
    "category": 1,
    "name": "femme : chauve",
    "variations": ["👩🏻‍🦲", "👩🏼‍🦲", "👩🏽‍🦲", "👩🏾‍🦲", "👩🏿‍🦲"],
    "version": "11.0"
  }, {
    "emoji": "🧑‍🦲",
    "category": 1,
    "name": "adulte : chauve",
    "variations": ["🧑🏻‍🦲", "🧑🏼‍🦲", "🧑🏽‍🦲", "🧑🏾‍🦲", "🧑🏿‍🦲"],
    "version": "12.1"
  }, {
    "emoji": "👱‍♀️",
    "category": 1,
    "name": "woman with blond hair",
    "variations": ["👱🏻‍♀️", "👱🏼‍♀️", "👱🏽‍♀️", "👱🏾‍♀️", "👱🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "👱‍♂️",
    "category": 1,
    "name": "man with blond hair",
    "variations": ["👱🏻‍♂️", "👱🏼‍♂️", "👱🏽‍♂️", "👱🏾‍♂️", "👱🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🧓",
    "category": 1,
    "name": "personne âgée",
    "variations": ["🧓🏻", "🧓🏼", "🧓🏽", "🧓🏾", "🧓🏿"],
    "version": "5.0"
  }, {
    "emoji": "👴",
    "category": 1,
    "name": "homme âgé",
    "variations": ["👴🏻", "👴🏼", "👴🏽", "👴🏾", "👴🏿"],
    "version": "1.0"
  }, {
    "emoji": "👵",
    "category": 1,
    "name": "femme âgée",
    "variations": ["👵🏻", "👵🏼", "👵🏽", "👵🏾", "👵🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙍",
    "category": 1,
    "name": "personne fronçant les sourcils",
    "variations": ["🙍🏻", "🙍🏼", "🙍🏽", "🙍🏾", "🙍🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙍‍♂️",
    "category": 1,
    "name": "man frowning",
    "variations": ["🙍🏻‍♂️", "🙍🏼‍♂️", "🙍🏽‍♂️", "🙍🏾‍♂️", "🙍🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙍‍♀️",
    "category": 1,
    "name": "woman frowning",
    "variations": ["🙍🏻‍♀️", "🙍🏼‍♀️", "🙍🏽‍♀️", "🙍🏾‍♀️", "🙍🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🙎",
    "category": 1,
    "name": "personne qui boude",
    "variations": ["🙎🏻", "🙎🏼", "🙎🏽", "🙎🏾", "🙎🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙎‍♂️",
    "category": 1,
    "name": "man pouting",
    "variations": ["🙎🏻‍♂️", "🙎🏼‍♂️", "🙎🏽‍♂️", "🙎🏾‍♂️", "🙎🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙎‍♀️",
    "category": 1,
    "name": "woman pouting",
    "variations": ["🙎🏻‍♀️", "🙎🏼‍♀️", "🙎🏽‍♀️", "🙎🏾‍♀️", "🙎🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🙅",
    "category": 1,
    "name": "personne faisant un geste d’interdiction",
    "variations": ["🙅🏻", "🙅🏼", "🙅🏽", "🙅🏾", "🙅🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙅‍♂️",
    "category": 1,
    "name": "man gesturing NO",
    "variations": ["🙅🏻‍♂️", "🙅🏼‍♂️", "🙅🏽‍♂️", "🙅🏾‍♂️", "🙅🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙅‍♀️",
    "category": 1,
    "name": "woman gesturing NO",
    "variations": ["🙅🏻‍♀️", "🙅🏼‍♀️", "🙅🏽‍♀️", "🙅🏾‍♀️", "🙅🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🙆",
    "category": 1,
    "name": "personne faisant un geste d’acceptation",
    "variations": ["🙆🏻", "🙆🏼", "🙆🏽", "🙆🏾", "🙆🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙆‍♂️",
    "category": 1,
    "name": "man gesturing OK",
    "variations": ["🙆🏻‍♂️", "🙆🏼‍♂️", "🙆🏽‍♂️", "🙆🏾‍♂️", "🙆🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙆‍♀️",
    "category": 1,
    "name": "woman gesturing OK",
    "variations": ["🙆🏻‍♀️", "🙆🏼‍♀️", "🙆🏽‍♀️", "🙆🏾‍♀️", "🙆🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "💁",
    "category": 1,
    "name": "personne paume vers le haut",
    "variations": ["💁🏻", "💁🏼", "💁🏽", "💁🏾", "💁🏿"],
    "version": "1.0"
  }, {
    "emoji": "💁‍♂️",
    "category": 1,
    "name": "man tipping hand",
    "variations": ["💁🏻‍♂️", "💁🏼‍♂️", "💁🏽‍♂️", "💁🏾‍♂️", "💁🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "💁‍♀️",
    "category": 1,
    "name": "woman tipping hand",
    "variations": ["💁🏻‍♀️", "💁🏼‍♀️", "💁🏽‍♀️", "💁🏾‍♀️", "💁🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🙋",
    "category": 1,
    "name": "personne qui lève la main",
    "variations": ["🙋🏻", "🙋🏼", "🙋🏽", "🙋🏾", "🙋🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙋‍♂️",
    "category": 1,
    "name": "man raising hand",
    "variations": ["🙋🏻‍♂️", "🙋🏼‍♂️", "🙋🏽‍♂️", "🙋🏾‍♂️", "🙋🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙋‍♀️",
    "category": 1,
    "name": "woman raising hand",
    "variations": ["🙋🏻‍♀️", "🙋🏼‍♀️", "🙋🏽‍♀️", "🙋🏾‍♀️", "🙋🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🧏",
    "category": 1,
    "name": "personne sourde",
    "variations": ["🧏🏻", "🧏🏼", "🧏🏽", "🧏🏾", "🧏🏿"],
    "version": "12.0"
  }, {
    "emoji": "🧏‍♂️",
    "category": 1,
    "name": "deaf man",
    "variations": ["🧏🏻‍♂️", "🧏🏼‍♂️", "🧏🏽‍♂️", "🧏🏾‍♂️", "🧏🏿‍♂️"],
    "version": "12.0"
  }, {
    "emoji": "🧏‍♀️",
    "category": 1,
    "name": "deaf woman",
    "variations": ["🧏🏻‍♀️", "🧏🏼‍♀️", "🧏🏽‍♀️", "🧏🏾‍♀️", "🧏🏿‍♀️"],
    "version": "12.0"
  }, {
    "emoji": "🙇",
    "category": 1,
    "name": "personne qui s’incline",
    "variations": ["🙇🏻", "🙇🏼", "🙇🏽", "🙇🏾", "🙇🏿"],
    "version": "1.0"
  }, {
    "emoji": "🙇‍♂️",
    "category": 1,
    "name": "man bowing",
    "variations": ["🙇🏻‍♂️", "🙇🏼‍♂️", "🙇🏽‍♂️", "🙇🏾‍♂️", "🙇🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🙇‍♀️",
    "category": 1,
    "name": "woman bowing",
    "variations": ["🙇🏻‍♀️", "🙇🏼‍♀️", "🙇🏽‍♀️", "🙇🏾‍♀️", "🙇🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤦",
    "category": 1,
    "name": "personne avec la paume sur le visage",
    "variations": ["🤦🏻", "🤦🏼", "🤦🏽", "🤦🏾", "🤦🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤦‍♂️",
    "category": 1,
    "name": "man facepalming",
    "variations": ["🤦🏻‍♂️", "🤦🏼‍♂️", "🤦🏽‍♂️", "🤦🏾‍♂️", "🤦🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤦‍♀️",
    "category": 1,
    "name": "woman facepalming",
    "variations": ["🤦🏻‍♀️", "🤦🏼‍♀️", "🤦🏽‍♀️", "🤦🏾‍♀️", "🤦🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤷",
    "category": 1,
    "name": "personne qui hausse les épaules",
    "variations": ["🤷🏻", "🤷🏼", "🤷🏽", "🤷🏾", "🤷🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤷‍♂️",
    "category": 1,
    "name": "man shrugging",
    "variations": ["🤷🏻‍♂️", "🤷🏼‍♂️", "🤷🏽‍♂️", "🤷🏾‍♂️", "🤷🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤷‍♀️",
    "category": 1,
    "name": "woman shrugging",
    "variations": ["🤷🏻‍♀️", "🤷🏼‍♀️", "🤷🏽‍♀️", "🤷🏾‍♀️", "🤷🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍⚕️",
    "category": 1,
    "name": "health worker",
    "variations": ["🧑🏻‍⚕️", "🧑🏼‍⚕️", "🧑🏽‍⚕️", "🧑🏾‍⚕️", "🧑🏿‍⚕️"],
    "version": "12.1"
  }, {
    "emoji": "👨‍⚕️",
    "category": 1,
    "name": "man health worker",
    "variations": ["👨🏻‍⚕️", "👨🏼‍⚕️", "👨🏽‍⚕️", "👨🏾‍⚕️", "👨🏿‍⚕️"],
    "version": "4.0"
  }, {
    "emoji": "👩‍⚕️",
    "category": 1,
    "name": "woman health worker",
    "variations": ["👩🏻‍⚕️", "👩🏼‍⚕️", "👩🏽‍⚕️", "👩🏾‍⚕️", "👩🏿‍⚕️"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🎓",
    "category": 1,
    "name": "étudiant (tous genres)",
    "variations": ["🧑🏻‍🎓", "🧑🏼‍🎓", "🧑🏽‍🎓", "🧑🏾‍🎓", "🧑🏿‍🎓"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🎓",
    "category": 1,
    "name": "étudiant",
    "variations": ["👨🏻‍🎓", "👨🏼‍🎓", "👨🏽‍🎓", "👨🏾‍🎓", "👨🏿‍🎓"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🎓",
    "category": 1,
    "name": "étudiante",
    "variations": ["👩🏻‍🎓", "👩🏼‍🎓", "👩🏽‍🎓", "👩🏾‍🎓", "👩🏿‍🎓"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🏫",
    "category": 1,
    "name": "personnel enseignant",
    "variations": ["🧑🏻‍🏫", "🧑🏼‍🏫", "🧑🏽‍🏫", "🧑🏾‍🏫", "🧑🏿‍🏫"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🏫",
    "category": 1,
    "name": "enseignant",
    "variations": ["👨🏻‍🏫", "👨🏼‍🏫", "👨🏽‍🏫", "👨🏾‍🏫", "👨🏿‍🏫"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🏫",
    "category": 1,
    "name": "enseignante",
    "variations": ["👩🏻‍🏫", "👩🏼‍🏫", "👩🏽‍🏫", "👩🏾‍🏫", "👩🏿‍🏫"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍⚖️",
    "category": 1,
    "name": "judge",
    "variations": ["🧑🏻‍⚖️", "🧑🏼‍⚖️", "🧑🏽‍⚖️", "🧑🏾‍⚖️", "🧑🏿‍⚖️"],
    "version": "12.1"
  }, {
    "emoji": "👨‍⚖️",
    "category": 1,
    "name": "man judge",
    "variations": ["👨🏻‍⚖️", "👨🏼‍⚖️", "👨🏽‍⚖️", "👨🏾‍⚖️", "👨🏿‍⚖️"],
    "version": "4.0"
  }, {
    "emoji": "👩‍⚖️",
    "category": 1,
    "name": "woman judge",
    "variations": ["👩🏻‍⚖️", "👩🏼‍⚖️", "👩🏽‍⚖️", "👩🏾‍⚖️", "👩🏿‍⚖️"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🌾",
    "category": 1,
    "name": "fermier (tous genres)",
    "variations": ["🧑🏻‍🌾", "🧑🏼‍🌾", "🧑🏽‍🌾", "🧑🏾‍🌾", "🧑🏿‍🌾"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🌾",
    "category": 1,
    "name": "fermier",
    "variations": ["👨🏻‍🌾", "👨🏼‍🌾", "👨🏽‍🌾", "👨🏾‍🌾", "👨🏿‍🌾"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🌾",
    "category": 1,
    "name": "fermière",
    "variations": ["👩🏻‍🌾", "👩🏼‍🌾", "👩🏽‍🌾", "👩🏾‍🌾", "👩🏿‍🌾"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🍳",
    "category": 1,
    "name": "cuisinier (tous genres)",
    "variations": ["🧑🏻‍🍳", "🧑🏼‍🍳", "🧑🏽‍🍳", "🧑🏾‍🍳", "🧑🏿‍🍳"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🍳",
    "category": 1,
    "name": "cuisinier",
    "variations": ["👨🏻‍🍳", "👨🏼‍🍳", "👨🏽‍🍳", "👨🏾‍🍳", "👨🏿‍🍳"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🍳",
    "category": 1,
    "name": "cuisinière",
    "variations": ["👩🏻‍🍳", "👩🏼‍🍳", "👩🏽‍🍳", "👩🏾‍🍳", "👩🏿‍🍳"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🔧",
    "category": 1,
    "name": "mécanicien (tous genres)",
    "variations": ["🧑🏻‍🔧", "🧑🏼‍🔧", "🧑🏽‍🔧", "🧑🏾‍🔧", "🧑🏿‍🔧"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🔧",
    "category": 1,
    "name": "mécanicien",
    "variations": ["👨🏻‍🔧", "👨🏼‍🔧", "👨🏽‍🔧", "👨🏾‍🔧", "👨🏿‍🔧"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🔧",
    "category": 1,
    "name": "mécanicienne",
    "variations": ["👩🏻‍🔧", "👩🏼‍🔧", "👩🏽‍🔧", "👩🏾‍🔧", "👩🏿‍🔧"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🏭",
    "category": 1,
    "name": "ouvrier (tous genres)",
    "variations": ["🧑🏻‍🏭", "🧑🏼‍🏭", "🧑🏽‍🏭", "🧑🏾‍🏭", "🧑🏿‍🏭"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🏭",
    "category": 1,
    "name": "ouvrier",
    "variations": ["👨🏻‍🏭", "👨🏼‍🏭", "👨🏽‍🏭", "👨🏾‍🏭", "👨🏿‍🏭"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🏭",
    "category": 1,
    "name": "ouvrière",
    "variations": ["👩🏻‍🏭", "👩🏼‍🏭", "👩🏽‍🏭", "👩🏾‍🏭", "👩🏿‍🏭"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍💼",
    "category": 1,
    "name": "employé de bureau (tous genres)",
    "variations": ["🧑🏻‍💼", "🧑🏼‍💼", "🧑🏽‍💼", "🧑🏾‍💼", "🧑🏿‍💼"],
    "version": "12.1"
  }, {
    "emoji": "👨‍💼",
    "category": 1,
    "name": "employé de bureau",
    "variations": ["👨🏻‍💼", "👨🏼‍💼", "👨🏽‍💼", "👨🏾‍💼", "👨🏿‍💼"],
    "version": "4.0"
  }, {
    "emoji": "👩‍💼",
    "category": 1,
    "name": "employée de bureau",
    "variations": ["👩🏻‍💼", "👩🏼‍💼", "👩🏽‍💼", "👩🏾‍💼", "👩🏿‍💼"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🔬",
    "category": 1,
    "name": "scientifique",
    "variations": ["🧑🏻‍🔬", "🧑🏼‍🔬", "🧑🏽‍🔬", "🧑🏾‍🔬", "🧑🏿‍🔬"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🔬",
    "category": 1,
    "name": "scientifique homme",
    "variations": ["👨🏻‍🔬", "👨🏼‍🔬", "👨🏽‍🔬", "👨🏾‍🔬", "👨🏿‍🔬"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🔬",
    "category": 1,
    "name": "scientifique femme",
    "variations": ["👩🏻‍🔬", "👩🏼‍🔬", "👩🏽‍🔬", "👩🏾‍🔬", "👩🏿‍🔬"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍💻",
    "category": 1,
    "name": "informaticien (tous genres)",
    "variations": ["🧑🏻‍💻", "🧑🏼‍💻", "🧑🏽‍💻", "🧑🏾‍💻", "🧑🏿‍💻"],
    "version": "12.1"
  }, {
    "emoji": "👨‍💻",
    "category": 1,
    "name": "informaticien",
    "variations": ["👨🏻‍💻", "👨🏼‍💻", "👨🏽‍💻", "👨🏾‍💻", "👨🏿‍💻"],
    "version": "4.0"
  }, {
    "emoji": "👩‍💻",
    "category": 1,
    "name": "informaticienne",
    "variations": ["👩🏻‍💻", "👩🏼‍💻", "👩🏽‍💻", "👩🏾‍💻", "👩🏿‍💻"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🎤",
    "category": 1,
    "name": "chanteur (tous genres)",
    "variations": ["🧑🏻‍🎤", "🧑🏼‍🎤", "🧑🏽‍🎤", "🧑🏾‍🎤", "🧑🏿‍🎤"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🎤",
    "category": 1,
    "name": "chanteur",
    "variations": ["👨🏻‍🎤", "👨🏼‍🎤", "👨🏽‍🎤", "👨🏾‍🎤", "👨🏿‍🎤"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🎤",
    "category": 1,
    "name": "chanteuse",
    "variations": ["👩🏻‍🎤", "👩🏼‍🎤", "👩🏽‍🎤", "👩🏾‍🎤", "👩🏿‍🎤"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🎨",
    "category": 1,
    "name": "artiste",
    "variations": ["🧑🏻‍🎨", "🧑🏼‍🎨", "🧑🏽‍🎨", "🧑🏾‍🎨", "🧑🏿‍🎨"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🎨",
    "category": 1,
    "name": "artiste homme",
    "variations": ["👨🏻‍🎨", "👨🏼‍🎨", "👨🏽‍🎨", "👨🏾‍🎨", "👨🏿‍🎨"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🎨",
    "category": 1,
    "name": "artiste femme",
    "variations": ["👩🏻‍🎨", "👩🏼‍🎨", "👩🏽‍🎨", "👩🏾‍🎨", "👩🏿‍🎨"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍✈️",
    "category": 1,
    "name": "pilot",
    "variations": ["🧑🏻‍✈️", "🧑🏼‍✈️", "🧑🏽‍✈️", "🧑🏾‍✈️", "🧑🏿‍✈️"],
    "version": "12.1"
  }, {
    "emoji": "👨‍✈️",
    "category": 1,
    "name": "man pilot",
    "variations": ["👨🏻‍✈️", "👨🏼‍✈️", "👨🏽‍✈️", "👨🏾‍✈️", "👨🏿‍✈️"],
    "version": "4.0"
  }, {
    "emoji": "👩‍✈️",
    "category": 1,
    "name": "woman pilot",
    "variations": ["👩🏻‍✈️", "👩🏼‍✈️", "👩🏽‍✈️", "👩🏾‍✈️", "👩🏿‍✈️"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🚀",
    "category": 1,
    "name": "astronaute",
    "variations": ["🧑🏻‍🚀", "🧑🏼‍🚀", "🧑🏽‍🚀", "🧑🏾‍🚀", "🧑🏿‍🚀"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🚀",
    "category": 1,
    "name": "astronaute homme",
    "variations": ["👨🏻‍🚀", "👨🏼‍🚀", "👨🏽‍🚀", "👨🏾‍🚀", "👨🏿‍🚀"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🚀",
    "category": 1,
    "name": "astronaute femme",
    "variations": ["👩🏻‍🚀", "👩🏼‍🚀", "👩🏽‍🚀", "👩🏾‍🚀", "👩🏿‍🚀"],
    "version": "4.0"
  }, {
    "emoji": "🧑‍🚒",
    "category": 1,
    "name": "pompier",
    "variations": ["🧑🏻‍🚒", "🧑🏼‍🚒", "🧑🏽‍🚒", "🧑🏾‍🚒", "🧑🏿‍🚒"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🚒",
    "category": 1,
    "name": "pompier homme",
    "variations": ["👨🏻‍🚒", "👨🏼‍🚒", "👨🏽‍🚒", "👨🏾‍🚒", "👨🏿‍🚒"],
    "version": "4.0"
  }, {
    "emoji": "👩‍🚒",
    "category": 1,
    "name": "pompier femme",
    "variations": ["👩🏻‍🚒", "👩🏼‍🚒", "👩🏽‍🚒", "👩🏾‍🚒", "👩🏿‍🚒"],
    "version": "4.0"
  }, {
    "emoji": "👮",
    "category": 1,
    "name": "officier de police",
    "variations": ["👮🏻", "👮🏼", "👮🏽", "👮🏾", "👮🏿"],
    "version": "1.0"
  }, {
    "emoji": "👮‍♂️",
    "category": 1,
    "name": "man police officer",
    "variations": ["👮🏻‍♂️", "👮🏼‍♂️", "👮🏽‍♂️", "👮🏾‍♂️", "👮🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "👮‍♀️",
    "category": 1,
    "name": "woman police officer",
    "variations": ["👮🏻‍♀️", "👮🏼‍♀️", "👮🏽‍♀️", "👮🏾‍♀️", "👮🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🕵️",
    "category": 1,
    "name": "detective",
    "variations": ["🕵🏻", "🕵🏼", "🕵🏽", "🕵🏾", "🕵🏿"],
    "version": "1.0"
  }, {
    "emoji": "🕵️‍♂️",
    "category": 1,
    "name": "man detective",
    "variations": ["🕵🏻‍♂️", "🕵🏼‍♂️", "🕵🏽‍♂️", "🕵🏾‍♂️", "🕵🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🕵️‍♀️",
    "category": 1,
    "name": "woman detective",
    "variations": ["🕵🏻‍♀️", "🕵🏼‍♀️", "🕵🏽‍♀️", "🕵🏾‍♀️", "🕵🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "💂",
    "category": 1,
    "name": "garde",
    "variations": ["💂🏻", "💂🏼", "💂🏽", "💂🏾", "💂🏿"],
    "version": "1.0"
  }, {
    "emoji": "💂‍♂️",
    "category": 1,
    "name": "man guard",
    "variations": ["💂🏻‍♂️", "💂🏼‍♂️", "💂🏽‍♂️", "💂🏾‍♂️", "💂🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "💂‍♀️",
    "category": 1,
    "name": "woman guard",
    "variations": ["💂🏻‍♀️", "💂🏼‍♀️", "💂🏽‍♀️", "💂🏾‍♀️", "💂🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🥷",
    "category": 1,
    "name": "ninja",
    "variations": ["🥷🏻", "🥷🏼", "🥷🏽", "🥷🏾", "🥷🏿"],
    "version": "13.0"
  }, {
    "emoji": "👷",
    "category": 1,
    "name": "personnel du bâtiment",
    "variations": ["👷🏻", "👷🏼", "👷🏽", "👷🏾", "👷🏿"],
    "version": "1.0"
  }, {
    "emoji": "👷‍♂️",
    "category": 1,
    "name": "man construction worker",
    "variations": ["👷🏻‍♂️", "👷🏼‍♂️", "👷🏽‍♂️", "👷🏾‍♂️", "👷🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "👷‍♀️",
    "category": 1,
    "name": "woman construction worker",
    "variations": ["👷🏻‍♀️", "👷🏼‍♀️", "👷🏽‍♀️", "👷🏾‍♀️", "👷🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤴",
    "category": 1,
    "name": "prince",
    "variations": ["🤴🏻", "🤴🏼", "🤴🏽", "🤴🏾", "🤴🏿"],
    "version": "3.0"
  }, {
    "emoji": "👸",
    "category": 1,
    "name": "princesse",
    "variations": ["👸🏻", "👸🏼", "👸🏽", "👸🏾", "👸🏿"],
    "version": "1.0"
  }, {
    "emoji": "👳",
    "category": 1,
    "name": "personne en turban",
    "variations": ["👳🏻", "👳🏼", "👳🏽", "👳🏾", "👳🏿"],
    "version": "1.0"
  }, {
    "emoji": "👳‍♂️",
    "category": 1,
    "name": "man wearing turban",
    "variations": ["👳🏻‍♂️", "👳🏼‍♂️", "👳🏽‍♂️", "👳🏾‍♂️", "👳🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "👳‍♀️",
    "category": 1,
    "name": "woman wearing turban",
    "variations": ["👳🏻‍♀️", "👳🏼‍♀️", "👳🏽‍♀️", "👳🏾‍♀️", "👳🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "👲",
    "category": 1,
    "name": "homme avec casquette chinoise",
    "variations": ["👲🏻", "👲🏼", "👲🏽", "👲🏾", "👲🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧕",
    "category": 1,
    "name": "femme avec foulard",
    "variations": ["🧕🏻", "🧕🏼", "🧕🏽", "🧕🏾", "🧕🏿"],
    "version": "5.0"
  }, {
    "emoji": "🤵",
    "category": 1,
    "name": "personne en smoking",
    "variations": ["🤵🏻", "🤵🏼", "🤵🏽", "🤵🏾", "🤵🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤵‍♂️",
    "category": 1,
    "name": "man in tuxedo",
    "variations": ["🤵🏻‍♂️", "🤵🏼‍♂️", "🤵🏽‍♂️", "🤵🏾‍♂️", "🤵🏿‍♂️"],
    "version": "13.0"
  }, {
    "emoji": "🤵‍♀️",
    "category": 1,
    "name": "woman in tuxedo",
    "variations": ["🤵🏻‍♀️", "🤵🏼‍♀️", "🤵🏽‍♀️", "🤵🏾‍♀️", "🤵🏿‍♀️"],
    "version": "13.0"
  }, {
    "emoji": "👰",
    "category": 1,
    "name": "personne mariée avec voile",
    "variations": ["👰🏻", "👰🏼", "👰🏽", "👰🏾", "👰🏿"],
    "version": "1.0"
  }, {
    "emoji": "👰‍♂️",
    "category": 1,
    "name": "man with veil",
    "variations": ["👰🏻‍♂️", "👰🏼‍♂️", "👰🏽‍♂️", "👰🏾‍♂️", "👰🏿‍♂️"],
    "version": "13.0"
  }, {
    "emoji": "👰‍♀️",
    "category": 1,
    "name": "woman with veil",
    "variations": ["👰🏻‍♀️", "👰🏼‍♀️", "👰🏽‍♀️", "👰🏾‍♀️", "👰🏿‍♀️"],
    "version": "13.0"
  }, {
    "emoji": "🤰",
    "category": 1,
    "name": "femme enceinte",
    "variations": ["🤰🏻", "🤰🏼", "🤰🏽", "🤰🏾", "🤰🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤱",
    "category": 1,
    "name": "allaitement",
    "variations": ["🤱🏻", "🤱🏼", "🤱🏽", "🤱🏾", "🤱🏿"],
    "version": "5.0"
  }, {
    "emoji": "👩‍🍼",
    "category": 1,
    "name": "femme allaitant un bébé",
    "variations": ["👩🏻‍🍼", "👩🏼‍🍼", "👩🏽‍🍼", "👩🏾‍🍼", "👩🏿‍🍼"],
    "version": "13.0"
  }, {
    "emoji": "👨‍🍼",
    "category": 1,
    "name": "homme allaitant un bébé",
    "variations": ["👨🏻‍🍼", "👨🏼‍🍼", "👨🏽‍🍼", "👨🏾‍🍼", "👨🏿‍🍼"],
    "version": "13.0"
  }, {
    "emoji": "🧑‍🍼",
    "category": 1,
    "name": "personne allaitant un bébé",
    "variations": ["🧑🏻‍🍼", "🧑🏼‍🍼", "🧑🏽‍🍼", "🧑🏾‍🍼", "🧑🏿‍🍼"],
    "version": "13.0"
  }, {
    "emoji": "👼",
    "category": 1,
    "name": "bébé ange",
    "variations": ["👼🏻", "👼🏼", "👼🏽", "👼🏾", "👼🏿"],
    "version": "1.0"
  }, {
    "emoji": "🎅",
    "category": 1,
    "name": "père Noël",
    "variations": ["🎅🏻", "🎅🏼", "🎅🏽", "🎅🏾", "🎅🏿"],
    "version": "1.0"
  }, {
    "emoji": "🤶",
    "category": 1,
    "name": "mère Noël",
    "variations": ["🤶🏻", "🤶🏼", "🤶🏽", "🤶🏾", "🤶🏿"],
    "version": "3.0"
  }, {
    "emoji": "🧑‍🎄",
    "category": 1,
    "name": "santa",
    "variations": ["🧑🏻‍🎄", "🧑🏼‍🎄", "🧑🏽‍🎄", "🧑🏾‍🎄", "🧑🏿‍🎄"],
    "version": "13.0"
  }, {
    "emoji": "🦸",
    "category": 1,
    "name": "super-héros",
    "variations": ["🦸🏻", "🦸🏼", "🦸🏽", "🦸🏾", "🦸🏿"],
    "version": "11.0"
  }, {
    "emoji": "🦸‍♂️",
    "category": 1,
    "name": "man superhero",
    "variations": ["🦸🏻‍♂️", "🦸🏼‍♂️", "🦸🏽‍♂️", "🦸🏾‍♂️", "🦸🏿‍♂️"],
    "version": "11.0"
  }, {
    "emoji": "🦸‍♀️",
    "category": 1,
    "name": "woman superhero",
    "variations": ["🦸🏻‍♀️", "🦸🏼‍♀️", "🦸🏽‍♀️", "🦸🏾‍♀️", "🦸🏿‍♀️"],
    "version": "11.0"
  }, {
    "emoji": "🦹",
    "category": 1,
    "name": "super-vilain",
    "variations": ["🦹🏻", "🦹🏼", "🦹🏽", "🦹🏾", "🦹🏿"],
    "version": "11.0"
  }, {
    "emoji": "🦹‍♂️",
    "category": 1,
    "name": "man supervillain",
    "variations": ["🦹🏻‍♂️", "🦹🏼‍♂️", "🦹🏽‍♂️", "🦹🏾‍♂️", "🦹🏿‍♂️"],
    "version": "11.0"
  }, {
    "emoji": "🦹‍♀️",
    "category": 1,
    "name": "woman supervillain",
    "variations": ["🦹🏻‍♀️", "🦹🏼‍♀️", "🦹🏽‍♀️", "🦹🏾‍♀️", "🦹🏿‍♀️"],
    "version": "11.0"
  }, {
    "emoji": "🧙",
    "category": 1,
    "name": "mage",
    "variations": ["🧙🏻", "🧙🏼", "🧙🏽", "🧙🏾", "🧙🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧙‍♂️",
    "category": 1,
    "name": "man mage",
    "variations": ["🧙🏻‍♂️", "🧙🏼‍♂️", "🧙🏽‍♂️", "🧙🏾‍♂️", "🧙🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧙‍♀️",
    "category": 1,
    "name": "woman mage",
    "variations": ["🧙🏻‍♀️", "🧙🏼‍♀️", "🧙🏽‍♀️", "🧙🏾‍♀️", "🧙🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧚",
    "category": 1,
    "name": "personnage féérique",
    "variations": ["🧚🏻", "🧚🏼", "🧚🏽", "🧚🏾", "🧚🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧚‍♂️",
    "category": 1,
    "name": "man fairy",
    "variations": ["🧚🏻‍♂️", "🧚🏼‍♂️", "🧚🏽‍♂️", "🧚🏾‍♂️", "🧚🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧚‍♀️",
    "category": 1,
    "name": "woman fairy",
    "variations": ["🧚🏻‍♀️", "🧚🏼‍♀️", "🧚🏽‍♀️", "🧚🏾‍♀️", "🧚🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧛",
    "category": 1,
    "name": "vampire",
    "variations": ["🧛🏻", "🧛🏼", "🧛🏽", "🧛🏾", "🧛🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧛‍♂️",
    "category": 1,
    "name": "man vampire",
    "variations": ["🧛🏻‍♂️", "🧛🏼‍♂️", "🧛🏽‍♂️", "🧛🏾‍♂️", "🧛🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧛‍♀️",
    "category": 1,
    "name": "woman vampire",
    "variations": ["🧛🏻‍♀️", "🧛🏼‍♀️", "🧛🏽‍♀️", "🧛🏾‍♀️", "🧛🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧜",
    "category": 1,
    "name": "créature aquatique",
    "variations": ["🧜🏻", "🧜🏼", "🧜🏽", "🧜🏾", "🧜🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧜‍♂️",
    "category": 1,
    "name": "merman",
    "variations": ["🧜🏻‍♂️", "🧜🏼‍♂️", "🧜🏽‍♂️", "🧜🏾‍♂️", "🧜🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧜‍♀️",
    "category": 1,
    "name": "mermaid",
    "variations": ["🧜🏻‍♀️", "🧜🏼‍♀️", "🧜🏽‍♀️", "🧜🏾‍♀️", "🧜🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧝",
    "category": 1,
    "name": "elfe",
    "variations": ["🧝🏻", "🧝🏼", "🧝🏽", "🧝🏾", "🧝🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧝‍♂️",
    "category": 1,
    "name": "man elf",
    "variations": ["🧝🏻‍♂️", "🧝🏼‍♂️", "🧝🏽‍♂️", "🧝🏾‍♂️", "🧝🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧝‍♀️",
    "category": 1,
    "name": "woman elf",
    "variations": ["🧝🏻‍♀️", "🧝🏼‍♀️", "🧝🏽‍♀️", "🧝🏾‍♀️", "🧝🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧞",
    "category": 1,
    "name": "génie",
    "version": "5.0"
  }, {
    "emoji": "🧞‍♂️",
    "category": 1,
    "name": "man genie",
    "version": "5.0"
  }, {
    "emoji": "🧞‍♀️",
    "category": 1,
    "name": "woman genie",
    "version": "5.0"
  }, {
    "emoji": "🧟",
    "category": 1,
    "name": "zombie",
    "version": "5.0"
  }, {
    "emoji": "🧟‍♂️",
    "category": 1,
    "name": "man zombie",
    "version": "5.0"
  }, {
    "emoji": "🧟‍♀️",
    "category": 1,
    "name": "woman zombie",
    "version": "5.0"
  }, {
    "emoji": "💆",
    "category": 1,
    "name": "personne qui se fait masser",
    "variations": ["💆🏻", "💆🏼", "💆🏽", "💆🏾", "💆🏿"],
    "version": "1.0"
  }, {
    "emoji": "💆‍♂️",
    "category": 1,
    "name": "man getting massage",
    "variations": ["💆🏻‍♂️", "💆🏼‍♂️", "💆🏽‍♂️", "💆🏾‍♂️", "💆🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "💆‍♀️",
    "category": 1,
    "name": "woman getting massage",
    "variations": ["💆🏻‍♀️", "💆🏼‍♀️", "💆🏽‍♀️", "💆🏾‍♀️", "💆🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "💇",
    "category": 1,
    "name": "personne qui se fait couper les cheveux",
    "variations": ["💇🏻", "💇🏼", "💇🏽", "💇🏾", "💇🏿"],
    "version": "1.0"
  }, {
    "emoji": "💇‍♂️",
    "category": 1,
    "name": "man getting haircut",
    "variations": ["💇🏻‍♂️", "💇🏼‍♂️", "💇🏽‍♂️", "💇🏾‍♂️", "💇🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "💇‍♀️",
    "category": 1,
    "name": "woman getting haircut",
    "variations": ["💇🏻‍♀️", "💇🏼‍♀️", "💇🏽‍♀️", "💇🏾‍♀️", "💇🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🚶",
    "category": 1,
    "name": "personne qui marche",
    "variations": ["🚶🏻", "🚶🏼", "🚶🏽", "🚶🏾", "🚶🏿"],
    "version": "1.0"
  }, {
    "emoji": "🚶‍♂️",
    "category": 1,
    "name": "man walking",
    "variations": ["🚶🏻‍♂️", "🚶🏼‍♂️", "🚶🏽‍♂️", "🚶🏾‍♂️", "🚶🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🚶‍♀️",
    "category": 1,
    "name": "woman walking",
    "variations": ["🚶🏻‍♀️", "🚶🏼‍♀️", "🚶🏽‍♀️", "🚶🏾‍♀️", "🚶🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🧍",
    "category": 1,
    "name": "personne debout",
    "variations": ["🧍🏻", "🧍🏼", "🧍🏽", "🧍🏾", "🧍🏿"],
    "version": "12.0"
  }, {
    "emoji": "🧍‍♂️",
    "category": 1,
    "name": "man standing",
    "variations": ["🧍🏻‍♂️", "🧍🏼‍♂️", "🧍🏽‍♂️", "🧍🏾‍♂️", "🧍🏿‍♂️"],
    "version": "12.0"
  }, {
    "emoji": "🧍‍♀️",
    "category": 1,
    "name": "woman standing",
    "variations": ["🧍🏻‍♀️", "🧍🏼‍♀️", "🧍🏽‍♀️", "🧍🏾‍♀️", "🧍🏿‍♀️"],
    "version": "12.0"
  }, {
    "emoji": "🧎",
    "category": 1,
    "name": "personne à genoux",
    "variations": ["🧎🏻", "🧎🏼", "🧎🏽", "🧎🏾", "🧎🏿"],
    "version": "12.0"
  }, {
    "emoji": "🧎‍♂️",
    "category": 1,
    "name": "man kneeling",
    "variations": ["🧎🏻‍♂️", "🧎🏼‍♂️", "🧎🏽‍♂️", "🧎🏾‍♂️", "🧎🏿‍♂️"],
    "version": "12.0"
  }, {
    "emoji": "🧎‍♀️",
    "category": 1,
    "name": "woman kneeling",
    "variations": ["🧎🏻‍♀️", "🧎🏼‍♀️", "🧎🏽‍♀️", "🧎🏾‍♀️", "🧎🏿‍♀️"],
    "version": "12.0"
  }, {
    "emoji": "🧑‍🦯",
    "category": 1,
    "name": "personne avec une canne blanche",
    "variations": ["🧑🏻‍🦯", "🧑🏼‍🦯", "🧑🏽‍🦯", "🧑🏾‍🦯", "🧑🏿‍🦯"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🦯",
    "category": 1,
    "name": "homme avec canne blanche",
    "variations": ["👨🏻‍🦯", "👨🏼‍🦯", "👨🏽‍🦯", "👨🏾‍🦯", "👨🏿‍🦯"],
    "version": "12.0"
  }, {
    "emoji": "👩‍🦯",
    "category": 1,
    "name": "femme avec canne blanche",
    "variations": ["👩🏻‍🦯", "👩🏼‍🦯", "👩🏽‍🦯", "👩🏾‍🦯", "👩🏿‍🦯"],
    "version": "12.0"
  }, {
    "emoji": "🧑‍🦼",
    "category": 1,
    "name": "personne en fauteuil motorisé",
    "variations": ["🧑🏻‍🦼", "🧑🏼‍🦼", "🧑🏽‍🦼", "🧑🏾‍🦼", "🧑🏿‍🦼"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🦼",
    "category": 1,
    "name": "homme en fauteuil motorisé",
    "variations": ["👨🏻‍🦼", "👨🏼‍🦼", "👨🏽‍🦼", "👨🏾‍🦼", "👨🏿‍🦼"],
    "version": "12.0"
  }, {
    "emoji": "👩‍🦼",
    "category": 1,
    "name": "femme en fauteuil motorisé",
    "variations": ["👩🏻‍🦼", "👩🏼‍🦼", "👩🏽‍🦼", "👩🏾‍🦼", "👩🏿‍🦼"],
    "version": "12.0"
  }, {
    "emoji": "🧑‍🦽",
    "category": 1,
    "name": "personne en fauteuil roulant manuel",
    "variations": ["🧑🏻‍🦽", "🧑🏼‍🦽", "🧑🏽‍🦽", "🧑🏾‍🦽", "🧑🏿‍🦽"],
    "version": "12.1"
  }, {
    "emoji": "👨‍🦽",
    "category": 1,
    "name": "homme en fauteuil roulant manuel",
    "variations": ["👨🏻‍🦽", "👨🏼‍🦽", "👨🏽‍🦽", "👨🏾‍🦽", "👨🏿‍🦽"],
    "version": "12.0"
  }, {
    "emoji": "👩‍🦽",
    "category": 1,
    "name": "femme en fauteuil roulant manuel",
    "variations": ["👩🏻‍🦽", "👩🏼‍🦽", "👩🏽‍🦽", "👩🏾‍🦽", "👩🏿‍🦽"],
    "version": "12.0"
  }, {
    "emoji": "🏃",
    "category": 1,
    "name": "personne qui court",
    "variations": ["🏃🏻", "🏃🏼", "🏃🏽", "🏃🏾", "🏃🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏃‍♂️",
    "category": 1,
    "name": "man running",
    "variations": ["🏃🏻‍♂️", "🏃🏼‍♂️", "🏃🏽‍♂️", "🏃🏾‍♂️", "🏃🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🏃‍♀️",
    "category": 1,
    "name": "woman running",
    "variations": ["🏃🏻‍♀️", "🏃🏼‍♀️", "🏃🏽‍♀️", "🏃🏾‍♀️", "🏃🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "💃",
    "category": 1,
    "name": "danseuse",
    "variations": ["💃🏻", "💃🏼", "💃🏽", "💃🏾", "💃🏿"],
    "version": "1.0"
  }, {
    "emoji": "🕺",
    "category": 1,
    "name": "danseur",
    "variations": ["🕺🏻", "🕺🏼", "🕺🏽", "🕺🏾", "🕺🏿"],
    "version": "3.0"
  }, {
    "emoji": "🕴️",
    "category": 1,
    "name": "person in suit levitating",
    "variations": ["🕴🏻", "🕴🏼", "🕴🏽", "🕴🏾", "🕴🏿"],
    "version": "1.0"
  }, {
    "emoji": "👯",
    "category": 1,
    "name": "personnes avec des oreilles de lapin",
    "version": "1.0"
  }, {
    "emoji": "👯‍♂️",
    "category": 1,
    "name": "men with bunny ears",
    "version": "4.0"
  }, {
    "emoji": "👯‍♀️",
    "category": 1,
    "name": "women with bunny ears",
    "version": "4.0"
  }, {
    "emoji": "🧖",
    "category": 1,
    "name": "personne au hammam",
    "variations": ["🧖🏻", "🧖🏼", "🧖🏽", "🧖🏾", "🧖🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧖‍♂️",
    "category": 1,
    "name": "man in steamy room",
    "variations": ["🧖🏻‍♂️", "🧖🏼‍♂️", "🧖🏽‍♂️", "🧖🏾‍♂️", "🧖🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧖‍♀️",
    "category": 1,
    "name": "woman in steamy room",
    "variations": ["🧖🏻‍♀️", "🧖🏼‍♀️", "🧖🏽‍♀️", "🧖🏾‍♀️", "🧖🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🧗",
    "category": 1,
    "name": "personne qui grimpe",
    "variations": ["🧗🏻", "🧗🏼", "🧗🏽", "🧗🏾", "🧗🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧗‍♂️",
    "category": 1,
    "name": "man climbing",
    "variations": ["🧗🏻‍♂️", "🧗🏼‍♂️", "🧗🏽‍♂️", "🧗🏾‍♂️", "🧗🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧗‍♀️",
    "category": 1,
    "name": "woman climbing",
    "variations": ["🧗🏻‍♀️", "🧗🏼‍♀️", "🧗🏽‍♀️", "🧗🏾‍♀️", "🧗🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🤺",
    "category": 1,
    "name": "escrimeur",
    "version": "3.0"
  }, {
    "emoji": "🏇",
    "category": 1,
    "name": "course hippique",
    "variations": ["🏇🏻", "🏇🏼", "🏇🏽", "🏇🏾", "🏇🏿"],
    "version": "1.0"
  }, {
    "emoji": "⛷️",
    "category": 1,
    "name": "skier",
    "version": "1.0"
  }, {
    "emoji": "🏂",
    "category": 1,
    "name": "snowboardeur",
    "variations": ["🏂🏻", "🏂🏼", "🏂🏽", "🏂🏾", "🏂🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏌️",
    "category": 1,
    "name": "person golfing",
    "variations": ["🏌🏻", "🏌🏼", "🏌🏽", "🏌🏾", "🏌🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏌️‍♂️",
    "category": 1,
    "name": "man golfing",
    "variations": ["🏌🏻‍♂️", "🏌🏼‍♂️", "🏌🏽‍♂️", "🏌🏾‍♂️", "🏌🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🏌️‍♀️",
    "category": 1,
    "name": "woman golfing",
    "variations": ["🏌🏻‍♀️", "🏌🏼‍♀️", "🏌🏽‍♀️", "🏌🏾‍♀️", "🏌🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🏄",
    "category": 1,
    "name": "personne faisant du surf",
    "variations": ["🏄🏻", "🏄🏼", "🏄🏽", "🏄🏾", "🏄🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏄‍♂️",
    "category": 1,
    "name": "man surfing",
    "variations": ["🏄🏻‍♂️", "🏄🏼‍♂️", "🏄🏽‍♂️", "🏄🏾‍♂️", "🏄🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🏄‍♀️",
    "category": 1,
    "name": "woman surfing",
    "variations": ["🏄🏻‍♀️", "🏄🏼‍♀️", "🏄🏽‍♀️", "🏄🏾‍♀️", "🏄🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🚣",
    "category": 1,
    "name": "personne ramant dans une barque",
    "variations": ["🚣🏻", "🚣🏼", "🚣🏽", "🚣🏾", "🚣🏿"],
    "version": "1.0"
  }, {
    "emoji": "🚣‍♂️",
    "category": 1,
    "name": "man rowing boat",
    "variations": ["🚣🏻‍♂️", "🚣🏼‍♂️", "🚣🏽‍♂️", "🚣🏾‍♂️", "🚣🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🚣‍♀️",
    "category": 1,
    "name": "woman rowing boat",
    "variations": ["🚣🏻‍♀️", "🚣🏼‍♀️", "🚣🏽‍♀️", "🚣🏾‍♀️", "🚣🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🏊",
    "category": 1,
    "name": "personne nageant",
    "variations": ["🏊🏻", "🏊🏼", "🏊🏽", "🏊🏾", "🏊🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏊‍♂️",
    "category": 1,
    "name": "man swimming",
    "variations": ["🏊🏻‍♂️", "🏊🏼‍♂️", "🏊🏽‍♂️", "🏊🏾‍♂️", "🏊🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🏊‍♀️",
    "category": 1,
    "name": "woman swimming",
    "variations": ["🏊🏻‍♀️", "🏊🏼‍♀️", "🏊🏽‍♀️", "🏊🏾‍♀️", "🏊🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "⛹️",
    "category": 1,
    "name": "person bouncing ball",
    "variations": ["⛹🏻", "⛹🏼", "⛹🏽", "⛹🏾", "⛹🏿"],
    "version": "1.0"
  }, {
    "emoji": "⛹️‍♂️",
    "category": 1,
    "name": "man bouncing ball",
    "variations": ["⛹🏻‍♂️", "⛹🏼‍♂️", "⛹🏽‍♂️", "⛹🏾‍♂️", "⛹🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "⛹️‍♀️",
    "category": 1,
    "name": "woman bouncing ball",
    "variations": ["⛹🏻‍♀️", "⛹🏼‍♀️", "⛹🏽‍♀️", "⛹🏾‍♀️", "⛹🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🏋️",
    "category": 1,
    "name": "person lifting weights",
    "variations": ["🏋🏻", "🏋🏼", "🏋🏽", "🏋🏾", "🏋🏿"],
    "version": "1.0"
  }, {
    "emoji": "🏋️‍♂️",
    "category": 1,
    "name": "man lifting weights",
    "variations": ["🏋🏻‍♂️", "🏋🏼‍♂️", "🏋🏽‍♂️", "🏋🏾‍♂️", "🏋🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🏋️‍♀️",
    "category": 1,
    "name": "woman lifting weights",
    "variations": ["🏋🏻‍♀️", "🏋🏼‍♀️", "🏋🏽‍♀️", "🏋🏾‍♀️", "🏋🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🚴",
    "category": 1,
    "name": "cycliste",
    "variations": ["🚴🏻", "🚴🏼", "🚴🏽", "🚴🏾", "🚴🏿"],
    "version": "1.0"
  }, {
    "emoji": "🚴‍♂️",
    "category": 1,
    "name": "man biking",
    "variations": ["🚴🏻‍♂️", "🚴🏼‍♂️", "🚴🏽‍♂️", "🚴🏾‍♂️", "🚴🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🚴‍♀️",
    "category": 1,
    "name": "woman biking",
    "variations": ["🚴🏻‍♀️", "🚴🏼‍♀️", "🚴🏽‍♀️", "🚴🏾‍♀️", "🚴🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🚵",
    "category": 1,
    "name": "personne en VTT",
    "variations": ["🚵🏻", "🚵🏼", "🚵🏽", "🚵🏾", "🚵🏿"],
    "version": "1.0"
  }, {
    "emoji": "🚵‍♂️",
    "category": 1,
    "name": "man mountain biking",
    "variations": ["🚵🏻‍♂️", "🚵🏼‍♂️", "🚵🏽‍♂️", "🚵🏾‍♂️", "🚵🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🚵‍♀️",
    "category": 1,
    "name": "woman mountain biking",
    "variations": ["🚵🏻‍♀️", "🚵🏼‍♀️", "🚵🏽‍♀️", "🚵🏾‍♀️", "🚵🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤸",
    "category": 1,
    "name": "personne faisant la roue",
    "variations": ["🤸🏻", "🤸🏼", "🤸🏽", "🤸🏾", "🤸🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤸‍♂️",
    "category": 1,
    "name": "man cartwheeling",
    "variations": ["🤸🏻‍♂️", "🤸🏼‍♂️", "🤸🏽‍♂️", "🤸🏾‍♂️", "🤸🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤸‍♀️",
    "category": 1,
    "name": "woman cartwheeling",
    "variations": ["🤸🏻‍♀️", "🤸🏼‍♀️", "🤸🏽‍♀️", "🤸🏾‍♀️", "🤸🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤼",
    "category": 1,
    "name": "personnes faisant de la lutte",
    "version": "3.0"
  }, {
    "emoji": "🤼‍♂️",
    "category": 1,
    "name": "men wrestling",
    "version": "4.0"
  }, {
    "emoji": "🤼‍♀️",
    "category": 1,
    "name": "women wrestling",
    "version": "4.0"
  }, {
    "emoji": "🤽",
    "category": 1,
    "name": "personne jouant au water-polo",
    "variations": ["🤽🏻", "🤽🏼", "🤽🏽", "🤽🏾", "🤽🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤽‍♂️",
    "category": 1,
    "name": "man playing water polo",
    "variations": ["🤽🏻‍♂️", "🤽🏼‍♂️", "🤽🏽‍♂️", "🤽🏾‍♂️", "🤽🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤽‍♀️",
    "category": 1,
    "name": "woman playing water polo",
    "variations": ["🤽🏻‍♀️", "🤽🏼‍♀️", "🤽🏽‍♀️", "🤽🏾‍♀️", "🤽🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤾",
    "category": 1,
    "name": "personne jouant au handball",
    "variations": ["🤾🏻", "🤾🏼", "🤾🏽", "🤾🏾", "🤾🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤾‍♂️",
    "category": 1,
    "name": "man playing handball",
    "variations": ["🤾🏻‍♂️", "🤾🏼‍♂️", "🤾🏽‍♂️", "🤾🏾‍♂️", "🤾🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤾‍♀️",
    "category": 1,
    "name": "woman playing handball",
    "variations": ["🤾🏻‍♀️", "🤾🏼‍♀️", "🤾🏽‍♀️", "🤾🏾‍♀️", "🤾🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🤹",
    "category": 1,
    "name": "personne qui jongle",
    "variations": ["🤹🏻", "🤹🏼", "🤹🏽", "🤹🏾", "🤹🏿"],
    "version": "3.0"
  }, {
    "emoji": "🤹‍♂️",
    "category": 1,
    "name": "man juggling",
    "variations": ["🤹🏻‍♂️", "🤹🏼‍♂️", "🤹🏽‍♂️", "🤹🏾‍♂️", "🤹🏿‍♂️"],
    "version": "4.0"
  }, {
    "emoji": "🤹‍♀️",
    "category": 1,
    "name": "woman juggling",
    "variations": ["🤹🏻‍♀️", "🤹🏼‍♀️", "🤹🏽‍♀️", "🤹🏾‍♀️", "🤹🏿‍♀️"],
    "version": "4.0"
  }, {
    "emoji": "🧘",
    "category": 1,
    "name": "personne dans la posture du lotus",
    "variations": ["🧘🏻", "🧘🏼", "🧘🏽", "🧘🏾", "🧘🏿"],
    "version": "5.0"
  }, {
    "emoji": "🧘‍♂️",
    "category": 1,
    "name": "man in lotus position",
    "variations": ["🧘🏻‍♂️", "🧘🏼‍♂️", "🧘🏽‍♂️", "🧘🏾‍♂️", "🧘🏿‍♂️"],
    "version": "5.0"
  }, {
    "emoji": "🧘‍♀️",
    "category": 1,
    "name": "woman in lotus position",
    "variations": ["🧘🏻‍♀️", "🧘🏼‍♀️", "🧘🏽‍♀️", "🧘🏾‍♀️", "🧘🏿‍♀️"],
    "version": "5.0"
  }, {
    "emoji": "🛀",
    "category": 1,
    "name": "personne prenant un bain",
    "variations": ["🛀🏻", "🛀🏼", "🛀🏽", "🛀🏾", "🛀🏿"],
    "version": "1.0"
  }, {
    "emoji": "🛌",
    "category": 1,
    "name": "personne au lit",
    "variations": ["🛌🏻", "🛌🏼", "🛌🏽", "🛌🏾", "🛌🏿"],
    "version": "1.0"
  }, {
    "emoji": "🧑‍🤝‍🧑",
    "category": 1,
    "name": "deux personnes se tenant la main",
    "variations": ["🧑🏻‍🤝‍🧑🏻", "🧑🏻‍🤝‍🧑🏼", "🧑🏻‍🤝‍🧑🏽", "🧑🏻‍🤝‍🧑🏾", "🧑🏻‍🤝‍🧑🏿", "🧑🏼‍🤝‍🧑🏻", "🧑🏼‍🤝‍🧑🏼", "🧑🏼‍🤝‍🧑🏽", "🧑🏼‍🤝‍🧑🏾", "🧑🏼‍🤝‍🧑🏿", "🧑🏽‍🤝‍🧑🏻", "🧑🏽‍🤝‍🧑🏼", "🧑🏽‍🤝‍🧑🏽", "🧑🏽‍🤝‍🧑🏾", "🧑🏽‍🤝‍🧑🏿", "🧑🏾‍🤝‍🧑🏻", "🧑🏾‍🤝‍🧑🏼", "🧑🏾‍🤝‍🧑🏽", "🧑🏾‍🤝‍🧑🏾", "🧑🏾‍🤝‍🧑🏿", "🧑🏿‍🤝‍🧑🏻", "🧑🏿‍🤝‍🧑🏼", "🧑🏿‍🤝‍🧑🏽", "🧑🏿‍🤝‍🧑🏾", "🧑🏿‍🤝‍🧑🏿"],
    "version": "12.0"
  }, {
    "emoji": "👭",
    "category": 1,
    "name": "deux femmes se tenant la main",
    "variations": ["👭🏻", "👩🏻‍🤝‍👩🏼", "👩🏻‍🤝‍👩🏽", "👩🏻‍🤝‍👩🏾", "👩🏻‍🤝‍👩🏿", "👩🏼‍🤝‍👩🏻", "👭🏼", "👩🏼‍🤝‍👩🏽", "👩🏼‍🤝‍👩🏾", "👩🏼‍🤝‍👩🏿", "👩🏽‍🤝‍👩🏻", "👩🏽‍🤝‍👩🏼", "👭🏽", "👩🏽‍🤝‍👩🏾", "👩🏽‍🤝‍👩🏿", "👩🏾‍🤝‍👩🏻", "👩🏾‍🤝‍👩🏼", "👩🏾‍🤝‍👩🏽", "👭🏾", "👩🏾‍🤝‍👩🏿", "👩🏿‍🤝‍👩🏻", "👩🏿‍🤝‍👩🏼", "👩🏿‍🤝‍👩🏽", "👩🏿‍🤝‍👩🏾", "👭🏿"],
    "version": "1.0"
  }, {
    "emoji": "👫",
    "category": 1,
    "name": "femme et homme se tenant la main",
    "variations": ["👫🏻", "👩🏻‍🤝‍👨🏼", "👩🏻‍🤝‍👨🏽", "👩🏻‍🤝‍👨🏾", "👩🏻‍🤝‍👨🏿", "👩🏼‍🤝‍👨🏻", "👫🏼", "👩🏼‍🤝‍👨🏽", "👩🏼‍🤝‍👨🏾", "👩🏼‍🤝‍👨🏿", "👩🏽‍🤝‍👨🏻", "👩🏽‍🤝‍👨🏼", "👫🏽", "👩🏽‍🤝‍👨🏾", "👩🏽‍🤝‍👨🏿", "👩🏾‍🤝‍👨🏻", "👩🏾‍🤝‍👨🏼", "👩🏾‍🤝‍👨🏽", "👫🏾", "👩🏾‍🤝‍👨🏿", "👩🏿‍🤝‍👨🏻", "👩🏿‍🤝‍👨🏼", "👩🏿‍🤝‍👨🏽", "👩🏿‍🤝‍👨🏾", "👫🏿"],
    "version": "1.0"
  }, {
    "emoji": "👬",
    "category": 1,
    "name": "deux hommes se tenant la main",
    "variations": ["👬🏻", "👨🏻‍🤝‍👨🏼", "👨🏻‍🤝‍👨🏽", "👨🏻‍🤝‍👨🏾", "👨🏻‍🤝‍👨🏿", "👨🏼‍🤝‍👨🏻", "👬🏼", "👨🏼‍🤝‍👨🏽", "👨🏼‍🤝‍👨🏾", "👨🏼‍🤝‍👨🏿", "👨🏽‍🤝‍👨🏻", "👨🏽‍🤝‍👨🏼", "👬🏽", "👨🏽‍🤝‍👨🏾", "👨🏽‍🤝‍👨🏿", "👨🏾‍🤝‍👨🏻", "👨🏾‍🤝‍👨🏼", "👨🏾‍🤝‍👨🏽", "👬🏾", "👨🏾‍🤝‍👨🏿", "👨🏿‍🤝‍👨🏻", "👨🏿‍🤝‍👨🏼", "👨🏿‍🤝‍👨🏽", "👨🏿‍🤝‍👨🏾", "👬🏿"],
    "version": "1.0"
  }, {
    "emoji": "💏",
    "category": 1,
    "name": "bisou",
    "variations": ["👩‍❤️‍💋‍👨", "👨‍❤️‍💋‍👨", "👩‍❤️‍💋‍👩"],
    "version": "1.0"
  }, {
    "emoji": "💑",
    "category": 1,
    "name": "couple avec cœur",
    "variations": ["👩‍❤️‍👨", "👨‍❤️‍👨", "👩‍❤️‍👩"],
    "version": "1.0"
  }, {
    "emoji": "👪",
    "category": 1,
    "name": "famille",
    "version": "1.0"
  }, {
    "emoji": "👨‍👩‍👦",
    "category": 1,
    "name": "famille : homme, femme et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👩‍👧",
    "category": 1,
    "name": "famille : homme, femme et fille",
    "version": "2.0"
  }, {
    "emoji": "👨‍👩‍👧‍👦",
    "category": 1,
    "name": "famille : homme, femme, fille et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👩‍👦‍👦",
    "category": 1,
    "name": "famille : homme, femme, garçon et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👩‍👧‍👧",
    "category": 1,
    "name": "famille : homme, femme, fille et fille",
    "version": "2.0"
  }, {
    "emoji": "👨‍👨‍👦",
    "category": 1,
    "name": "famille : homme, homme et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👨‍👧",
    "category": 1,
    "name": "famille : homme, homme et fille",
    "version": "2.0"
  }, {
    "emoji": "👨‍👨‍👧‍👦",
    "category": 1,
    "name": "famille : homme, homme, fille et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👨‍👦‍👦",
    "category": 1,
    "name": "famille : homme, homme, garçon et garçon",
    "version": "2.0"
  }, {
    "emoji": "👨‍👨‍👧‍👧",
    "category": 1,
    "name": "famille : homme, homme, fille et fille",
    "version": "2.0"
  }, {
    "emoji": "👩‍👩‍👦",
    "category": 1,
    "name": "famille : femme, femme et garçon",
    "version": "2.0"
  }, {
    "emoji": "👩‍👩‍👧",
    "category": 1,
    "name": "famille : femme, femme et fille",
    "version": "2.0"
  }, {
    "emoji": "👩‍👩‍👧‍👦",
    "category": 1,
    "name": "famille : femme, femme, fille et garçon",
    "version": "2.0"
  }, {
    "emoji": "👩‍👩‍👦‍👦",
    "category": 1,
    "name": "famille : femme, femme, garçon et garçon",
    "version": "2.0"
  }, {
    "emoji": "👩‍👩‍👧‍👧",
    "category": 1,
    "name": "famille : femme, femme, fille et fille",
    "version": "2.0"
  }, {
    "emoji": "👨‍👦",
    "category": 1,
    "name": "famille : homme et garçon",
    "version": "4.0"
  }, {
    "emoji": "👨‍👦‍👦",
    "category": 1,
    "name": "famille : homme, garçon et garçon",
    "version": "4.0"
  }, {
    "emoji": "👨‍👧",
    "category": 1,
    "name": "famille : homme et fille",
    "version": "4.0"
  }, {
    "emoji": "👨‍👧‍👦",
    "category": 1,
    "name": "famille : homme, fille et garçon",
    "version": "4.0"
  }, {
    "emoji": "👨‍👧‍👧",
    "category": 1,
    "name": "famille : homme, fille et fille",
    "version": "4.0"
  }, {
    "emoji": "👩‍👦",
    "category": 1,
    "name": "famille : femme et garçon",
    "version": "4.0"
  }, {
    "emoji": "👩‍👦‍👦",
    "category": 1,
    "name": "famille : femme, garçon et garçon",
    "version": "4.0"
  }, {
    "emoji": "👩‍👧",
    "category": 1,
    "name": "famille : femme et fille",
    "version": "4.0"
  }, {
    "emoji": "👩‍👧‍👦",
    "category": 1,
    "name": "famille : femme, fille et garçon",
    "version": "4.0"
  }, {
    "emoji": "👩‍👧‍👧",
    "category": 1,
    "name": "famille : femme, fille et fille",
    "version": "4.0"
  }, {
    "emoji": "🗣️",
    "category": 1,
    "name": "speaking head",
    "version": "1.0"
  }, {
    "emoji": "👤",
    "category": 1,
    "name": "silhouette de buste",
    "version": "1.0"
  }, {
    "emoji": "👥",
    "category": 1,
    "name": "silhouettes de bustes",
    "version": "1.0"
  }, {
    "emoji": "🫂",
    "category": 1,
    "name": "étreinte",
    "version": "13.0"
  }, {
    "emoji": "👣",
    "category": 1,
    "name": "traces de pas",
    "version": "1.0"
  }, {
    "emoji": "🐵",
    "category": 2,
    "name": "tête de singe",
    "version": "1.0"
  }, {
    "emoji": "🐒",
    "category": 2,
    "name": "singe",
    "version": "1.0"
  }, {
    "emoji": "🦍",
    "category": 2,
    "name": "gorille",
    "version": "3.0"
  }, {
    "emoji": "🦧",
    "category": 2,
    "name": "orang-outan",
    "version": "12.0"
  }, {
    "emoji": "🐶",
    "category": 2,
    "name": "tête de chien",
    "version": "1.0"
  }, {
    "emoji": "🐕",
    "category": 2,
    "name": "chien",
    "version": "1.0"
  }, {
    "emoji": "🦮",
    "category": 2,
    "name": "chien guide",
    "version": "12.0"
  }, {
    "emoji": "🐕‍🦺",
    "category": 2,
    "name": "chien d’assistance",
    "version": "12.0"
  }, {
    "emoji": "🐩",
    "category": 2,
    "name": "caniche",
    "version": "1.0"
  }, {
    "emoji": "🐺",
    "category": 2,
    "name": "loup",
    "version": "1.0"
  }, {
    "emoji": "🦊",
    "category": 2,
    "name": "renard",
    "version": "3.0"
  }, {
    "emoji": "🦝",
    "category": 2,
    "name": "raton laveur",
    "version": "11.0"
  }, {
    "emoji": "🐱",
    "category": 2,
    "name": "tête de chat",
    "version": "1.0"
  }, {
    "emoji": "🐈",
    "category": 2,
    "name": "chat",
    "version": "1.0"
  }, {
    "emoji": "🐈‍⬛",
    "category": 2,
    "name": "chat noir",
    "version": "13.0"
  }, {
    "emoji": "🦁",
    "category": 2,
    "name": "tête de lion",
    "version": "1.0"
  }, {
    "emoji": "🐯",
    "category": 2,
    "name": "tête de tigre",
    "version": "1.0"
  }, {
    "emoji": "🐅",
    "category": 2,
    "name": "tigre",
    "version": "1.0"
  }, {
    "emoji": "🐆",
    "category": 2,
    "name": "léopard",
    "version": "1.0"
  }, {
    "emoji": "🐴",
    "category": 2,
    "name": "tête de cheval",
    "version": "1.0"
  }, {
    "emoji": "🐎",
    "category": 2,
    "name": "cheval",
    "version": "1.0"
  }, {
    "emoji": "🦄",
    "category": 2,
    "name": "licorne",
    "version": "1.0"
  }, {
    "emoji": "🦓",
    "category": 2,
    "name": "zèbre",
    "version": "5.0"
  }, {
    "emoji": "🦌",
    "category": 2,
    "name": "cerf",
    "version": "3.0"
  }, {
    "emoji": "🦬",
    "category": 2,
    "name": "bison",
    "version": "13.0"
  }, {
    "emoji": "🐮",
    "category": 2,
    "name": "tête de vache",
    "version": "1.0"
  }, {
    "emoji": "🐂",
    "category": 2,
    "name": "bœuf",
    "version": "1.0"
  }, {
    "emoji": "🐃",
    "category": 2,
    "name": "buffle",
    "version": "1.0"
  }, {
    "emoji": "🐄",
    "category": 2,
    "name": "vache",
    "version": "1.0"
  }, {
    "emoji": "🐷",
    "category": 2,
    "name": "tête de cochon",
    "version": "1.0"
  }, {
    "emoji": "🐖",
    "category": 2,
    "name": "cochon",
    "version": "1.0"
  }, {
    "emoji": "🐗",
    "category": 2,
    "name": "sanglier",
    "version": "1.0"
  }, {
    "emoji": "🐽",
    "category": 2,
    "name": "groin",
    "version": "1.0"
  }, {
    "emoji": "🐏",
    "category": 2,
    "name": "bélier",
    "version": "1.0"
  }, {
    "emoji": "🐑",
    "category": 2,
    "name": "mouton",
    "version": "1.0"
  }, {
    "emoji": "🐐",
    "category": 2,
    "name": "chèvre",
    "version": "1.0"
  }, {
    "emoji": "🐪",
    "category": 2,
    "name": "dromadaire",
    "version": "1.0"
  }, {
    "emoji": "🐫",
    "category": 2,
    "name": "chameau",
    "version": "1.0"
  }, {
    "emoji": "🦙",
    "category": 2,
    "name": "lama",
    "version": "11.0"
  }, {
    "emoji": "🦒",
    "category": 2,
    "name": "girafe",
    "version": "5.0"
  }, {
    "emoji": "🐘",
    "category": 2,
    "name": "éléphant",
    "version": "1.0"
  }, {
    "emoji": "🦣",
    "category": 2,
    "name": "mammouth",
    "version": "13.0"
  }, {
    "emoji": "🦏",
    "category": 2,
    "name": "rhinocéros",
    "version": "3.0"
  }, {
    "emoji": "🦛",
    "category": 2,
    "name": "hippopotame",
    "version": "11.0"
  }, {
    "emoji": "🐭",
    "category": 2,
    "name": "tête de souris",
    "version": "1.0"
  }, {
    "emoji": "🐁",
    "category": 2,
    "name": "souris",
    "version": "1.0"
  }, {
    "emoji": "🐀",
    "category": 2,
    "name": "rat",
    "version": "1.0"
  }, {
    "emoji": "🐹",
    "category": 2,
    "name": "hamster",
    "version": "1.0"
  }, {
    "emoji": "🐰",
    "category": 2,
    "name": "tête de lapin",
    "version": "1.0"
  }, {
    "emoji": "🐇",
    "category": 2,
    "name": "lapin",
    "version": "1.0"
  }, {
    "emoji": "🐿️",
    "category": 2,
    "name": "chipmunk",
    "version": "1.0"
  }, {
    "emoji": "🦫",
    "category": 2,
    "name": "castor",
    "version": "13.0"
  }, {
    "emoji": "🦔",
    "category": 2,
    "name": "hérisson",
    "version": "5.0"
  }, {
    "emoji": "🦇",
    "category": 2,
    "name": "chauve-souris",
    "version": "3.0"
  }, {
    "emoji": "🐻",
    "category": 2,
    "name": "ours",
    "version": "1.0"
  }, {
    "emoji": "🐻‍❄️",
    "category": 2,
    "name": "polar bear",
    "version": "13.0"
  }, {
    "emoji": "🐨",
    "category": 2,
    "name": "koala",
    "version": "1.0"
  }, {
    "emoji": "🐼",
    "category": 2,
    "name": "panda",
    "version": "1.0"
  }, {
    "emoji": "🦥",
    "category": 2,
    "name": "paresseux",
    "version": "12.0"
  }, {
    "emoji": "🦦",
    "category": 2,
    "name": "loutre",
    "version": "12.0"
  }, {
    "emoji": "🦨",
    "category": 2,
    "name": "mouffette",
    "version": "12.0"
  }, {
    "emoji": "🦘",
    "category": 2,
    "name": "kangourou",
    "version": "11.0"
  }, {
    "emoji": "🦡",
    "category": 2,
    "name": "blaireau",
    "version": "11.0"
  }, {
    "emoji": "🐾",
    "category": 2,
    "name": "empreintes d’animaux",
    "version": "1.0"
  }, {
    "emoji": "🦃",
    "category": 2,
    "name": "dindon",
    "version": "1.0"
  }, {
    "emoji": "🐔",
    "category": 2,
    "name": "poule",
    "version": "1.0"
  }, {
    "emoji": "🐓",
    "category": 2,
    "name": "coq",
    "version": "1.0"
  }, {
    "emoji": "🐣",
    "category": 2,
    "name": "poussin qui éclôt",
    "version": "1.0"
  }, {
    "emoji": "🐤",
    "category": 2,
    "name": "poussin",
    "version": "1.0"
  }, {
    "emoji": "🐥",
    "category": 2,
    "name": "poussin de face",
    "version": "1.0"
  }, {
    "emoji": "🐦",
    "category": 2,
    "name": "oiseau",
    "version": "1.0"
  }, {
    "emoji": "🐧",
    "category": 2,
    "name": "pingouin",
    "version": "1.0"
  }, {
    "emoji": "🕊️",
    "category": 2,
    "name": "dove",
    "version": "1.0"
  }, {
    "emoji": "🦅",
    "category": 2,
    "name": "aigle",
    "version": "3.0"
  }, {
    "emoji": "🦆",
    "category": 2,
    "name": "canard",
    "version": "3.0"
  }, {
    "emoji": "🦢",
    "category": 2,
    "name": "cygne",
    "version": "11.0"
  }, {
    "emoji": "🦉",
    "category": 2,
    "name": "chouette",
    "version": "3.0"
  }, {
    "emoji": "🦤",
    "category": 2,
    "name": "dodo",
    "version": "13.0"
  }, {
    "emoji": "🪶",
    "category": 2,
    "name": "plume",
    "version": "13.0"
  }, {
    "emoji": "🦩",
    "category": 2,
    "name": "flamant",
    "version": "12.0"
  }, {
    "emoji": "🦚",
    "category": 2,
    "name": "paon",
    "version": "11.0"
  }, {
    "emoji": "🦜",
    "category": 2,
    "name": "perroquet",
    "version": "11.0"
  }, {
    "emoji": "🐸",
    "category": 2,
    "name": "grenouille",
    "version": "1.0"
  }, {
    "emoji": "🐊",
    "category": 2,
    "name": "crocodile",
    "version": "1.0"
  }, {
    "emoji": "🐢",
    "category": 2,
    "name": "tortue",
    "version": "1.0"
  }, {
    "emoji": "🦎",
    "category": 2,
    "name": "lézard",
    "version": "3.0"
  }, {
    "emoji": "🐍",
    "category": 2,
    "name": "serpent",
    "version": "1.0"
  }, {
    "emoji": "🐲",
    "category": 2,
    "name": "tête de dragon",
    "version": "1.0"
  }, {
    "emoji": "🐉",
    "category": 2,
    "name": "dragon",
    "version": "1.0"
  }, {
    "emoji": "🦕",
    "category": 2,
    "name": "sauropode",
    "version": "5.0"
  }, {
    "emoji": "🦖",
    "category": 2,
    "name": "T-Rex",
    "version": "5.0"
  }, {
    "emoji": "🐳",
    "category": 2,
    "name": "baleine soufflant par son évent",
    "version": "1.0"
  }, {
    "emoji": "🐋",
    "category": 2,
    "name": "baleine",
    "version": "1.0"
  }, {
    "emoji": "🐬",
    "category": 2,
    "name": "dauphin",
    "version": "1.0"
  }, {
    "emoji": "🦭",
    "category": 2,
    "name": "phoque",
    "version": "13.0"
  }, {
    "emoji": "🐟",
    "category": 2,
    "name": "poisson",
    "version": "1.0"
  }, {
    "emoji": "🐠",
    "category": 2,
    "name": "poisson tropical",
    "version": "1.0"
  }, {
    "emoji": "🐡",
    "category": 2,
    "name": "poisson-lune",
    "version": "1.0"
  }, {
    "emoji": "🦈",
    "category": 2,
    "name": "requin",
    "version": "3.0"
  }, {
    "emoji": "🐙",
    "category": 2,
    "name": "pieuvre",
    "version": "1.0"
  }, {
    "emoji": "🐚",
    "category": 2,
    "name": "coquille en spirale",
    "version": "1.0"
  }, {
    "emoji": "🐌",
    "category": 2,
    "name": "escargot",
    "version": "1.0"
  }, {
    "emoji": "🦋",
    "category": 2,
    "name": "papillon",
    "version": "3.0"
  }, {
    "emoji": "🐛",
    "category": 2,
    "name": "chenille",
    "version": "1.0"
  }, {
    "emoji": "🐜",
    "category": 2,
    "name": "fourmi",
    "version": "1.0"
  }, {
    "emoji": "🐝",
    "category": 2,
    "name": "abeille",
    "version": "1.0"
  }, {
    "emoji": "🪲",
    "category": 2,
    "name": "scarabée",
    "version": "13.0"
  }, {
    "emoji": "🐞",
    "category": 2,
    "name": "coccinelle",
    "version": "1.0"
  }, {
    "emoji": "🦗",
    "category": 2,
    "name": "criquet",
    "version": "5.0"
  }, {
    "emoji": "🪳",
    "category": 2,
    "name": "cafard",
    "version": "13.0"
  }, {
    "emoji": "🕷️",
    "category": 2,
    "name": "spider",
    "version": "1.0"
  }, {
    "emoji": "🕸️",
    "category": 2,
    "name": "spider web",
    "version": "1.0"
  }, {
    "emoji": "🦂",
    "category": 2,
    "name": "scorpion",
    "version": "1.0"
  }, {
    "emoji": "🦟",
    "category": 2,
    "name": "moustique",
    "version": "11.0"
  }, {
    "emoji": "🪰",
    "category": 2,
    "name": "mouche",
    "version": "13.0"
  }, {
    "emoji": "🪱",
    "category": 2,
    "name": "lombric",
    "version": "13.0"
  }, {
    "emoji": "🦠",
    "category": 2,
    "name": "microbe",
    "version": "11.0"
  }, {
    "emoji": "💐",
    "category": 2,
    "name": "bouquet",
    "version": "1.0"
  }, {
    "emoji": "🌸",
    "category": 2,
    "name": "fleur de cerisier",
    "version": "1.0"
  }, {
    "emoji": "💮",
    "category": 2,
    "name": "fleur blanche",
    "version": "1.0"
  }, {
    "emoji": "🏵️",
    "category": 2,
    "name": "rosette",
    "version": "1.0"
  }, {
    "emoji": "🌹",
    "category": 2,
    "name": "rose",
    "version": "1.0"
  }, {
    "emoji": "🥀",
    "category": 2,
    "name": "fleur fanée",
    "version": "3.0"
  }, {
    "emoji": "🌺",
    "category": 2,
    "name": "hibiscus",
    "version": "1.0"
  }, {
    "emoji": "🌻",
    "category": 2,
    "name": "tournesol",
    "version": "1.0"
  }, {
    "emoji": "🌼",
    "category": 2,
    "name": "bourgeon",
    "version": "1.0"
  }, {
    "emoji": "🌷",
    "category": 2,
    "name": "tulipe",
    "version": "1.0"
  }, {
    "emoji": "🌱",
    "category": 2,
    "name": "jeune pousse",
    "version": "1.0"
  }, {
    "emoji": "🪴",
    "category": 2,
    "name": "plante en pot",
    "version": "13.0"
  }, {
    "emoji": "🌲",
    "category": 2,
    "name": "conifère",
    "version": "1.0"
  }, {
    "emoji": "🌳",
    "category": 2,
    "name": "arbre à feuilles caduques",
    "version": "1.0"
  }, {
    "emoji": "🌴",
    "category": 2,
    "name": "palmier",
    "version": "1.0"
  }, {
    "emoji": "🌵",
    "category": 2,
    "name": "cactus",
    "version": "1.0"
  }, {
    "emoji": "🌾",
    "category": 2,
    "name": "plant de riz",
    "version": "1.0"
  }, {
    "emoji": "🌿",
    "category": 2,
    "name": "feuille",
    "version": "1.0"
  }, {
    "emoji": "☘️",
    "category": 2,
    "name": "shamrock",
    "version": "1.0"
  }, {
    "emoji": "🍀",
    "category": 2,
    "name": "trèfle à quatre feuilles",
    "version": "1.0"
  }, {
    "emoji": "🍁",
    "category": 2,
    "name": "feuille d’érable",
    "version": "1.0"
  }, {
    "emoji": "🍂",
    "category": 2,
    "name": "feuille morte",
    "version": "1.0"
  }, {
    "emoji": "🍃",
    "category": 2,
    "name": "feuille virevoltante",
    "version": "1.0"
  }, {
    "emoji": "🍇",
    "category": 3,
    "name": "raisin",
    "version": "1.0"
  }, {
    "emoji": "🍈",
    "category": 3,
    "name": "melon",
    "version": "1.0"
  }, {
    "emoji": "🍉",
    "category": 3,
    "name": "pastèque",
    "version": "1.0"
  }, {
    "emoji": "🍊",
    "category": 3,
    "name": "mandarine",
    "version": "1.0"
  }, {
    "emoji": "🍋",
    "category": 3,
    "name": "citron",
    "version": "1.0"
  }, {
    "emoji": "🍌",
    "category": 3,
    "name": "banane",
    "version": "1.0"
  }, {
    "emoji": "🍍",
    "category": 3,
    "name": "ananas",
    "version": "1.0"
  }, {
    "emoji": "🥭",
    "category": 3,
    "name": "mangue",
    "version": "11.0"
  }, {
    "emoji": "🍎",
    "category": 3,
    "name": "pomme rouge",
    "version": "1.0"
  }, {
    "emoji": "🍏",
    "category": 3,
    "name": "pomme verte",
    "version": "1.0"
  }, {
    "emoji": "🍐",
    "category": 3,
    "name": "poire",
    "version": "1.0"
  }, {
    "emoji": "🍑",
    "category": 3,
    "name": "pêche",
    "version": "1.0"
  }, {
    "emoji": "🍒",
    "category": 3,
    "name": "cerises",
    "version": "1.0"
  }, {
    "emoji": "🍓",
    "category": 3,
    "name": "fraise",
    "version": "1.0"
  }, {
    "emoji": "🫐",
    "category": 3,
    "name": "myrtilles",
    "version": "13.0"
  }, {
    "emoji": "🥝",
    "category": 3,
    "name": "kiwi",
    "version": "3.0"
  }, {
    "emoji": "🍅",
    "category": 3,
    "name": "tomate",
    "version": "1.0"
  }, {
    "emoji": "🫒",
    "category": 3,
    "name": "olive",
    "version": "13.0"
  }, {
    "emoji": "🥥",
    "category": 3,
    "name": "noix de coco",
    "version": "5.0"
  }, {
    "emoji": "🥑",
    "category": 3,
    "name": "avocat",
    "version": "3.0"
  }, {
    "emoji": "🍆",
    "category": 3,
    "name": "aubergine",
    "version": "1.0"
  }, {
    "emoji": "🥔",
    "category": 3,
    "name": "pomme de terre",
    "version": "3.0"
  }, {
    "emoji": "🥕",
    "category": 3,
    "name": "carotte",
    "version": "3.0"
  }, {
    "emoji": "🌽",
    "category": 3,
    "name": "épi de maïs",
    "version": "1.0"
  }, {
    "emoji": "🌶️",
    "category": 3,
    "name": "hot pepper",
    "version": "1.0"
  }, {
    "emoji": "🫑",
    "category": 3,
    "name": "poivron",
    "version": "13.0"
  }, {
    "emoji": "🥒",
    "category": 3,
    "name": "concombre",
    "version": "3.0"
  }, {
    "emoji": "🥬",
    "category": 3,
    "name": "légume à feuilles vertes",
    "version": "11.0"
  }, {
    "emoji": "🥦",
    "category": 3,
    "name": "brocoli",
    "version": "5.0"
  }, {
    "emoji": "🧄",
    "category": 3,
    "name": "ail",
    "version": "12.0"
  }, {
    "emoji": "🧅",
    "category": 3,
    "name": "oignon",
    "version": "12.0"
  }, {
    "emoji": "🍄",
    "category": 3,
    "name": "champignon",
    "version": "1.0"
  }, {
    "emoji": "🥜",
    "category": 3,
    "name": "cacahuètes",
    "version": "3.0"
  }, {
    "emoji": "🌰",
    "category": 3,
    "name": "châtaigne",
    "version": "1.0"
  }, {
    "emoji": "🍞",
    "category": 3,
    "name": "pain",
    "version": "1.0"
  }, {
    "emoji": "🥐",
    "category": 3,
    "name": "croissant",
    "version": "3.0"
  }, {
    "emoji": "🥖",
    "category": 3,
    "name": "baguette",
    "version": "3.0"
  }, {
    "emoji": "🫓",
    "category": 3,
    "name": "galette",
    "version": "13.0"
  }, {
    "emoji": "🥨",
    "category": 3,
    "name": "bretzel",
    "version": "5.0"
  }, {
    "emoji": "🥯",
    "category": 3,
    "name": "bagel",
    "version": "11.0"
  }, {
    "emoji": "🥞",
    "category": 3,
    "name": "pancakes",
    "version": "3.0"
  }, {
    "emoji": "🧇",
    "category": 3,
    "name": "gaufre",
    "version": "12.0"
  }, {
    "emoji": "🧀",
    "category": 3,
    "name": "part de fromage",
    "version": "1.0"
  }, {
    "emoji": "🍖",
    "category": 3,
    "name": "viande sur un os",
    "version": "1.0"
  }, {
    "emoji": "🍗",
    "category": 3,
    "name": "cuisse de poulet",
    "version": "1.0"
  }, {
    "emoji": "🥩",
    "category": 3,
    "name": "morceau de viande",
    "version": "5.0"
  }, {
    "emoji": "🥓",
    "category": 3,
    "name": "lard",
    "version": "3.0"
  }, {
    "emoji": "🍔",
    "category": 3,
    "name": "hamburger",
    "version": "1.0"
  }, {
    "emoji": "🍟",
    "category": 3,
    "name": "frites",
    "version": "1.0"
  }, {
    "emoji": "🍕",
    "category": 3,
    "name": "pizza",
    "version": "1.0"
  }, {
    "emoji": "🌭",
    "category": 3,
    "name": "hot dog",
    "version": "1.0"
  }, {
    "emoji": "🥪",
    "category": 3,
    "name": "sandwich",
    "version": "5.0"
  }, {
    "emoji": "🌮",
    "category": 3,
    "name": "taco",
    "version": "1.0"
  }, {
    "emoji": "🌯",
    "category": 3,
    "name": "burrito",
    "version": "1.0"
  }, {
    "emoji": "🫔",
    "category": 3,
    "name": "tamal",
    "version": "13.0"
  }, {
    "emoji": "🥙",
    "category": 3,
    "name": "kebab",
    "version": "3.0"
  }, {
    "emoji": "🧆",
    "category": 3,
    "name": "falafels",
    "version": "12.0"
  }, {
    "emoji": "🥚",
    "category": 3,
    "name": "œuf",
    "version": "3.0"
  }, {
    "emoji": "🍳",
    "category": 3,
    "name": "œuf au plat",
    "version": "1.0"
  }, {
    "emoji": "🥘",
    "category": 3,
    "name": "plat mitonné",
    "version": "3.0"
  }, {
    "emoji": "🍲",
    "category": 3,
    "name": "marmite",
    "version": "1.0"
  }, {
    "emoji": "🫕",
    "category": 3,
    "name": "fondue",
    "version": "13.0"
  }, {
    "emoji": "🥣",
    "category": 3,
    "name": "bol avec cuillère",
    "version": "5.0"
  }, {
    "emoji": "🥗",
    "category": 3,
    "name": "salade verte",
    "version": "3.0"
  }, {
    "emoji": "🍿",
    "category": 3,
    "name": "pop-corn",
    "version": "1.0"
  }, {
    "emoji": "🧈",
    "category": 3,
    "name": "beurre",
    "version": "12.0"
  }, {
    "emoji": "🧂",
    "category": 3,
    "name": "sel",
    "version": "11.0"
  }, {
    "emoji": "🥫",
    "category": 3,
    "name": "aliments en conserve",
    "version": "5.0"
  }, {
    "emoji": "🍱",
    "category": 3,
    "name": "boîte déjeuner",
    "version": "1.0"
  }, {
    "emoji": "🍘",
    "category": 3,
    "name": "galette de riz",
    "version": "1.0"
  }, {
    "emoji": "🍙",
    "category": 3,
    "name": "boulette de riz",
    "version": "1.0"
  }, {
    "emoji": "🍚",
    "category": 3,
    "name": "bol de riz",
    "version": "1.0"
  }, {
    "emoji": "🍛",
    "category": 3,
    "name": "riz au curry",
    "version": "1.0"
  }, {
    "emoji": "🍜",
    "category": 3,
    "name": "bol fumant",
    "version": "1.0"
  }, {
    "emoji": "🍝",
    "category": 3,
    "name": "spaghetti",
    "version": "1.0"
  }, {
    "emoji": "🍠",
    "category": 3,
    "name": "patate douce",
    "version": "1.0"
  }, {
    "emoji": "🍢",
    "category": 3,
    "name": "brochette de poisson",
    "version": "1.0"
  }, {
    "emoji": "🍣",
    "category": 3,
    "name": "sushi",
    "version": "1.0"
  }, {
    "emoji": "🍤",
    "category": 3,
    "name": "beignet de crevette",
    "version": "1.0"
  }, {
    "emoji": "🍥",
    "category": 3,
    "name": "croquette de poisson",
    "version": "1.0"
  }, {
    "emoji": "🥮",
    "category": 3,
    "name": "gâteau de lune",
    "version": "11.0"
  }, {
    "emoji": "🍡",
    "category": 3,
    "name": "brochette de bonbons",
    "version": "1.0"
  }, {
    "emoji": "🥟",
    "category": 3,
    "name": "boulette de pâte",
    "version": "5.0"
  }, {
    "emoji": "🥠",
    "category": 3,
    "name": "biscuit chinois",
    "version": "5.0"
  }, {
    "emoji": "🥡",
    "category": 3,
    "name": "boîte à emporter",
    "version": "5.0"
  }, {
    "emoji": "🦀",
    "category": 3,
    "name": "crabe",
    "version": "1.0"
  }, {
    "emoji": "🦞",
    "category": 3,
    "name": "homard",
    "version": "11.0"
  }, {
    "emoji": "🦐",
    "category": 3,
    "name": "crevette",
    "version": "3.0"
  }, {
    "emoji": "🦑",
    "category": 3,
    "name": "calamar",
    "version": "3.0"
  }, {
    "emoji": "🦪",
    "category": 3,
    "name": "huître",
    "version": "12.0"
  }, {
    "emoji": "🍦",
    "category": 3,
    "name": "glace italienne",
    "version": "1.0"
  }, {
    "emoji": "🍧",
    "category": 3,
    "name": "granité",
    "version": "1.0"
  }, {
    "emoji": "🍨",
    "category": 3,
    "name": "glace",
    "version": "1.0"
  }, {
    "emoji": "🍩",
    "category": 3,
    "name": "doughnut",
    "version": "1.0"
  }, {
    "emoji": "🍪",
    "category": 3,
    "name": "cookie",
    "version": "1.0"
  }, {
    "emoji": "🎂",
    "category": 3,
    "name": "gâteau d’anniversaire",
    "version": "1.0"
  }, {
    "emoji": "🍰",
    "category": 3,
    "name": "gâteau sablé",
    "version": "1.0"
  }, {
    "emoji": "🧁",
    "category": 3,
    "name": "cupcake",
    "version": "11.0"
  }, {
    "emoji": "🥧",
    "category": 3,
    "name": "tarte",
    "version": "5.0"
  }, {
    "emoji": "🍫",
    "category": 3,
    "name": "barre chocolatée",
    "version": "1.0"
  }, {
    "emoji": "🍬",
    "category": 3,
    "name": "bonbon",
    "version": "1.0"
  }, {
    "emoji": "🍭",
    "category": 3,
    "name": "sucette",
    "version": "1.0"
  }, {
    "emoji": "🍮",
    "category": 3,
    "name": "crème renversée",
    "version": "1.0"
  }, {
    "emoji": "🍯",
    "category": 3,
    "name": "pot de miel",
    "version": "1.0"
  }, {
    "emoji": "🍼",
    "category": 3,
    "name": "biberon",
    "version": "1.0"
  }, {
    "emoji": "🥛",
    "category": 3,
    "name": "verre de lait",
    "version": "3.0"
  }, {
    "emoji": "☕",
    "category": 3,
    "name": "boisson chaude",
    "version": "1.0"
  }, {
    "emoji": "🫖",
    "category": 3,
    "name": "théière",
    "version": "13.0"
  }, {
    "emoji": "🍵",
    "category": 3,
    "name": "tasse",
    "version": "1.0"
  }, {
    "emoji": "🍶",
    "category": 3,
    "name": "saké",
    "version": "1.0"
  }, {
    "emoji": "🍾",
    "category": 3,
    "name": "bouteille de champagne",
    "version": "1.0"
  }, {
    "emoji": "🍷",
    "category": 3,
    "name": "verre de vin",
    "version": "1.0"
  }, {
    "emoji": "🍸",
    "category": 3,
    "name": "cocktail",
    "version": "1.0"
  }, {
    "emoji": "🍹",
    "category": 3,
    "name": "cocktail tropical",
    "version": "1.0"
  }, {
    "emoji": "🍺",
    "category": 3,
    "name": "chope",
    "version": "1.0"
  }, {
    "emoji": "🍻",
    "category": 3,
    "name": "chopes de bière",
    "version": "1.0"
  }, {
    "emoji": "🥂",
    "category": 3,
    "name": "trinquer",
    "version": "3.0"
  }, {
    "emoji": "🥃",
    "category": 3,
    "name": "verre tumbler",
    "version": "3.0"
  }, {
    "emoji": "🥤",
    "category": 3,
    "name": "gobelet avec paille",
    "version": "5.0"
  }, {
    "emoji": "🧋",
    "category": 3,
    "name": "thé aux perles",
    "version": "13.0"
  }, {
    "emoji": "🧃",
    "category": 3,
    "name": "briquette de jus",
    "version": "12.0"
  }, {
    "emoji": "🧉",
    "category": 3,
    "name": "maté",
    "version": "12.0"
  }, {
    "emoji": "🧊",
    "category": 3,
    "name": "glaçon",
    "version": "12.0"
  }, {
    "emoji": "🥢",
    "category": 3,
    "name": "baguettes",
    "version": "5.0"
  }, {
    "emoji": "🍽️",
    "category": 3,
    "name": "fork and knife with plate",
    "version": "1.0"
  }, {
    "emoji": "🍴",
    "category": 3,
    "name": "fourchette et couteau",
    "version": "1.0"
  }, {
    "emoji": "🥄",
    "category": 3,
    "name": "cuillère",
    "version": "3.0"
  }, {
    "emoji": "🔪",
    "category": 3,
    "name": "couteau de cuisine",
    "version": "1.0"
  }, {
    "emoji": "🏺",
    "category": 3,
    "name": "amphore",
    "version": "1.0"
  }, {
    "emoji": "🌍",
    "category": 4,
    "name": "globe tourné sur l’Afrique et l’Europe",
    "version": "1.0"
  }, {
    "emoji": "🌎",
    "category": 4,
    "name": "globe tourné sur les Amériques",
    "version": "1.0"
  }, {
    "emoji": "🌏",
    "category": 4,
    "name": "globe tourné sur l’Asie et l’Australie",
    "version": "1.0"
  }, {
    "emoji": "🌐",
    "category": 4,
    "name": "globe avec méridiens",
    "version": "1.0"
  }, {
    "emoji": "🗺️",
    "category": 4,
    "name": "world map",
    "version": "1.0"
  }, {
    "emoji": "🗾",
    "category": 4,
    "name": "carte du Japon",
    "version": "1.0"
  }, {
    "emoji": "🧭",
    "category": 4,
    "name": "boussole",
    "version": "11.0"
  }, {
    "emoji": "🏔️",
    "category": 4,
    "name": "snow-capped mountain",
    "version": "1.0"
  }, {
    "emoji": "⛰️",
    "category": 4,
    "name": "mountain",
    "version": "1.0"
  }, {
    "emoji": "🌋",
    "category": 4,
    "name": "volcan",
    "version": "1.0"
  }, {
    "emoji": "🗻",
    "category": 4,
    "name": "mont Fuji",
    "version": "1.0"
  }, {
    "emoji": "🏕️",
    "category": 4,
    "name": "camping",
    "version": "1.0"
  }, {
    "emoji": "🏖️",
    "category": 4,
    "name": "beach with umbrella",
    "version": "1.0"
  }, {
    "emoji": "🏜️",
    "category": 4,
    "name": "desert",
    "version": "1.0"
  }, {
    "emoji": "🏝️",
    "category": 4,
    "name": "desert island",
    "version": "1.0"
  }, {
    "emoji": "🏞️",
    "category": 4,
    "name": "national park",
    "version": "1.0"
  }, {
    "emoji": "🏟️",
    "category": 4,
    "name": "stadium",
    "version": "1.0"
  }, {
    "emoji": "🏛️",
    "category": 4,
    "name": "classical building",
    "version": "1.0"
  }, {
    "emoji": "🏗️",
    "category": 4,
    "name": "building construction",
    "version": "1.0"
  }, {
    "emoji": "🧱",
    "category": 4,
    "name": "brique",
    "version": "11.0"
  }, {
    "emoji": "🪨",
    "category": 4,
    "name": "rocher",
    "version": "13.0"
  }, {
    "emoji": "🪵",
    "category": 4,
    "name": "bois",
    "version": "13.0"
  }, {
    "emoji": "🛖",
    "category": 4,
    "name": "hutte",
    "version": "13.0"
  }, {
    "emoji": "🏘️",
    "category": 4,
    "name": "houses",
    "version": "1.0"
  }, {
    "emoji": "🏚️",
    "category": 4,
    "name": "derelict house",
    "version": "1.0"
  }, {
    "emoji": "🏠",
    "category": 4,
    "name": "maison",
    "version": "1.0"
  }, {
    "emoji": "🏡",
    "category": 4,
    "name": "maison avec jardin",
    "version": "1.0"
  }, {
    "emoji": "🏢",
    "category": 4,
    "name": "immeuble de bureaux",
    "version": "1.0"
  }, {
    "emoji": "🏣",
    "category": 4,
    "name": "bureau de poste japonais",
    "version": "1.0"
  }, {
    "emoji": "🏤",
    "category": 4,
    "name": "bureau de poste",
    "version": "1.0"
  }, {
    "emoji": "🏥",
    "category": 4,
    "name": "hôpital",
    "version": "1.0"
  }, {
    "emoji": "🏦",
    "category": 4,
    "name": "banque",
    "version": "1.0"
  }, {
    "emoji": "🏨",
    "category": 4,
    "name": "hôtel",
    "version": "1.0"
  }, {
    "emoji": "🏩",
    "category": 4,
    "name": "love hotel",
    "version": "1.0"
  }, {
    "emoji": "🏪",
    "category": 4,
    "name": "supérette",
    "version": "1.0"
  }, {
    "emoji": "🏫",
    "category": 4,
    "name": "école",
    "version": "1.0"
  }, {
    "emoji": "🏬",
    "category": 4,
    "name": "grand magasin",
    "version": "1.0"
  }, {
    "emoji": "🏭",
    "category": 4,
    "name": "usine",
    "version": "1.0"
  }, {
    "emoji": "🏯",
    "category": 4,
    "name": "château japonais",
    "version": "1.0"
  }, {
    "emoji": "🏰",
    "category": 4,
    "name": "château",
    "version": "1.0"
  }, {
    "emoji": "💒",
    "category": 4,
    "name": "mariage",
    "version": "1.0"
  }, {
    "emoji": "🗼",
    "category": 4,
    "name": "tour de Tokyo",
    "version": "1.0"
  }, {
    "emoji": "🗽",
    "category": 4,
    "name": "statue de la Liberté",
    "version": "1.0"
  }, {
    "emoji": "⛪",
    "category": 4,
    "name": "église",
    "version": "1.0"
  }, {
    "emoji": "🕌",
    "category": 4,
    "name": "mosquée",
    "version": "1.0"
  }, {
    "emoji": "🛕",
    "category": 4,
    "name": "temple hindou",
    "version": "12.0"
  }, {
    "emoji": "🕍",
    "category": 4,
    "name": "synagogue",
    "version": "1.0"
  }, {
    "emoji": "⛩️",
    "category": 4,
    "name": "shinto shrine",
    "version": "1.0"
  }, {
    "emoji": "🕋",
    "category": 4,
    "name": "kaaba",
    "version": "1.0"
  }, {
    "emoji": "⛲",
    "category": 4,
    "name": "fontaine",
    "version": "1.0"
  }, {
    "emoji": "⛺",
    "category": 4,
    "name": "tente",
    "version": "1.0"
  }, {
    "emoji": "🌁",
    "category": 4,
    "name": "brume",
    "version": "1.0"
  }, {
    "emoji": "🌃",
    "category": 4,
    "name": "nuit étoilée",
    "version": "1.0"
  }, {
    "emoji": "🏙️",
    "category": 4,
    "name": "cityscape",
    "version": "1.0"
  }, {
    "emoji": "🌄",
    "category": 4,
    "name": "soleil levant derrière les montagnes",
    "version": "1.0"
  }, {
    "emoji": "🌅",
    "category": 4,
    "name": "soleil levant",
    "version": "1.0"
  }, {
    "emoji": "🌆",
    "category": 4,
    "name": "ville au crépuscule",
    "version": "1.0"
  }, {
    "emoji": "🌇",
    "category": 4,
    "name": "coucher de soleil",
    "version": "1.0"
  }, {
    "emoji": "🌉",
    "category": 4,
    "name": "pont de nuit",
    "version": "1.0"
  }, {
    "emoji": "♨️",
    "category": 4,
    "name": "hot springs",
    "version": "1.0"
  }, {
    "emoji": "🎠",
    "category": 4,
    "name": "cheval de manège",
    "version": "1.0"
  }, {
    "emoji": "🎡",
    "category": 4,
    "name": "grande roue",
    "version": "1.0"
  }, {
    "emoji": "🎢",
    "category": 4,
    "name": "montagnes russes",
    "version": "1.0"
  }, {
    "emoji": "💈",
    "category": 4,
    "name": "enseigne de barbier",
    "version": "1.0"
  }, {
    "emoji": "🎪",
    "category": 4,
    "name": "chapiteau",
    "version": "1.0"
  }, {
    "emoji": "🚂",
    "category": 4,
    "name": "locomotive",
    "version": "1.0"
  }, {
    "emoji": "🚃",
    "category": 4,
    "name": "wagon",
    "version": "1.0"
  }, {
    "emoji": "🚄",
    "category": 4,
    "name": "TGV",
    "version": "1.0"
  }, {
    "emoji": "🚅",
    "category": 4,
    "name": "train à grande vitesse",
    "version": "1.0"
  }, {
    "emoji": "🚆",
    "category": 4,
    "name": "train",
    "version": "1.0"
  }, {
    "emoji": "🚇",
    "category": 4,
    "name": "métro",
    "version": "1.0"
  }, {
    "emoji": "🚈",
    "category": 4,
    "name": "métro léger",
    "version": "1.0"
  }, {
    "emoji": "🚉",
    "category": 4,
    "name": "gare",
    "version": "1.0"
  }, {
    "emoji": "🚊",
    "category": 4,
    "name": "tramway",
    "version": "1.0"
  }, {
    "emoji": "🚝",
    "category": 4,
    "name": "monorail",
    "version": "1.0"
  }, {
    "emoji": "🚞",
    "category": 4,
    "name": "train de montagne",
    "version": "1.0"
  }, {
    "emoji": "🚋",
    "category": 4,
    "name": "wagon de tramway",
    "version": "1.0"
  }, {
    "emoji": "🚌",
    "category": 4,
    "name": "bus",
    "version": "1.0"
  }, {
    "emoji": "🚍",
    "category": 4,
    "name": "bus de face",
    "version": "1.0"
  }, {
    "emoji": "🚎",
    "category": 4,
    "name": "trolleybus",
    "version": "1.0"
  }, {
    "emoji": "🚐",
    "category": 4,
    "name": "minibus",
    "version": "1.0"
  }, {
    "emoji": "🚑",
    "category": 4,
    "name": "ambulance",
    "version": "1.0"
  }, {
    "emoji": "🚒",
    "category": 4,
    "name": "camion de pompier",
    "version": "1.0"
  }, {
    "emoji": "🚓",
    "category": 4,
    "name": "voiture de police",
    "version": "1.0"
  }, {
    "emoji": "🚔",
    "category": 4,
    "name": "voiture de police de face",
    "version": "1.0"
  }, {
    "emoji": "🚕",
    "category": 4,
    "name": "taxi",
    "version": "1.0"
  }, {
    "emoji": "🚖",
    "category": 4,
    "name": "taxi de face",
    "version": "1.0"
  }, {
    "emoji": "🚗",
    "category": 4,
    "name": "voiture",
    "version": "1.0"
  }, {
    "emoji": "🚘",
    "category": 4,
    "name": "voiture de face",
    "version": "1.0"
  }, {
    "emoji": "🚙",
    "category": 4,
    "name": "véhicule utilitaire sport",
    "version": "1.0"
  }, {
    "emoji": "🛻",
    "category": 4,
    "name": "pick-up",
    "version": "13.0"
  }, {
    "emoji": "🚚",
    "category": 4,
    "name": "camion de livraison",
    "version": "1.0"
  }, {
    "emoji": "🚛",
    "category": 4,
    "name": "semi-remorque",
    "version": "1.0"
  }, {
    "emoji": "🚜",
    "category": 4,
    "name": "tracteur",
    "version": "1.0"
  }, {
    "emoji": "🏎️",
    "category": 4,
    "name": "racing car",
    "version": "1.0"
  }, {
    "emoji": "🏍️",
    "category": 4,
    "name": "motorcycle",
    "version": "1.0"
  }, {
    "emoji": "🛵",
    "category": 4,
    "name": "scooter",
    "version": "3.0"
  }, {
    "emoji": "🦽",
    "category": 4,
    "name": "fauteuil roulant manuel",
    "version": "12.0"
  }, {
    "emoji": "🦼",
    "category": 4,
    "name": "fauteuil motorisé",
    "version": "12.0"
  }, {
    "emoji": "🛺",
    "category": 4,
    "name": "tuk tuk",
    "version": "12.0"
  }, {
    "emoji": "🚲",
    "category": 4,
    "name": "vélo",
    "version": "1.0"
  }, {
    "emoji": "🛴",
    "category": 4,
    "name": "trottinette",
    "version": "3.0"
  }, {
    "emoji": "🛹",
    "category": 4,
    "name": "planche à roulettes",
    "version": "11.0"
  }, {
    "emoji": "🛼",
    "category": 4,
    "name": "patin à roulettes",
    "version": "13.0"
  }, {
    "emoji": "🚏",
    "category": 4,
    "name": "arrêt de bus",
    "version": "1.0"
  }, {
    "emoji": "🛣️",
    "category": 4,
    "name": "motorway",
    "version": "1.0"
  }, {
    "emoji": "🛤️",
    "category": 4,
    "name": "railway track",
    "version": "1.0"
  }, {
    "emoji": "🛢️",
    "category": 4,
    "name": "oil drum",
    "version": "1.0"
  }, {
    "emoji": "⛽",
    "category": 4,
    "name": "pompe à essence",
    "version": "1.0"
  }, {
    "emoji": "🚨",
    "category": 4,
    "name": "gyrophare",
    "version": "1.0"
  }, {
    "emoji": "🚥",
    "category": 4,
    "name": "feu tricolore horizontal",
    "version": "1.0"
  }, {
    "emoji": "🚦",
    "category": 4,
    "name": "feu tricolore vertical",
    "version": "1.0"
  }, {
    "emoji": "🛑",
    "category": 4,
    "name": "stop",
    "version": "3.0"
  }, {
    "emoji": "🚧",
    "category": 4,
    "name": "travaux",
    "version": "1.0"
  }, {
    "emoji": "⚓",
    "category": 4,
    "name": "ancre",
    "version": "1.0"
  }, {
    "emoji": "⛵",
    "category": 4,
    "name": "voilier",
    "version": "1.0"
  }, {
    "emoji": "🛶",
    "category": 4,
    "name": "canoë",
    "version": "3.0"
  }, {
    "emoji": "🚤",
    "category": 4,
    "name": "hors-bord",
    "version": "1.0"
  }, {
    "emoji": "🛳️",
    "category": 4,
    "name": "passenger ship",
    "version": "1.0"
  }, {
    "emoji": "⛴️",
    "category": 4,
    "name": "ferry",
    "version": "1.0"
  }, {
    "emoji": "🛥️",
    "category": 4,
    "name": "motor boat",
    "version": "1.0"
  }, {
    "emoji": "🚢",
    "category": 4,
    "name": "navire",
    "version": "1.0"
  }, {
    "emoji": "✈️",
    "category": 4,
    "name": "airplane",
    "version": "1.0"
  }, {
    "emoji": "🛩️",
    "category": 4,
    "name": "small airplane",
    "version": "1.0"
  }, {
    "emoji": "🛫",
    "category": 4,
    "name": "avion au décollage",
    "version": "1.0"
  }, {
    "emoji": "🛬",
    "category": 4,
    "name": "avion à l’atterrissage",
    "version": "1.0"
  }, {
    "emoji": "🪂",
    "category": 4,
    "name": "parachute",
    "version": "12.0"
  }, {
    "emoji": "💺",
    "category": 4,
    "name": "siège",
    "version": "1.0"
  }, {
    "emoji": "🚁",
    "category": 4,
    "name": "hélicoptère",
    "version": "1.0"
  }, {
    "emoji": "🚟",
    "category": 4,
    "name": "train suspendu",
    "version": "1.0"
  }, {
    "emoji": "🚠",
    "category": 4,
    "name": "téléphérique",
    "version": "1.0"
  }, {
    "emoji": "🚡",
    "category": 4,
    "name": "tramway aérien",
    "version": "1.0"
  }, {
    "emoji": "🛰️",
    "category": 4,
    "name": "satellite",
    "version": "1.0"
  }, {
    "emoji": "🚀",
    "category": 4,
    "name": "fusée",
    "version": "1.0"
  }, {
    "emoji": "🛸",
    "category": 4,
    "name": "soucoupe volante",
    "version": "5.0"
  }, {
    "emoji": "🛎️",
    "category": 4,
    "name": "bellhop bell",
    "version": "1.0"
  }, {
    "emoji": "🧳",
    "category": 4,
    "name": "bagage",
    "version": "11.0"
  }, {
    "emoji": "⌛",
    "category": 4,
    "name": "sablier",
    "version": "1.0"
  }, {
    "emoji": "⏳",
    "category": 4,
    "name": "sablier avec sable qui coule",
    "version": "1.0"
  }, {
    "emoji": "⌚",
    "category": 4,
    "name": "montre",
    "version": "1.0"
  }, {
    "emoji": "⏰",
    "category": 4,
    "name": "réveil",
    "version": "1.0"
  }, {
    "emoji": "⏱️",
    "category": 4,
    "name": "stopwatch",
    "version": "1.0"
  }, {
    "emoji": "⏲️",
    "category": 4,
    "name": "timer clock",
    "version": "1.0"
  }, {
    "emoji": "🕰️",
    "category": 4,
    "name": "mantelpiece clock",
    "version": "1.0"
  }, {
    "emoji": "🕛",
    "category": 4,
    "name": "midi/minuit",
    "version": "1.0"
  }, {
    "emoji": "🕧",
    "category": 4,
    "name": "midi/minuit et demie",
    "version": "1.0"
  }, {
    "emoji": "🕐",
    "category": 4,
    "name": "une heure",
    "version": "1.0"
  }, {
    "emoji": "🕜",
    "category": 4,
    "name": "une heure et demie",
    "version": "1.0"
  }, {
    "emoji": "🕑",
    "category": 4,
    "name": "deux heures",
    "version": "1.0"
  }, {
    "emoji": "🕝",
    "category": 4,
    "name": "deux heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕒",
    "category": 4,
    "name": "trois heures",
    "version": "1.0"
  }, {
    "emoji": "🕞",
    "category": 4,
    "name": "trois heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕓",
    "category": 4,
    "name": "quatre heures",
    "version": "1.0"
  }, {
    "emoji": "🕟",
    "category": 4,
    "name": "quatre heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕔",
    "category": 4,
    "name": "cinq heures",
    "version": "1.0"
  }, {
    "emoji": "🕠",
    "category": 4,
    "name": "cinq heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕕",
    "category": 4,
    "name": "six heures",
    "version": "1.0"
  }, {
    "emoji": "🕡",
    "category": 4,
    "name": "six heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕖",
    "category": 4,
    "name": "sept heures",
    "version": "1.0"
  }, {
    "emoji": "🕢",
    "category": 4,
    "name": "sept heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕗",
    "category": 4,
    "name": "huit heures",
    "version": "1.0"
  }, {
    "emoji": "🕣",
    "category": 4,
    "name": "huit heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕘",
    "category": 4,
    "name": "neuf heures",
    "version": "1.0"
  }, {
    "emoji": "🕤",
    "category": 4,
    "name": "neuf heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕙",
    "category": 4,
    "name": "dix heures",
    "version": "1.0"
  }, {
    "emoji": "🕥",
    "category": 4,
    "name": "dix heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🕚",
    "category": 4,
    "name": "onze heures",
    "version": "1.0"
  }, {
    "emoji": "🕦",
    "category": 4,
    "name": "onze heures et demie",
    "version": "1.0"
  }, {
    "emoji": "🌑",
    "category": 4,
    "name": "nouvelle lune",
    "version": "1.0"
  }, {
    "emoji": "🌒",
    "category": 4,
    "name": "lune croissante",
    "version": "1.0"
  }, {
    "emoji": "🌓",
    "category": 4,
    "name": "premier quartier de lune",
    "version": "1.0"
  }, {
    "emoji": "🌔",
    "category": 4,
    "name": "lune gibbeuse croissante",
    "version": "1.0"
  }, {
    "emoji": "🌕",
    "category": 4,
    "name": "pleine lune",
    "version": "1.0"
  }, {
    "emoji": "🌖",
    "category": 4,
    "name": "lune gibbeuse décroissante",
    "version": "1.0"
  }, {
    "emoji": "🌗",
    "category": 4,
    "name": "dernier quartier",
    "version": "1.0"
  }, {
    "emoji": "🌘",
    "category": 4,
    "name": "lune décroissante",
    "version": "1.0"
  }, {
    "emoji": "🌙",
    "category": 4,
    "name": "croissant de lune",
    "version": "1.0"
  }, {
    "emoji": "🌚",
    "category": 4,
    "name": "nouvelle lune avec visage",
    "version": "1.0"
  }, {
    "emoji": "🌛",
    "category": 4,
    "name": "premier quartier de lune avec visage",
    "version": "1.0"
  }, {
    "emoji": "🌜",
    "category": 4,
    "name": "dernier quartier de lune avec visage",
    "version": "1.0"
  }, {
    "emoji": "🌡️",
    "category": 4,
    "name": "thermometer",
    "version": "1.0"
  }, {
    "emoji": "☀️",
    "category": 4,
    "name": "sun",
    "version": "1.0"
  }, {
    "emoji": "🌝",
    "category": 4,
    "name": "pleine lune avec visage",
    "version": "1.0"
  }, {
    "emoji": "🌞",
    "category": 4,
    "name": "soleil avec visage",
    "version": "1.0"
  }, {
    "emoji": "🪐",
    "category": 4,
    "name": "planète à anneaux",
    "version": "12.0"
  }, {
    "emoji": "⭐",
    "category": 4,
    "name": "étoile",
    "version": "1.0"
  }, {
    "emoji": "🌟",
    "category": 4,
    "name": "étoile brillante",
    "version": "1.0"
  }, {
    "emoji": "🌠",
    "category": 4,
    "name": "étoile filante",
    "version": "1.0"
  }, {
    "emoji": "🌌",
    "category": 4,
    "name": "voie lactée",
    "version": "1.0"
  }, {
    "emoji": "☁️",
    "category": 4,
    "name": "cloud",
    "version": "1.0"
  }, {
    "emoji": "⛅",
    "category": 4,
    "name": "soleil derrière les nuages",
    "version": "1.0"
  }, {
    "emoji": "⛈️",
    "category": 4,
    "name": "cloud with lightning and rain",
    "version": "1.0"
  }, {
    "emoji": "🌤️",
    "category": 4,
    "name": "sun behind small cloud",
    "version": "1.0"
  }, {
    "emoji": "🌥️",
    "category": 4,
    "name": "sun behind large cloud",
    "version": "1.0"
  }, {
    "emoji": "🌦️",
    "category": 4,
    "name": "sun behind rain cloud",
    "version": "1.0"
  }, {
    "emoji": "🌧️",
    "category": 4,
    "name": "cloud with rain",
    "version": "1.0"
  }, {
    "emoji": "🌨️",
    "category": 4,
    "name": "cloud with snow",
    "version": "1.0"
  }, {
    "emoji": "🌩️",
    "category": 4,
    "name": "cloud with lightning",
    "version": "1.0"
  }, {
    "emoji": "🌪️",
    "category": 4,
    "name": "tornado",
    "version": "1.0"
  }, {
    "emoji": "🌫️",
    "category": 4,
    "name": "fog",
    "version": "1.0"
  }, {
    "emoji": "🌬️",
    "category": 4,
    "name": "wind face",
    "version": "1.0"
  }, {
    "emoji": "🌀",
    "category": 4,
    "name": "cyclone",
    "version": "1.0"
  }, {
    "emoji": "🌈",
    "category": 4,
    "name": "arc-en-ciel",
    "version": "1.0"
  }, {
    "emoji": "🌂",
    "category": 4,
    "name": "parapluie fermé",
    "version": "1.0"
  }, {
    "emoji": "☂️",
    "category": 4,
    "name": "umbrella",
    "version": "1.0"
  }, {
    "emoji": "☔",
    "category": 4,
    "name": "parapluie avec gouttes de pluie",
    "version": "1.0"
  }, {
    "emoji": "⛱️",
    "category": 4,
    "name": "umbrella on ground",
    "version": "1.0"
  }, {
    "emoji": "⚡",
    "category": 4,
    "name": "haute tension",
    "version": "1.0"
  }, {
    "emoji": "❄️",
    "category": 4,
    "name": "snowflake",
    "version": "1.0"
  }, {
    "emoji": "☃️",
    "category": 4,
    "name": "snowman",
    "version": "1.0"
  }, {
    "emoji": "⛄",
    "category": 4,
    "name": "bonhomme de neige sans neige",
    "version": "1.0"
  }, {
    "emoji": "☄️",
    "category": 4,
    "name": "comet",
    "version": "1.0"
  }, {
    "emoji": "🔥",
    "category": 4,
    "name": "feu",
    "version": "1.0"
  }, {
    "emoji": "💧",
    "category": 4,
    "name": "goutte d’eau",
    "version": "1.0"
  }, {
    "emoji": "🌊",
    "category": 4,
    "name": "vague",
    "version": "1.0"
  }, {
    "emoji": "🎃",
    "category": 5,
    "name": "citrouille",
    "version": "1.0"
  }, {
    "emoji": "🎄",
    "category": 5,
    "name": "sapin de Noël",
    "version": "1.0"
  }, {
    "emoji": "🎆",
    "category": 5,
    "name": "feu d’artifice",
    "version": "1.0"
  }, {
    "emoji": "🎇",
    "category": 5,
    "name": "cierge magique",
    "version": "1.0"
  }, {
    "emoji": "🧨",
    "category": 5,
    "name": "pétard",
    "version": "11.0"
  }, {
    "emoji": "✨",
    "category": 5,
    "name": "étincelles",
    "version": "1.0"
  }, {
    "emoji": "🎈",
    "category": 5,
    "name": "ballon gonflable",
    "version": "1.0"
  }, {
    "emoji": "🎉",
    "category": 5,
    "name": "cotillons",
    "version": "1.0"
  }, {
    "emoji": "🎊",
    "category": 5,
    "name": "confettis",
    "version": "1.0"
  }, {
    "emoji": "🎋",
    "category": 5,
    "name": "arbre à vœux",
    "version": "1.0"
  }, {
    "emoji": "🎍",
    "category": 5,
    "name": "bambou décoratif",
    "version": "1.0"
  }, {
    "emoji": "🎎",
    "category": 5,
    "name": "poupées japonaises",
    "version": "1.0"
  }, {
    "emoji": "🎏",
    "category": 5,
    "name": "koinobori",
    "version": "1.0"
  }, {
    "emoji": "🎐",
    "category": 5,
    "name": "carillon éolien",
    "version": "1.0"
  }, {
    "emoji": "🎑",
    "category": 5,
    "name": "cérémonie de la lune",
    "version": "1.0"
  }, {
    "emoji": "🧧",
    "category": 5,
    "name": "enveloppe rouge",
    "version": "11.0"
  }, {
    "emoji": "🎀",
    "category": 5,
    "name": "ruban",
    "version": "1.0"
  }, {
    "emoji": "🎁",
    "category": 5,
    "name": "cadeau",
    "version": "1.0"
  }, {
    "emoji": "🎗️",
    "category": 5,
    "name": "reminder ribbon",
    "version": "1.0"
  }, {
    "emoji": "🎟️",
    "category": 5,
    "name": "admission tickets",
    "version": "1.0"
  }, {
    "emoji": "🎫",
    "category": 5,
    "name": "billet",
    "version": "1.0"
  }, {
    "emoji": "🎖️",
    "category": 5,
    "name": "military medal",
    "version": "1.0"
  }, {
    "emoji": "🏆",
    "category": 5,
    "name": "trophée",
    "version": "1.0"
  }, {
    "emoji": "🏅",
    "category": 5,
    "name": "médaille sportive",
    "version": "1.0"
  }, {
    "emoji": "🥇",
    "category": 5,
    "name": "médaille d’or",
    "version": "3.0"
  }, {
    "emoji": "🥈",
    "category": 5,
    "name": "médaille d’argent",
    "version": "3.0"
  }, {
    "emoji": "🥉",
    "category": 5,
    "name": "médaille de bronze",
    "version": "3.0"
  }, {
    "emoji": "⚽",
    "category": 5,
    "name": "ballon de football",
    "version": "1.0"
  }, {
    "emoji": "⚾",
    "category": 5,
    "name": "baseball",
    "version": "1.0"
  }, {
    "emoji": "🥎",
    "category": 5,
    "name": "softball",
    "version": "11.0"
  }, {
    "emoji": "🏀",
    "category": 5,
    "name": "basket",
    "version": "1.0"
  }, {
    "emoji": "🏐",
    "category": 5,
    "name": "volley-ball",
    "version": "1.0"
  }, {
    "emoji": "🏈",
    "category": 5,
    "name": "football américain",
    "version": "1.0"
  }, {
    "emoji": "🏉",
    "category": 5,
    "name": "rugby",
    "version": "1.0"
  }, {
    "emoji": "🎾",
    "category": 5,
    "name": "tennis",
    "version": "1.0"
  }, {
    "emoji": "🥏",
    "category": 5,
    "name": "disque volant",
    "version": "11.0"
  }, {
    "emoji": "🎳",
    "category": 5,
    "name": "bowling",
    "version": "1.0"
  }, {
    "emoji": "🏏",
    "category": 5,
    "name": "cricket",
    "version": "1.0"
  }, {
    "emoji": "🏑",
    "category": 5,
    "name": "hockey sur gazon",
    "version": "1.0"
  }, {
    "emoji": "🏒",
    "category": 5,
    "name": "hockey sur glace",
    "version": "1.0"
  }, {
    "emoji": "🥍",
    "category": 5,
    "name": "crosse",
    "version": "11.0"
  }, {
    "emoji": "🏓",
    "category": 5,
    "name": "ping-pong",
    "version": "1.0"
  }, {
    "emoji": "🏸",
    "category": 5,
    "name": "badminton",
    "version": "1.0"
  }, {
    "emoji": "🥊",
    "category": 5,
    "name": "gant de boxe",
    "version": "3.0"
  }, {
    "emoji": "🥋",
    "category": 5,
    "name": "tenue d’arts martiaux",
    "version": "3.0"
  }, {
    "emoji": "🥅",
    "category": 5,
    "name": "cage",
    "version": "3.0"
  }, {
    "emoji": "⛳",
    "category": 5,
    "name": "drapeau de golf",
    "version": "1.0"
  }, {
    "emoji": "⛸️",
    "category": 5,
    "name": "ice skate",
    "version": "1.0"
  }, {
    "emoji": "🎣",
    "category": 5,
    "name": "pêche à la ligne",
    "version": "1.0"
  }, {
    "emoji": "🤿",
    "category": 5,
    "name": "masque de plongée",
    "version": "12.0"
  }, {
    "emoji": "🎽",
    "category": 5,
    "name": "maillot de course",
    "version": "1.0"
  }, {
    "emoji": "🎿",
    "category": 5,
    "name": "ski",
    "version": "1.0"
  }, {
    "emoji": "🛷",
    "category": 5,
    "name": "luge",
    "version": "5.0"
  }, {
    "emoji": "🥌",
    "category": 5,
    "name": "pierre de curling",
    "version": "5.0"
  }, {
    "emoji": "🎯",
    "category": 5,
    "name": "dans le mille",
    "version": "1.0"
  }, {
    "emoji": "🪀",
    "category": 5,
    "name": "yoyo",
    "version": "12.0"
  }, {
    "emoji": "🪁",
    "category": 5,
    "name": "cerf-volant",
    "version": "12.0"
  }, {
    "emoji": "🎱",
    "category": 5,
    "name": "boule de billard",
    "version": "1.0"
  }, {
    "emoji": "🔮",
    "category": 5,
    "name": "boule de cristal",
    "version": "1.0"
  }, {
    "emoji": "🪄",
    "category": 5,
    "name": "baguette magique",
    "version": "13.0"
  }, {
    "emoji": "🧿",
    "category": 5,
    "name": "mauvais œil",
    "version": "11.0"
  }, {
    "emoji": "🎮",
    "category": 5,
    "name": "jeu vidéo",
    "version": "1.0"
  }, {
    "emoji": "🕹️",
    "category": 5,
    "name": "joystick",
    "version": "1.0"
  }, {
    "emoji": "🎰",
    "category": 5,
    "name": "machine à sous",
    "version": "1.0"
  }, {
    "emoji": "🎲",
    "category": 5,
    "name": "dés",
    "version": "1.0"
  }, {
    "emoji": "🧩",
    "category": 5,
    "name": "pièce de puzzle",
    "version": "11.0"
  }, {
    "emoji": "🧸",
    "category": 5,
    "name": "ours en peluche",
    "version": "11.0"
  }, {
    "emoji": "🪅",
    "category": 5,
    "name": "piñata",
    "version": "13.0"
  }, {
    "emoji": "🪆",
    "category": 5,
    "name": "poupées russes",
    "version": "13.0"
  }, {
    "emoji": "♠️",
    "category": 5,
    "name": "spade suit",
    "version": "1.0"
  }, {
    "emoji": "♥️",
    "category": 5,
    "name": "heart suit",
    "version": "1.0"
  }, {
    "emoji": "♦️",
    "category": 5,
    "name": "diamond suit",
    "version": "1.0"
  }, {
    "emoji": "♣️",
    "category": 5,
    "name": "club suit",
    "version": "1.0"
  }, {
    "emoji": "♟️",
    "category": 5,
    "name": "chess pawn",
    "version": "11.0"
  }, {
    "emoji": "🃏",
    "category": 5,
    "name": "carte Joker",
    "version": "1.0"
  }, {
    "emoji": "🀄",
    "category": 5,
    "name": "dragon rouge mahjong",
    "version": "1.0"
  }, {
    "emoji": "🎴",
    "category": 5,
    "name": "jeu des fleurs",
    "version": "1.0"
  }, {
    "emoji": "🎭",
    "category": 5,
    "name": "spectacle vivant",
    "version": "1.0"
  }, {
    "emoji": "🖼️",
    "category": 5,
    "name": "framed picture",
    "version": "1.0"
  }, {
    "emoji": "🎨",
    "category": 5,
    "name": "palette de peinture",
    "version": "1.0"
  }, {
    "emoji": "🧵",
    "category": 5,
    "name": "bobine de fil",
    "version": "11.0"
  }, {
    "emoji": "🪡",
    "category": 5,
    "name": "aiguille à coudre",
    "version": "13.0"
  }, {
    "emoji": "🧶",
    "category": 5,
    "name": "fil",
    "version": "11.0"
  }, {
    "emoji": "🪢",
    "category": 5,
    "name": "nœud",
    "version": "13.0"
  }, {
    "emoji": "👓",
    "category": 6,
    "name": "lunettes de vue",
    "version": "1.0"
  }, {
    "emoji": "🕶️",
    "category": 6,
    "name": "sunglasses",
    "version": "1.0"
  }, {
    "emoji": "🥽",
    "category": 6,
    "name": "lunettes",
    "version": "11.0"
  }, {
    "emoji": "🥼",
    "category": 6,
    "name": "blouse blanche",
    "version": "11.0"
  }, {
    "emoji": "🦺",
    "category": 6,
    "name": "gilet de sécurité",
    "version": "12.0"
  }, {
    "emoji": "👔",
    "category": 6,
    "name": "cravate",
    "version": "1.0"
  }, {
    "emoji": "👕",
    "category": 6,
    "name": "T-shirt",
    "version": "1.0"
  }, {
    "emoji": "👖",
    "category": 6,
    "name": "jean",
    "version": "1.0"
  }, {
    "emoji": "🧣",
    "category": 6,
    "name": "foulard",
    "version": "5.0"
  }, {
    "emoji": "🧤",
    "category": 6,
    "name": "gants",
    "version": "5.0"
  }, {
    "emoji": "🧥",
    "category": 6,
    "name": "manteau",
    "version": "5.0"
  }, {
    "emoji": "🧦",
    "category": 6,
    "name": "chaussettes",
    "version": "5.0"
  }, {
    "emoji": "👗",
    "category": 6,
    "name": "robe",
    "version": "1.0"
  }, {
    "emoji": "👘",
    "category": 6,
    "name": "kimono",
    "version": "1.0"
  }, {
    "emoji": "🥻",
    "category": 6,
    "name": "sari",
    "version": "12.0"
  }, {
    "emoji": "🩱",
    "category": 6,
    "name": "maillot de bain une pièce",
    "version": "12.0"
  }, {
    "emoji": "🩲",
    "category": 6,
    "name": "slip",
    "version": "12.0"
  }, {
    "emoji": "🩳",
    "category": 6,
    "name": "short",
    "version": "12.0"
  }, {
    "emoji": "👙",
    "category": 6,
    "name": "bikini",
    "version": "1.0"
  }, {
    "emoji": "👚",
    "category": 6,
    "name": "vêtements de femme",
    "version": "1.0"
  }, {
    "emoji": "👛",
    "category": 6,
    "name": "porte-monnaie",
    "version": "1.0"
  }, {
    "emoji": "👜",
    "category": 6,
    "name": "sac à main",
    "version": "1.0"
  }, {
    "emoji": "👝",
    "category": 6,
    "name": "pochette",
    "version": "1.0"
  }, {
    "emoji": "🛍️",
    "category": 6,
    "name": "shopping bags",
    "version": "1.0"
  }, {
    "emoji": "🎒",
    "category": 6,
    "name": "cartable",
    "version": "1.0"
  }, {
    "emoji": "🩴",
    "category": 6,
    "name": "tong",
    "version": "13.0"
  }, {
    "emoji": "👞",
    "category": 6,
    "name": "chaussure d’homme",
    "version": "1.0"
  }, {
    "emoji": "👟",
    "category": 6,
    "name": "chaussure de sport",
    "version": "1.0"
  }, {
    "emoji": "🥾",
    "category": 6,
    "name": "chaussure de randonnée",
    "version": "11.0"
  }, {
    "emoji": "🥿",
    "category": 6,
    "name": "chaussure plate",
    "version": "11.0"
  }, {
    "emoji": "👠",
    "category": 6,
    "name": "chaussure à talon haut",
    "version": "1.0"
  }, {
    "emoji": "👡",
    "category": 6,
    "name": "sandale de femme",
    "version": "1.0"
  }, {
    "emoji": "🩰",
    "category": 6,
    "name": "chaussons de danse",
    "version": "12.0"
  }, {
    "emoji": "👢",
    "category": 6,
    "name": "botte de femme",
    "version": "1.0"
  }, {
    "emoji": "👑",
    "category": 6,
    "name": "couronne",
    "version": "1.0"
  }, {
    "emoji": "👒",
    "category": 6,
    "name": "chapeau de femme",
    "version": "1.0"
  }, {
    "emoji": "🎩",
    "category": 6,
    "name": "haut de forme",
    "version": "1.0"
  }, {
    "emoji": "🎓",
    "category": 6,
    "name": "toque universitaire",
    "version": "1.0"
  }, {
    "emoji": "🧢",
    "category": 6,
    "name": "casquette américaine",
    "version": "5.0"
  }, {
    "emoji": "🪖",
    "category": 6,
    "name": "casque militaire",
    "version": "13.0"
  }, {
    "emoji": "⛑️",
    "category": 6,
    "name": "rescue worker’s helmet",
    "version": "1.0"
  }, {
    "emoji": "📿",
    "category": 6,
    "name": "chapelet",
    "version": "1.0"
  }, {
    "emoji": "💄",
    "category": 6,
    "name": "rouge à lèvres",
    "version": "1.0"
  }, {
    "emoji": "💍",
    "category": 6,
    "name": "bague",
    "version": "1.0"
  }, {
    "emoji": "💎",
    "category": 6,
    "name": "pierre précieuse",
    "version": "1.0"
  }, {
    "emoji": "🔇",
    "category": 6,
    "name": "muet",
    "version": "1.0"
  }, {
    "emoji": "🔈",
    "category": 6,
    "name": "volume des enceintes faible",
    "version": "1.0"
  }, {
    "emoji": "🔉",
    "category": 6,
    "name": "volume des enceintes moyen",
    "version": "1.0"
  }, {
    "emoji": "🔊",
    "category": 6,
    "name": "volume des enceintes élevé",
    "version": "1.0"
  }, {
    "emoji": "📢",
    "category": 6,
    "name": "haut-parleur",
    "version": "1.0"
  }, {
    "emoji": "📣",
    "category": 6,
    "name": "porte-voix",
    "version": "1.0"
  }, {
    "emoji": "📯",
    "category": 6,
    "name": "cor postal",
    "version": "1.0"
  }, {
    "emoji": "🔔",
    "category": 6,
    "name": "cloche",
    "version": "1.0"
  }, {
    "emoji": "🔕",
    "category": 6,
    "name": "alarme désactivée",
    "version": "1.0"
  }, {
    "emoji": "🎼",
    "category": 6,
    "name": "partition",
    "version": "1.0"
  }, {
    "emoji": "🎵",
    "category": 6,
    "name": "note de musique",
    "version": "1.0"
  }, {
    "emoji": "🎶",
    "category": 6,
    "name": "notes de musique",
    "version": "1.0"
  }, {
    "emoji": "🎙️",
    "category": 6,
    "name": "studio microphone",
    "version": "1.0"
  }, {
    "emoji": "🎚️",
    "category": 6,
    "name": "level slider",
    "version": "1.0"
  }, {
    "emoji": "🎛️",
    "category": 6,
    "name": "control knobs",
    "version": "1.0"
  }, {
    "emoji": "🎤",
    "category": 6,
    "name": "micro",
    "version": "1.0"
  }, {
    "emoji": "🎧",
    "category": 6,
    "name": "casque",
    "version": "1.0"
  }, {
    "emoji": "📻",
    "category": 6,
    "name": "radio",
    "version": "1.0"
  }, {
    "emoji": "🎷",
    "category": 6,
    "name": "saxophone",
    "version": "1.0"
  }, {
    "emoji": "🪗",
    "category": 6,
    "name": "accordéon",
    "version": "13.0"
  }, {
    "emoji": "🎸",
    "category": 6,
    "name": "guitare",
    "version": "1.0"
  }, {
    "emoji": "🎹",
    "category": 6,
    "name": "piano",
    "version": "1.0"
  }, {
    "emoji": "🎺",
    "category": 6,
    "name": "trompette",
    "version": "1.0"
  }, {
    "emoji": "🎻",
    "category": 6,
    "name": "violon",
    "version": "1.0"
  }, {
    "emoji": "🪕",
    "category": 6,
    "name": "banjo",
    "version": "12.0"
  }, {
    "emoji": "🥁",
    "category": 6,
    "name": "batterie",
    "version": "3.0"
  }, {
    "emoji": "🪘",
    "category": 6,
    "name": "djembé",
    "version": "13.0"
  }, {
    "emoji": "📱",
    "category": 6,
    "name": "téléphone portable",
    "version": "1.0"
  }, {
    "emoji": "📲",
    "category": 6,
    "name": "appel entrant",
    "version": "1.0"
  }, {
    "emoji": "☎️",
    "category": 6,
    "name": "telephone",
    "version": "1.0"
  }, {
    "emoji": "📞",
    "category": 6,
    "name": "combiné téléphonique",
    "version": "1.0"
  }, {
    "emoji": "📟",
    "category": 6,
    "name": "bipeur",
    "version": "1.0"
  }, {
    "emoji": "📠",
    "category": 6,
    "name": "fax",
    "version": "1.0"
  }, {
    "emoji": "🔋",
    "category": 6,
    "name": "pile",
    "version": "1.0"
  }, {
    "emoji": "🔌",
    "category": 6,
    "name": "câble avec fiche électrique",
    "version": "1.0"
  }, {
    "emoji": "💻",
    "category": 6,
    "name": "ordinateur portable",
    "version": "1.0"
  }, {
    "emoji": "🖥️",
    "category": 6,
    "name": "desktop computer",
    "version": "1.0"
  }, {
    "emoji": "🖨️",
    "category": 6,
    "name": "printer",
    "version": "1.0"
  }, {
    "emoji": "⌨️",
    "category": 6,
    "name": "keyboard",
    "version": "1.0"
  }, {
    "emoji": "🖱️",
    "category": 6,
    "name": "computer mouse",
    "version": "1.0"
  }, {
    "emoji": "🖲️",
    "category": 6,
    "name": "trackball",
    "version": "1.0"
  }, {
    "emoji": "💽",
    "category": 6,
    "name": "disque d’ordinateur",
    "version": "1.0"
  }, {
    "emoji": "💾",
    "category": 6,
    "name": "disquette",
    "version": "1.0"
  }, {
    "emoji": "💿",
    "category": 6,
    "name": "CD",
    "version": "1.0"
  }, {
    "emoji": "📀",
    "category": 6,
    "name": "DVD",
    "version": "1.0"
  }, {
    "emoji": "🧮",
    "category": 6,
    "name": "abaque",
    "version": "11.0"
  }, {
    "emoji": "🎥",
    "category": 6,
    "name": "caméra",
    "version": "1.0"
  }, {
    "emoji": "🎞️",
    "category": 6,
    "name": "film frames",
    "version": "1.0"
  }, {
    "emoji": "📽️",
    "category": 6,
    "name": "film projector",
    "version": "1.0"
  }, {
    "emoji": "🎬",
    "category": 6,
    "name": "clap",
    "version": "1.0"
  }, {
    "emoji": "📺",
    "category": 6,
    "name": "téléviseur",
    "version": "1.0"
  }, {
    "emoji": "📷",
    "category": 6,
    "name": "appareil photo",
    "version": "1.0"
  }, {
    "emoji": "📸",
    "category": 6,
    "name": "appareil photo avec flash",
    "version": "1.0"
  }, {
    "emoji": "📹",
    "category": 6,
    "name": "caméscope",
    "version": "1.0"
  }, {
    "emoji": "📼",
    "category": 6,
    "name": "cassette vidéo",
    "version": "1.0"
  }, {
    "emoji": "🔍",
    "category": 6,
    "name": "loupe orientée à gauche",
    "version": "1.0"
  }, {
    "emoji": "🔎",
    "category": 6,
    "name": "loupe orientée à droite",
    "version": "1.0"
  }, {
    "emoji": "🕯️",
    "category": 6,
    "name": "candle",
    "version": "1.0"
  }, {
    "emoji": "💡",
    "category": 6,
    "name": "ampoule",
    "version": "1.0"
  }, {
    "emoji": "🔦",
    "category": 6,
    "name": "torche",
    "version": "1.0"
  }, {
    "emoji": "🏮",
    "category": 6,
    "name": "lampion rouge",
    "version": "1.0"
  }, {
    "emoji": "🪔",
    "category": 6,
    "name": "diya",
    "version": "12.0"
  }, {
    "emoji": "📔",
    "category": 6,
    "name": "carnet avec couverture",
    "version": "1.0"
  }, {
    "emoji": "📕",
    "category": 6,
    "name": "livre fermé",
    "version": "1.0"
  }, {
    "emoji": "📖",
    "category": 6,
    "name": "livre ouvert",
    "version": "1.0"
  }, {
    "emoji": "📗",
    "category": 6,
    "name": "livre vert",
    "version": "1.0"
  }, {
    "emoji": "📘",
    "category": 6,
    "name": "livre bleu",
    "version": "1.0"
  }, {
    "emoji": "📙",
    "category": 6,
    "name": "livre orange",
    "version": "1.0"
  }, {
    "emoji": "📚",
    "category": 6,
    "name": "livres",
    "version": "1.0"
  }, {
    "emoji": "📓",
    "category": 6,
    "name": "carnet",
    "version": "1.0"
  }, {
    "emoji": "📒",
    "category": 6,
    "name": "carnet de compte",
    "version": "1.0"
  }, {
    "emoji": "📃",
    "category": 6,
    "name": "page enroulée",
    "version": "1.0"
  }, {
    "emoji": "📜",
    "category": 6,
    "name": "parchemin",
    "version": "1.0"
  }, {
    "emoji": "📄",
    "category": 6,
    "name": "page",
    "version": "1.0"
  }, {
    "emoji": "📰",
    "category": 6,
    "name": "journal",
    "version": "1.0"
  }, {
    "emoji": "🗞️",
    "category": 6,
    "name": "rolled-up newspaper",
    "version": "1.0"
  }, {
    "emoji": "📑",
    "category": 6,
    "name": "signets",
    "version": "1.0"
  }, {
    "emoji": "🔖",
    "category": 6,
    "name": "marque-page",
    "version": "1.0"
  }, {
    "emoji": "🏷️",
    "category": 6,
    "name": "label",
    "version": "1.0"
  }, {
    "emoji": "💰",
    "category": 6,
    "name": "sac plein d’argent",
    "version": "1.0"
  }, {
    "emoji": "🪙",
    "category": 6,
    "name": "pièce",
    "version": "13.0"
  }, {
    "emoji": "💴",
    "category": 6,
    "name": "billet en yens",
    "version": "1.0"
  }, {
    "emoji": "💵",
    "category": 6,
    "name": "billet en dollars",
    "version": "1.0"
  }, {
    "emoji": "💶",
    "category": 6,
    "name": "billet en euros",
    "version": "1.0"
  }, {
    "emoji": "💷",
    "category": 6,
    "name": "billet en livres",
    "version": "1.0"
  }, {
    "emoji": "💸",
    "category": 6,
    "name": "billet avec des ailes",
    "version": "1.0"
  }, {
    "emoji": "💳",
    "category": 6,
    "name": "carte bancaire",
    "version": "1.0"
  }, {
    "emoji": "🧾",
    "category": 6,
    "name": "reçu",
    "version": "11.0"
  }, {
    "emoji": "💹",
    "category": 6,
    "name": "courbe avec yen en hausse",
    "version": "1.0"
  }, {
    "emoji": "✉️",
    "category": 6,
    "name": "envelope",
    "version": "1.0"
  }, {
    "emoji": "📧",
    "category": 6,
    "name": "e-mail",
    "version": "1.0"
  }, {
    "emoji": "📨",
    "category": 6,
    "name": "message reçu",
    "version": "1.0"
  }, {
    "emoji": "📩",
    "category": 6,
    "name": "enveloppe avec flèche",
    "version": "1.0"
  }, {
    "emoji": "📤",
    "category": 6,
    "name": "boîte d’envoi",
    "version": "1.0"
  }, {
    "emoji": "📥",
    "category": 6,
    "name": "boîte de réception",
    "version": "1.0"
  }, {
    "emoji": "📦",
    "category": 6,
    "name": "colis",
    "version": "1.0"
  }, {
    "emoji": "📫",
    "category": 6,
    "name": "boîte aux lettres fermée drapeau levé",
    "version": "1.0"
  }, {
    "emoji": "📪",
    "category": 6,
    "name": "boîte aux lettres fermée drapeau baissé",
    "version": "1.0"
  }, {
    "emoji": "📬",
    "category": 6,
    "name": "boîte aux lettres ouverte drapeau levé",
    "version": "1.0"
  }, {
    "emoji": "📭",
    "category": 6,
    "name": "boîte aux lettres ouverte drapeau baissé",
    "version": "1.0"
  }, {
    "emoji": "📮",
    "category": 6,
    "name": "boîte aux lettres",
    "version": "1.0"
  }, {
    "emoji": "🗳️",
    "category": 6,
    "name": "ballot box with ballot",
    "version": "1.0"
  }, {
    "emoji": "✏️",
    "category": 6,
    "name": "pencil",
    "version": "1.0"
  }, {
    "emoji": "✒️",
    "category": 6,
    "name": "black nib",
    "version": "1.0"
  }, {
    "emoji": "🖋️",
    "category": 6,
    "name": "fountain pen",
    "version": "1.0"
  }, {
    "emoji": "🖊️",
    "category": 6,
    "name": "pen",
    "version": "1.0"
  }, {
    "emoji": "🖌️",
    "category": 6,
    "name": "paintbrush",
    "version": "1.0"
  }, {
    "emoji": "🖍️",
    "category": 6,
    "name": "crayon",
    "version": "1.0"
  }, {
    "emoji": "📝",
    "category": 6,
    "name": "mémo",
    "version": "1.0"
  }, {
    "emoji": "💼",
    "category": 6,
    "name": "porte-documents",
    "version": "1.0"
  }, {
    "emoji": "📁",
    "category": 6,
    "name": "dossier",
    "version": "1.0"
  }, {
    "emoji": "📂",
    "category": 6,
    "name": "dossier ouvert",
    "version": "1.0"
  }, {
    "emoji": "🗂️",
    "category": 6,
    "name": "card index dividers",
    "version": "1.0"
  }, {
    "emoji": "📅",
    "category": 6,
    "name": "calendrier",
    "version": "1.0"
  }, {
    "emoji": "📆",
    "category": 6,
    "name": "éphéméride",
    "version": "1.0"
  }, {
    "emoji": "🗒️",
    "category": 6,
    "name": "spiral notepad",
    "version": "1.0"
  }, {
    "emoji": "🗓️",
    "category": 6,
    "name": "spiral calendar",
    "version": "1.0"
  }, {
    "emoji": "📇",
    "category": 6,
    "name": "carnet d’adresses",
    "version": "1.0"
  }, {
    "emoji": "📈",
    "category": 6,
    "name": "graphique en hausse",
    "version": "1.0"
  }, {
    "emoji": "📉",
    "category": 6,
    "name": "graphique en baisse",
    "version": "1.0"
  }, {
    "emoji": "📊",
    "category": 6,
    "name": "graphiques à barres",
    "version": "1.0"
  }, {
    "emoji": "📋",
    "category": 6,
    "name": "porte-bloc",
    "version": "1.0"
  }, {
    "emoji": "📌",
    "category": 6,
    "name": "punaise",
    "version": "1.0"
  }, {
    "emoji": "📍",
    "category": 6,
    "name": "épingle",
    "version": "1.0"
  }, {
    "emoji": "📎",
    "category": 6,
    "name": "trombone",
    "version": "1.0"
  }, {
    "emoji": "🖇️",
    "category": 6,
    "name": "linked paperclips",
    "version": "1.0"
  }, {
    "emoji": "📏",
    "category": 6,
    "name": "règle",
    "version": "1.0"
  }, {
    "emoji": "📐",
    "category": 6,
    "name": "équerre",
    "version": "1.0"
  }, {
    "emoji": "✂️",
    "category": 6,
    "name": "scissors",
    "version": "1.0"
  }, {
    "emoji": "🗃️",
    "category": 6,
    "name": "card file box",
    "version": "1.0"
  }, {
    "emoji": "🗄️",
    "category": 6,
    "name": "file cabinet",
    "version": "1.0"
  }, {
    "emoji": "🗑️",
    "category": 6,
    "name": "wastebasket",
    "version": "1.0"
  }, {
    "emoji": "🔒",
    "category": 6,
    "name": "cadenas fermé",
    "version": "1.0"
  }, {
    "emoji": "🔓",
    "category": 6,
    "name": "cadenas ouvert",
    "version": "1.0"
  }, {
    "emoji": "🔏",
    "category": 6,
    "name": "cadenas fermé avec stylo",
    "version": "1.0"
  }, {
    "emoji": "🔐",
    "category": 6,
    "name": "cadenas fermé avec clé",
    "version": "1.0"
  }, {
    "emoji": "🔑",
    "category": 6,
    "name": "clé",
    "version": "1.0"
  }, {
    "emoji": "🗝️",
    "category": 6,
    "name": "old key",
    "version": "1.0"
  }, {
    "emoji": "🔨",
    "category": 6,
    "name": "marteau",
    "version": "1.0"
  }, {
    "emoji": "🪓",
    "category": 6,
    "name": "hache",
    "version": "12.0"
  }, {
    "emoji": "⛏️",
    "category": 6,
    "name": "pick",
    "version": "1.0"
  }, {
    "emoji": "⚒️",
    "category": 6,
    "name": "hammer and pick",
    "version": "1.0"
  }, {
    "emoji": "🛠️",
    "category": 6,
    "name": "hammer and wrench",
    "version": "1.0"
  }, {
    "emoji": "🗡️",
    "category": 6,
    "name": "dagger",
    "version": "1.0"
  }, {
    "emoji": "⚔️",
    "category": 6,
    "name": "crossed swords",
    "version": "1.0"
  }, {
    "emoji": "🔫",
    "category": 6,
    "name": "pistolet à eau",
    "version": "1.0"
  }, {
    "emoji": "🪃",
    "category": 6,
    "name": "boomerang",
    "version": "13.0"
  }, {
    "emoji": "🏹",
    "category": 6,
    "name": "arc et flèche",
    "version": "1.0"
  }, {
    "emoji": "🛡️",
    "category": 6,
    "name": "shield",
    "version": "1.0"
  }, {
    "emoji": "🪚",
    "category": 6,
    "name": "scie",
    "version": "13.0"
  }, {
    "emoji": "🔧",
    "category": 6,
    "name": "clé à molette",
    "version": "1.0"
  }, {
    "emoji": "🪛",
    "category": 6,
    "name": "tournevis",
    "version": "13.0"
  }, {
    "emoji": "🔩",
    "category": 6,
    "name": "vis et écrou",
    "version": "1.0"
  }, {
    "emoji": "⚙️",
    "category": 6,
    "name": "gear",
    "version": "1.0"
  }, {
    "emoji": "🗜️",
    "category": 6,
    "name": "clamp",
    "version": "1.0"
  }, {
    "emoji": "⚖️",
    "category": 6,
    "name": "balance scale",
    "version": "1.0"
  }, {
    "emoji": "🦯",
    "category": 6,
    "name": "canne blanche",
    "version": "12.0"
  }, {
    "emoji": "🔗",
    "category": 6,
    "name": "chaînons",
    "version": "1.0"
  }, {
    "emoji": "⛓️",
    "category": 6,
    "name": "chains",
    "version": "1.0"
  }, {
    "emoji": "🪝",
    "category": 6,
    "name": "crochet",
    "version": "13.0"
  }, {
    "emoji": "🧰",
    "category": 6,
    "name": "boîte à outils",
    "version": "11.0"
  }, {
    "emoji": "🧲",
    "category": 6,
    "name": "aimant",
    "version": "11.0"
  }, {
    "emoji": "🪜",
    "category": 6,
    "name": "échelle",
    "version": "13.0"
  }, {
    "emoji": "⚗️",
    "category": 6,
    "name": "alembic",
    "version": "1.0"
  }, {
    "emoji": "🧪",
    "category": 6,
    "name": "tube à essai",
    "version": "11.0"
  }, {
    "emoji": "🧫",
    "category": 6,
    "name": "boîte de pétri",
    "version": "11.0"
  }, {
    "emoji": "🧬",
    "category": 6,
    "name": "adn",
    "version": "11.0"
  }, {
    "emoji": "🔬",
    "category": 6,
    "name": "microscope",
    "version": "1.0"
  }, {
    "emoji": "🔭",
    "category": 6,
    "name": "télescope",
    "version": "1.0"
  }, {
    "emoji": "📡",
    "category": 6,
    "name": "antenne satellite",
    "version": "1.0"
  }, {
    "emoji": "💉",
    "category": 6,
    "name": "seringue",
    "version": "1.0"
  }, {
    "emoji": "🩸",
    "category": 6,
    "name": "goutte de sang",
    "version": "12.0"
  }, {
    "emoji": "💊",
    "category": 6,
    "name": "pilule",
    "version": "1.0"
  }, {
    "emoji": "🩹",
    "category": 6,
    "name": "sparadrap",
    "version": "12.0"
  }, {
    "emoji": "🩺",
    "category": 6,
    "name": "stéthoscope",
    "version": "12.0"
  }, {
    "emoji": "🚪",
    "category": 6,
    "name": "porte",
    "version": "1.0"
  }, {
    "emoji": "🛗",
    "category": 6,
    "name": "ascenseur",
    "version": "13.0"
  }, {
    "emoji": "🪞",
    "category": 6,
    "name": "miroir",
    "version": "13.0"
  }, {
    "emoji": "🪟",
    "category": 6,
    "name": "fenêtre",
    "version": "13.0"
  }, {
    "emoji": "🛏️",
    "category": 6,
    "name": "bed",
    "version": "1.0"
  }, {
    "emoji": "🛋️",
    "category": 6,
    "name": "couch and lamp",
    "version": "1.0"
  }, {
    "emoji": "🪑",
    "category": 6,
    "name": "chaise",
    "version": "12.0"
  }, {
    "emoji": "🚽",
    "category": 6,
    "name": "toilettes",
    "version": "1.0"
  }, {
    "emoji": "🪠",
    "category": 6,
    "name": "ventouse",
    "version": "13.0"
  }, {
    "emoji": "🚿",
    "category": 6,
    "name": "douche",
    "version": "1.0"
  }, {
    "emoji": "🛁",
    "category": 6,
    "name": "baignoire",
    "version": "1.0"
  }, {
    "emoji": "🪤",
    "category": 6,
    "name": "tapette à souris",
    "version": "13.0"
  }, {
    "emoji": "🪒",
    "category": 6,
    "name": "rasoir",
    "version": "12.0"
  }, {
    "emoji": "🧴",
    "category": 6,
    "name": "bouteille de lotion",
    "version": "11.0"
  }, {
    "emoji": "🧷",
    "category": 6,
    "name": "épingle de sûreté",
    "version": "11.0"
  }, {
    "emoji": "🧹",
    "category": 6,
    "name": "balai",
    "version": "11.0"
  }, {
    "emoji": "🧺",
    "category": 6,
    "name": "panier",
    "version": "11.0"
  }, {
    "emoji": "🧻",
    "category": 6,
    "name": "rouleau de papier",
    "version": "11.0"
  }, {
    "emoji": "🪣",
    "category": 6,
    "name": "seau",
    "version": "13.0"
  }, {
    "emoji": "🧼",
    "category": 6,
    "name": "savon",
    "version": "11.0"
  }, {
    "emoji": "🪥",
    "category": 6,
    "name": "brosse à dents",
    "version": "13.0"
  }, {
    "emoji": "🧽",
    "category": 6,
    "name": "éponge",
    "version": "11.0"
  }, {
    "emoji": "🧯",
    "category": 6,
    "name": "extincteur",
    "version": "11.0"
  }, {
    "emoji": "🛒",
    "category": 6,
    "name": "chariot",
    "version": "3.0"
  }, {
    "emoji": "🚬",
    "category": 6,
    "name": "cigarette",
    "version": "1.0"
  }, {
    "emoji": "⚰️",
    "category": 6,
    "name": "coffin",
    "version": "1.0"
  }, {
    "emoji": "🪦",
    "category": 6,
    "name": "pierre tombale",
    "version": "13.0"
  }, {
    "emoji": "⚱️",
    "category": 6,
    "name": "funeral urn",
    "version": "1.0"
  }, {
    "emoji": "🗿",
    "category": 6,
    "name": "moai",
    "version": "1.0"
  }, {
    "emoji": "🪧",
    "category": 6,
    "name": "pancarte",
    "version": "13.0"
  }, {
    "emoji": "🏧",
    "category": 7,
    "name": "distributeur de billets",
    "version": "1.0"
  }, {
    "emoji": "🚮",
    "category": 7,
    "name": "icône Poubelle",
    "version": "1.0"
  }, {
    "emoji": "🚰",
    "category": 7,
    "name": "eau potable",
    "version": "1.0"
  }, {
    "emoji": "♿",
    "category": 7,
    "name": "symbole Accès handicapés",
    "version": "1.0"
  }, {
    "emoji": "🚹",
    "category": 7,
    "name": "symbole Toilettes hommes",
    "version": "1.0"
  }, {
    "emoji": "🚺",
    "category": 7,
    "name": "symbole Toilettes femmes",
    "version": "1.0"
  }, {
    "emoji": "🚻",
    "category": 7,
    "name": "panneau Toilettes",
    "version": "1.0"
  }, {
    "emoji": "🚼",
    "category": 7,
    "name": "symbole Bébé",
    "version": "1.0"
  }, {
    "emoji": "🚾",
    "category": 7,
    "name": "WC",
    "version": "1.0"
  }, {
    "emoji": "🛂",
    "category": 7,
    "name": "contrôle des passeports",
    "version": "1.0"
  }, {
    "emoji": "🛃",
    "category": 7,
    "name": "douane",
    "version": "1.0"
  }, {
    "emoji": "🛄",
    "category": 7,
    "name": "retrait des bagages",
    "version": "1.0"
  }, {
    "emoji": "🛅",
    "category": 7,
    "name": "consigne",
    "version": "1.0"
  }, {
    "emoji": "⚠️",
    "category": 7,
    "name": "warning",
    "version": "1.0"
  }, {
    "emoji": "🚸",
    "category": 7,
    "name": "traversée d’enfants",
    "version": "1.0"
  }, {
    "emoji": "⛔",
    "category": 7,
    "name": "sens interdit",
    "version": "1.0"
  }, {
    "emoji": "🚫",
    "category": 7,
    "name": "symbole d’interdiction",
    "version": "1.0"
  }, {
    "emoji": "🚳",
    "category": 7,
    "name": "vélos interdits",
    "version": "1.0"
  }, {
    "emoji": "🚭",
    "category": 7,
    "name": "interdiction de fumer",
    "version": "1.0"
  }, {
    "emoji": "🚯",
    "category": 7,
    "name": "dépôt d’ordures interdit",
    "version": "1.0"
  }, {
    "emoji": "🚱",
    "category": 7,
    "name": "eau non potable",
    "version": "1.0"
  }, {
    "emoji": "🚷",
    "category": 7,
    "name": "interdit aux piétons",
    "version": "1.0"
  }, {
    "emoji": "📵",
    "category": 7,
    "name": "téléphones portables interdits",
    "version": "1.0"
  }, {
    "emoji": "🔞",
    "category": 7,
    "name": "18 ans et plus",
    "version": "1.0"
  }, {
    "emoji": "☢️",
    "category": 7,
    "name": "radioactive",
    "version": "1.0"
  }, {
    "emoji": "☣️",
    "category": 7,
    "name": "biohazard",
    "version": "1.0"
  }, {
    "emoji": "⬆️",
    "category": 7,
    "name": "up arrow",
    "version": "1.0"
  }, {
    "emoji": "↗️",
    "category": 7,
    "name": "up-right arrow",
    "version": "1.0"
  }, {
    "emoji": "➡️",
    "category": 7,
    "name": "right arrow",
    "version": "1.0"
  }, {
    "emoji": "↘️",
    "category": 7,
    "name": "down-right arrow",
    "version": "1.0"
  }, {
    "emoji": "⬇️",
    "category": 7,
    "name": "down arrow",
    "version": "1.0"
  }, {
    "emoji": "↙️",
    "category": 7,
    "name": "down-left arrow",
    "version": "1.0"
  }, {
    "emoji": "⬅️",
    "category": 7,
    "name": "left arrow",
    "version": "1.0"
  }, {
    "emoji": "↖️",
    "category": 7,
    "name": "up-left arrow",
    "version": "1.0"
  }, {
    "emoji": "↕️",
    "category": 7,
    "name": "up-down arrow",
    "version": "1.0"
  }, {
    "emoji": "↔️",
    "category": 7,
    "name": "left-right arrow",
    "version": "1.0"
  }, {
    "emoji": "↩️",
    "category": 7,
    "name": "right arrow curving left",
    "version": "1.0"
  }, {
    "emoji": "↪️",
    "category": 7,
    "name": "left arrow curving right",
    "version": "1.0"
  }, {
    "emoji": "⤴️",
    "category": 7,
    "name": "right arrow curving up",
    "version": "1.0"
  }, {
    "emoji": "⤵️",
    "category": 7,
    "name": "right arrow curving down",
    "version": "1.0"
  }, {
    "emoji": "🔃",
    "category": 7,
    "name": "flèches dans le sens horaire",
    "version": "1.0"
  }, {
    "emoji": "🔄",
    "category": 7,
    "name": "flèches dans le sens antihoraire",
    "version": "1.0"
  }, {
    "emoji": "🔙",
    "category": 7,
    "name": "flèche Retour",
    "version": "1.0"
  }, {
    "emoji": "🔚",
    "category": 7,
    "name": "flèche Fin",
    "version": "1.0"
  }, {
    "emoji": "🔛",
    "category": 7,
    "name": "flèche Activé",
    "version": "1.0"
  }, {
    "emoji": "🔜",
    "category": 7,
    "name": "flèche Bientôt",
    "version": "1.0"
  }, {
    "emoji": "🔝",
    "category": 7,
    "name": "flèche En haut",
    "version": "1.0"
  }, {
    "emoji": "🛐",
    "category": 7,
    "name": "lieu de culte",
    "version": "1.0"
  }, {
    "emoji": "⚛️",
    "category": 7,
    "name": "atom symbol",
    "version": "1.0"
  }, {
    "emoji": "🕉️",
    "category": 7,
    "name": "om",
    "version": "1.0"
  }, {
    "emoji": "✡️",
    "category": 7,
    "name": "star of David",
    "version": "1.0"
  }, {
    "emoji": "☸️",
    "category": 7,
    "name": "wheel of dharma",
    "version": "1.0"
  }, {
    "emoji": "☯️",
    "category": 7,
    "name": "yin yang",
    "version": "1.0"
  }, {
    "emoji": "✝️",
    "category": 7,
    "name": "latin cross",
    "version": "1.0"
  }, {
    "emoji": "☦️",
    "category": 7,
    "name": "orthodox cross",
    "version": "1.0"
  }, {
    "emoji": "☪️",
    "category": 7,
    "name": "star and crescent",
    "version": "1.0"
  }, {
    "emoji": "☮️",
    "category": 7,
    "name": "peace symbol",
    "version": "1.0"
  }, {
    "emoji": "🕎",
    "category": 7,
    "name": "chandelier à sept branches",
    "version": "1.0"
  }, {
    "emoji": "🔯",
    "category": 7,
    "name": "étoile à 6 branches",
    "version": "1.0"
  }, {
    "emoji": "♈",
    "category": 7,
    "name": "bélier zodiaque",
    "version": "1.0"
  }, {
    "emoji": "♉",
    "category": 7,
    "name": "taureau",
    "version": "1.0"
  }, {
    "emoji": "♊",
    "category": 7,
    "name": "gémeaux",
    "version": "1.0"
  }, {
    "emoji": "♋",
    "category": 7,
    "name": "cancer",
    "version": "1.0"
  }, {
    "emoji": "♌",
    "category": 7,
    "name": "lion",
    "version": "1.0"
  }, {
    "emoji": "♍",
    "category": 7,
    "name": "vierge",
    "version": "1.0"
  }, {
    "emoji": "♎",
    "category": 7,
    "name": "balance",
    "version": "1.0"
  }, {
    "emoji": "♏",
    "category": 7,
    "name": "scorpion zodiaque",
    "version": "1.0"
  }, {
    "emoji": "♐",
    "category": 7,
    "name": "sagittaire",
    "version": "1.0"
  }, {
    "emoji": "♑",
    "category": 7,
    "name": "capricorne",
    "version": "1.0"
  }, {
    "emoji": "♒",
    "category": 7,
    "name": "verseau",
    "version": "1.0"
  }, {
    "emoji": "♓",
    "category": 7,
    "name": "poissons",
    "version": "1.0"
  }, {
    "emoji": "⛎",
    "category": 7,
    "name": "serpentaire",
    "version": "1.0"
  }, {
    "emoji": "🔀",
    "category": 7,
    "name": "bouton lecture aléatoire",
    "version": "1.0"
  }, {
    "emoji": "🔁",
    "category": 7,
    "name": "bouton répétition",
    "version": "1.0"
  }, {
    "emoji": "🔂",
    "category": 7,
    "name": "bouton répétition de la piste",
    "version": "1.0"
  }, {
    "emoji": "▶️",
    "category": 7,
    "name": "play button",
    "version": "1.0"
  }, {
    "emoji": "⏩",
    "category": 7,
    "name": "bouton avance rapide",
    "version": "1.0"
  }, {
    "emoji": "⏭️",
    "category": 7,
    "name": "next track button",
    "version": "1.0"
  }, {
    "emoji": "⏯️",
    "category": 7,
    "name": "play or pause button",
    "version": "1.0"
  }, {
    "emoji": "◀️",
    "category": 7,
    "name": "reverse button",
    "version": "1.0"
  }, {
    "emoji": "⏪",
    "category": 7,
    "name": "bouton retour rapide",
    "version": "1.0"
  }, {
    "emoji": "⏮️",
    "category": 7,
    "name": "last track button",
    "version": "1.0"
  }, {
    "emoji": "🔼",
    "category": 7,
    "name": "petit triangle haut",
    "version": "1.0"
  }, {
    "emoji": "⏫",
    "category": 7,
    "name": "double flèche vers le haut",
    "version": "1.0"
  }, {
    "emoji": "🔽",
    "category": 7,
    "name": "petit triangle bas",
    "version": "1.0"
  }, {
    "emoji": "⏬",
    "category": 7,
    "name": "double flèche vers le bas",
    "version": "1.0"
  }, {
    "emoji": "⏸️",
    "category": 7,
    "name": "pause button",
    "version": "1.0"
  }, {
    "emoji": "⏹️",
    "category": 7,
    "name": "stop button",
    "version": "1.0"
  }, {
    "emoji": "⏺️",
    "category": 7,
    "name": "record button",
    "version": "1.0"
  }, {
    "emoji": "⏏️",
    "category": 7,
    "name": "eject button",
    "version": "1.0"
  }, {
    "emoji": "🎦",
    "category": 7,
    "name": "cinéma",
    "version": "1.0"
  }, {
    "emoji": "🔅",
    "category": 7,
    "name": "luminosité faible",
    "version": "1.0"
  }, {
    "emoji": "🔆",
    "category": 7,
    "name": "luminosité élevée",
    "version": "1.0"
  }, {
    "emoji": "📶",
    "category": 7,
    "name": "barres de réseau",
    "version": "1.0"
  }, {
    "emoji": "📳",
    "category": 7,
    "name": "mode vibreur",
    "version": "1.0"
  }, {
    "emoji": "📴",
    "category": 7,
    "name": "téléphone éteint",
    "version": "1.0"
  }, {
    "emoji": "♀️",
    "category": 7,
    "name": "female sign",
    "version": "4.0"
  }, {
    "emoji": "♂️",
    "category": 7,
    "name": "male sign",
    "version": "4.0"
  }, {
    "emoji": "⚧️",
    "category": 7,
    "name": "transgender symbol",
    "version": "13.0"
  }, {
    "emoji": "✖️",
    "category": 7,
    "name": "multiply",
    "version": "1.0"
  }, {
    "emoji": "➕",
    "category": 7,
    "name": "plus",
    "version": "1.0"
  }, {
    "emoji": "➖",
    "category": 7,
    "name": "moins",
    "version": "1.0"
  }, {
    "emoji": "➗",
    "category": 7,
    "name": "signe diviser",
    "version": "1.0"
  }, {
    "emoji": "♾️",
    "category": 7,
    "name": "infinity",
    "version": "11.0"
  }, {
    "emoji": "‼️",
    "category": 7,
    "name": "double exclamation mark",
    "version": "1.0"
  }, {
    "emoji": "⁉️",
    "category": 7,
    "name": "exclamation question mark",
    "version": "1.0"
  }, {
    "emoji": "❓",
    "category": 7,
    "name": "point d’interrogation rouge",
    "version": "1.0"
  }, {
    "emoji": "❔",
    "category": 7,
    "name": "point d’interrogation blanc",
    "version": "1.0"
  }, {
    "emoji": "❕",
    "category": 7,
    "name": "point d’exclamation blanc",
    "version": "1.0"
  }, {
    "emoji": "❗",
    "category": 7,
    "name": "point d’exclamation rouge",
    "version": "1.0"
  }, {
    "emoji": "〰️",
    "category": 7,
    "name": "wavy dash",
    "version": "1.0"
  }, {
    "emoji": "💱",
    "category": 7,
    "name": "conversion de devise",
    "version": "1.0"
  }, {
    "emoji": "💲",
    "category": 7,
    "name": "symbole dollar",
    "version": "1.0"
  }, {
    "emoji": "⚕️",
    "category": 7,
    "name": "medical symbol",
    "version": "4.0"
  }, {
    "emoji": "♻️",
    "category": 7,
    "name": "recycling symbol",
    "version": "1.0"
  }, {
    "emoji": "⚜️",
    "category": 7,
    "name": "fleur-de-lis",
    "version": "1.0"
  }, {
    "emoji": "🔱",
    "category": 7,
    "name": "trident",
    "version": "1.0"
  }, {
    "emoji": "📛",
    "category": 7,
    "name": "badge nominatif",
    "version": "1.0"
  }, {
    "emoji": "🔰",
    "category": 7,
    "name": "symbole japonais de débutant",
    "version": "1.0"
  }, {
    "emoji": "⭕",
    "category": 7,
    "name": "cercle rouge",
    "version": "1.0"
  }, {
    "emoji": "✅",
    "category": 7,
    "name": "bouton coché",
    "version": "1.0"
  }, {
    "emoji": "☑️",
    "category": 7,
    "name": "check box with check",
    "version": "1.0"
  }, {
    "emoji": "✔️",
    "category": 7,
    "name": "check mark",
    "version": "1.0"
  }, {
    "emoji": "❌",
    "category": 7,
    "name": "croix",
    "version": "1.0"
  }, {
    "emoji": "❎",
    "category": 7,
    "name": "bouton croix",
    "version": "1.0"
  }, {
    "emoji": "➰",
    "category": 7,
    "name": "boucle",
    "version": "1.0"
  }, {
    "emoji": "➿",
    "category": 7,
    "name": "double boucle",
    "version": "1.0"
  }, {
    "emoji": "〽️",
    "category": 7,
    "name": "part alternation mark",
    "version": "1.0"
  }, {
    "emoji": "✳️",
    "category": 7,
    "name": "eight-spoked asterisk",
    "version": "1.0"
  }, {
    "emoji": "✴️",
    "category": 7,
    "name": "eight-pointed star",
    "version": "1.0"
  }, {
    "emoji": "❇️",
    "category": 7,
    "name": "sparkle",
    "version": "1.0"
  }, {
    "emoji": "©️",
    "category": 7,
    "name": "copyright",
    "version": "1.0"
  }, {
    "emoji": "®️",
    "category": 7,
    "name": "registered",
    "version": "1.0"
  }, {
    "emoji": "™️",
    "category": 7,
    "name": "trade mark",
    "version": "1.0"
  }, {
    "emoji": "#️⃣",
    "category": 7,
    "name": "keycap: #",
    "version": "1.0"
  }, {
    "emoji": "*️⃣",
    "category": 7,
    "name": "keycap: *",
    "version": "2.0"
  }, {
    "emoji": "0️⃣",
    "category": 7,
    "name": "keycap: 0",
    "version": "1.0"
  }, {
    "emoji": "1️⃣",
    "category": 7,
    "name": "keycap: 1",
    "version": "1.0"
  }, {
    "emoji": "2️⃣",
    "category": 7,
    "name": "keycap: 2",
    "version": "1.0"
  }, {
    "emoji": "3️⃣",
    "category": 7,
    "name": "keycap: 3",
    "version": "1.0"
  }, {
    "emoji": "4️⃣",
    "category": 7,
    "name": "keycap: 4",
    "version": "1.0"
  }, {
    "emoji": "5️⃣",
    "category": 7,
    "name": "keycap: 5",
    "version": "1.0"
  }, {
    "emoji": "6️⃣",
    "category": 7,
    "name": "keycap: 6",
    "version": "1.0"
  }, {
    "emoji": "7️⃣",
    "category": 7,
    "name": "keycap: 7",
    "version": "1.0"
  }, {
    "emoji": "8️⃣",
    "category": 7,
    "name": "keycap: 8",
    "version": "1.0"
  }, {
    "emoji": "9️⃣",
    "category": 7,
    "name": "keycap: 9",
    "version": "1.0"
  }, {
    "emoji": "🔟",
    "category": 7,
    "name": "touches : 10",
    "version": "1.0"
  }, {
    "emoji": "🔠",
    "category": 7,
    "name": "majuscules",
    "version": "1.0"
  }, {
    "emoji": "🔡",
    "category": 7,
    "name": "minuscules",
    "version": "1.0"
  }, {
    "emoji": "🔢",
    "category": 7,
    "name": "saisie de chiffres",
    "version": "1.0"
  }, {
    "emoji": "🔣",
    "category": 7,
    "name": "saisie de symboles",
    "version": "1.0"
  }, {
    "emoji": "🔤",
    "category": 7,
    "name": "alphabet latin",
    "version": "1.0"
  }, {
    "emoji": "🅰️",
    "category": 7,
    "name": "A button (blood type)",
    "version": "1.0"
  }, {
    "emoji": "🆎",
    "category": 7,
    "name": "groupe sanguin AB",
    "version": "1.0"
  }, {
    "emoji": "🅱️",
    "category": 7,
    "name": "B button (blood type)",
    "version": "1.0"
  }, {
    "emoji": "🆑",
    "category": 7,
    "name": "bouton Effacer",
    "version": "1.0"
  }, {
    "emoji": "🆒",
    "category": 7,
    "name": "bouton Cool",
    "version": "1.0"
  }, {
    "emoji": "🆓",
    "category": 7,
    "name": "bouton Gratuit",
    "version": "1.0"
  }, {
    "emoji": "ℹ️",
    "category": 7,
    "name": "information",
    "version": "1.0"
  }, {
    "emoji": "🆔",
    "category": 7,
    "name": "bouton Identifiant",
    "version": "1.0"
  }, {
    "emoji": "Ⓜ️",
    "category": 7,
    "name": "circled M",
    "version": "1.0"
  }, {
    "emoji": "🆕",
    "category": 7,
    "name": "bouton Nouveau",
    "version": "1.0"
  }, {
    "emoji": "🆖",
    "category": 7,
    "name": "bouton Pas bien",
    "version": "1.0"
  }, {
    "emoji": "🅾️",
    "category": 7,
    "name": "O button (blood type)",
    "version": "1.0"
  }, {
    "emoji": "🆗",
    "category": 7,
    "name": "bouton OK",
    "version": "1.0"
  }, {
    "emoji": "🅿️",
    "category": 7,
    "name": "P button",
    "version": "1.0"
  }, {
    "emoji": "🆘",
    "category": 7,
    "name": "bouton SOS",
    "version": "1.0"
  }, {
    "emoji": "🆙",
    "category": 7,
    "name": "bouton Vers le haut",
    "version": "1.0"
  }, {
    "emoji": "🆚",
    "category": 7,
    "name": "bouton VS",
    "version": "1.0"
  }, {
    "emoji": "🈁",
    "category": 7,
    "name": "bouton ici en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈂️",
    "category": 7,
    "name": "Japanese “service charge” button",
    "version": "1.0"
  }, {
    "emoji": "🈷️",
    "category": 7,
    "name": "Japanese “monthly amount” button",
    "version": "1.0"
  }, {
    "emoji": "🈶",
    "category": 7,
    "name": "bouton pas gratuit en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈯",
    "category": 7,
    "name": "bouton réservé en japonais",
    "version": "1.0"
  }, {
    "emoji": "🉐",
    "category": 7,
    "name": "bouton bonne affaire en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈹",
    "category": 7,
    "name": "bouton réduction en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈚",
    "category": 7,
    "name": "bouton gratuit en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈲",
    "category": 7,
    "name": "bouton interdit en japonais",
    "version": "1.0"
  }, {
    "emoji": "🉑",
    "category": 7,
    "name": "bouton accepter en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈸",
    "category": 7,
    "name": "bouton application en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈴",
    "category": 7,
    "name": "bouton note pour réussir en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈳",
    "category": 7,
    "name": "bouton chambres disponibles en japonais",
    "version": "1.0"
  }, {
    "emoji": "㊗️",
    "category": 7,
    "name": "Japanese “congratulations” button",
    "version": "1.0"
  }, {
    "emoji": "㊙️",
    "category": 7,
    "name": "Japanese “secret” button",
    "version": "1.0"
  }, {
    "emoji": "🈺",
    "category": 7,
    "name": "bouton ouvert pour affaires en japonais",
    "version": "1.0"
  }, {
    "emoji": "🈵",
    "category": 7,
    "name": "bouton complet en japonais",
    "version": "1.0"
  }, {
    "emoji": "🔴",
    "category": 7,
    "name": "disque rouge",
    "version": "1.0"
  }, {
    "emoji": "🟠",
    "category": 7,
    "name": "disque orange",
    "version": "12.0"
  }, {
    "emoji": "🟡",
    "category": 7,
    "name": "disque jaune",
    "version": "12.0"
  }, {
    "emoji": "🟢",
    "category": 7,
    "name": "disque vert",
    "version": "12.0"
  }, {
    "emoji": "🔵",
    "category": 7,
    "name": "disque bleu",
    "version": "1.0"
  }, {
    "emoji": "🟣",
    "category": 7,
    "name": "disque violet",
    "version": "12.0"
  }, {
    "emoji": "🟤",
    "category": 7,
    "name": "disque marron",
    "version": "12.0"
  }, {
    "emoji": "⚫",
    "category": 7,
    "name": "disque noir",
    "version": "1.0"
  }, {
    "emoji": "⚪",
    "category": 7,
    "name": "disque blanc",
    "version": "1.0"
  }, {
    "emoji": "🟥",
    "category": 7,
    "name": "carré rouge",
    "version": "12.0"
  }, {
    "emoji": "🟧",
    "category": 7,
    "name": "carré orange",
    "version": "12.0"
  }, {
    "emoji": "🟨",
    "category": 7,
    "name": "carré jaune",
    "version": "12.0"
  }, {
    "emoji": "🟩",
    "category": 7,
    "name": "carré vert",
    "version": "12.0"
  }, {
    "emoji": "🟦",
    "category": 7,
    "name": "carré bleu",
    "version": "12.0"
  }, {
    "emoji": "🟪",
    "category": 7,
    "name": "carré violet",
    "version": "12.0"
  }, {
    "emoji": "🟫",
    "category": 7,
    "name": "carré marron",
    "version": "12.0"
  }, {
    "emoji": "⬛",
    "category": 7,
    "name": "grand carré noir",
    "version": "1.0"
  }, {
    "emoji": "⬜",
    "category": 7,
    "name": "grand carré blanc",
    "version": "1.0"
  }, {
    "emoji": "◼️",
    "category": 7,
    "name": "black medium square",
    "version": "1.0"
  }, {
    "emoji": "◻️",
    "category": 7,
    "name": "white medium square",
    "version": "1.0"
  }, {
    "emoji": "◾",
    "category": 7,
    "name": "carré petit moyen noir",
    "version": "1.0"
  }, {
    "emoji": "◽",
    "category": 7,
    "name": "carré petit moyen blanc",
    "version": "1.0"
  }, {
    "emoji": "▪️",
    "category": 7,
    "name": "black small square",
    "version": "1.0"
  }, {
    "emoji": "▫️",
    "category": 7,
    "name": "white small square",
    "version": "1.0"
  }, {
    "emoji": "🔶",
    "category": 7,
    "name": "grand losange orange",
    "version": "1.0"
  }, {
    "emoji": "🔷",
    "category": 7,
    "name": "grand losange bleu",
    "version": "1.0"
  }, {
    "emoji": "🔸",
    "category": 7,
    "name": "petit losange orange",
    "version": "1.0"
  }, {
    "emoji": "🔹",
    "category": 7,
    "name": "petit losange bleu",
    "version": "1.0"
  }, {
    "emoji": "🔺",
    "category": 7,
    "name": "triangle rouge pointant vers le haut",
    "version": "1.0"
  }, {
    "emoji": "🔻",
    "category": 7,
    "name": "triangle rouge pointant vers le bas",
    "version": "1.0"
  }, {
    "emoji": "💠",
    "category": 7,
    "name": "diamant avec un point",
    "version": "1.0"
  }, {
    "emoji": "🔘",
    "category": 7,
    "name": "bouton radio",
    "version": "1.0"
  }, {
    "emoji": "🔳",
    "category": 7,
    "name": "carré blanc",
    "version": "1.0"
  }, {
    "emoji": "🔲",
    "category": 7,
    "name": "carré noir",
    "version": "1.0"
  }, {
    "emoji": "🏁",
    "category": 8,
    "name": "drapeau à damier",
    "version": "1.0"
  }, {
    "emoji": "🚩",
    "category": 8,
    "name": "drapeau triangulaire",
    "version": "1.0"
  }, {
    "emoji": "🎌",
    "category": 8,
    "name": "drapeaux croisés",
    "version": "1.0"
  }, {
    "emoji": "🏴",
    "category": 8,
    "name": "drapeau noir",
    "version": "1.0"
  }, {
    "emoji": "🏳️",
    "category": 8,
    "name": "white flag",
    "version": "1.0"
  }, {
    "emoji": "🏳️‍🌈",
    "category": 8,
    "name": "rainbow flag",
    "version": "4.0"
  }, {
    "emoji": "🏳️‍⚧️",
    "category": 8,
    "name": "transgender flag",
    "version": "13.0"
  }, {
    "emoji": "🏴‍☠️",
    "category": 8,
    "name": "pirate flag",
    "version": "11.0"
  }, {
    "emoji": "🇦🇨",
    "category": 8,
    "name": "drapeau : Île de l’Ascension",
    "version": "2.0"
  }, {
    "emoji": "🇦🇩",
    "category": 8,
    "name": "drapeau : Andorre",
    "version": "2.0"
  }, {
    "emoji": "🇦🇪",
    "category": 8,
    "name": "drapeau : Émirats arabes unis",
    "version": "2.0"
  }, {
    "emoji": "🇦🇫",
    "category": 8,
    "name": "drapeau : Afghanistan",
    "version": "2.0"
  }, {
    "emoji": "🇦🇬",
    "category": 8,
    "name": "drapeau : Antigua-et-Barbuda",
    "version": "2.0"
  }, {
    "emoji": "🇦🇮",
    "category": 8,
    "name": "drapeau : Anguilla",
    "version": "2.0"
  }, {
    "emoji": "🇦🇱",
    "category": 8,
    "name": "drapeau : Albanie",
    "version": "2.0"
  }, {
    "emoji": "🇦🇲",
    "category": 8,
    "name": "drapeau : Arménie",
    "version": "2.0"
  }, {
    "emoji": "🇦🇴",
    "category": 8,
    "name": "drapeau : Angola",
    "version": "2.0"
  }, {
    "emoji": "🇦🇶",
    "category": 8,
    "name": "drapeau : Antarctique",
    "version": "2.0"
  }, {
    "emoji": "🇦🇷",
    "category": 8,
    "name": "drapeau : Argentine",
    "version": "2.0"
  }, {
    "emoji": "🇦🇸",
    "category": 8,
    "name": "drapeau : Samoa américaines",
    "version": "2.0"
  }, {
    "emoji": "🇦🇹",
    "category": 8,
    "name": "drapeau : Autriche",
    "version": "2.0"
  }, {
    "emoji": "🇦🇺",
    "category": 8,
    "name": "drapeau : Australie",
    "version": "2.0"
  }, {
    "emoji": "🇦🇼",
    "category": 8,
    "name": "drapeau : Aruba",
    "version": "2.0"
  }, {
    "emoji": "🇦🇽",
    "category": 8,
    "name": "drapeau : Îles Åland",
    "version": "2.0"
  }, {
    "emoji": "🇦🇿",
    "category": 8,
    "name": "drapeau : Azerbaïdjan",
    "version": "2.0"
  }, {
    "emoji": "🇧🇦",
    "category": 8,
    "name": "drapeau : Bosnie-Herzégovine",
    "version": "2.0"
  }, {
    "emoji": "🇧🇧",
    "category": 8,
    "name": "drapeau : Barbade",
    "version": "2.0"
  }, {
    "emoji": "🇧🇩",
    "category": 8,
    "name": "drapeau : Bangladesh",
    "version": "2.0"
  }, {
    "emoji": "🇧🇪",
    "category": 8,
    "name": "drapeau : Belgique",
    "version": "2.0"
  }, {
    "emoji": "🇧🇫",
    "category": 8,
    "name": "drapeau : Burkina Faso",
    "version": "2.0"
  }, {
    "emoji": "🇧🇬",
    "category": 8,
    "name": "drapeau : Bulgarie",
    "version": "2.0"
  }, {
    "emoji": "🇧🇭",
    "category": 8,
    "name": "drapeau : Bahreïn",
    "version": "2.0"
  }, {
    "emoji": "🇧🇮",
    "category": 8,
    "name": "drapeau : Burundi",
    "version": "2.0"
  }, {
    "emoji": "🇧🇯",
    "category": 8,
    "name": "drapeau : Bénin",
    "version": "2.0"
  }, {
    "emoji": "🇧🇱",
    "category": 8,
    "name": "drapeau : Saint-Barthélemy",
    "version": "2.0"
  }, {
    "emoji": "🇧🇲",
    "category": 8,
    "name": "drapeau : Bermudes",
    "version": "2.0"
  }, {
    "emoji": "🇧🇳",
    "category": 8,
    "name": "drapeau : Brunei",
    "version": "2.0"
  }, {
    "emoji": "🇧🇴",
    "category": 8,
    "name": "drapeau : Bolivie",
    "version": "2.0"
  }, {
    "emoji": "🇧🇶",
    "category": 8,
    "name": "drapeau : Pays-Bas caribéens",
    "version": "2.0"
  }, {
    "emoji": "🇧🇷",
    "category": 8,
    "name": "drapeau : Brésil",
    "version": "2.0"
  }, {
    "emoji": "🇧🇸",
    "category": 8,
    "name": "drapeau : Bahamas",
    "version": "2.0"
  }, {
    "emoji": "🇧🇹",
    "category": 8,
    "name": "drapeau : Bhoutan",
    "version": "2.0"
  }, {
    "emoji": "🇧🇻",
    "category": 8,
    "name": "drapeau : Île Bouvet",
    "version": "2.0"
  }, {
    "emoji": "🇧🇼",
    "category": 8,
    "name": "drapeau : Botswana",
    "version": "2.0"
  }, {
    "emoji": "🇧🇾",
    "category": 8,
    "name": "drapeau : Biélorussie",
    "version": "2.0"
  }, {
    "emoji": "🇧🇿",
    "category": 8,
    "name": "drapeau : Belize",
    "version": "2.0"
  }, {
    "emoji": "🇨🇦",
    "category": 8,
    "name": "drapeau : Canada",
    "version": "2.0"
  }, {
    "emoji": "🇨🇨",
    "category": 8,
    "name": "drapeau : Îles Cocos",
    "version": "2.0"
  }, {
    "emoji": "🇨🇩",
    "category": 8,
    "name": "drapeau : Congo-Kinshasa",
    "version": "2.0"
  }, {
    "emoji": "🇨🇫",
    "category": 8,
    "name": "drapeau : République centrafricaine",
    "version": "2.0"
  }, {
    "emoji": "🇨🇬",
    "category": 8,
    "name": "drapeau : Congo-Brazzaville",
    "version": "2.0"
  }, {
    "emoji": "🇨🇭",
    "category": 8,
    "name": "drapeau : Suisse",
    "version": "2.0"
  }, {
    "emoji": "🇨🇮",
    "category": 8,
    "name": "drapeau : Côte d’Ivoire",
    "version": "2.0"
  }, {
    "emoji": "🇨🇰",
    "category": 8,
    "name": "drapeau : Îles Cook",
    "version": "2.0"
  }, {
    "emoji": "🇨🇱",
    "category": 8,
    "name": "drapeau : Chili",
    "version": "2.0"
  }, {
    "emoji": "🇨🇲",
    "category": 8,
    "name": "drapeau : Cameroun",
    "version": "2.0"
  }, {
    "emoji": "🇨🇳",
    "category": 8,
    "name": "drapeau : Chine",
    "version": "1.0"
  }, {
    "emoji": "🇨🇴",
    "category": 8,
    "name": "drapeau : Colombie",
    "version": "2.0"
  }, {
    "emoji": "🇨🇵",
    "category": 8,
    "name": "drapeau : Île Clipperton",
    "version": "2.0"
  }, {
    "emoji": "🇨🇷",
    "category": 8,
    "name": "drapeau : Costa Rica",
    "version": "2.0"
  }, {
    "emoji": "🇨🇺",
    "category": 8,
    "name": "drapeau : Cuba",
    "version": "2.0"
  }, {
    "emoji": "🇨🇻",
    "category": 8,
    "name": "drapeau : Cap-Vert",
    "version": "2.0"
  }, {
    "emoji": "🇨🇼",
    "category": 8,
    "name": "drapeau : Curaçao",
    "version": "2.0"
  }, {
    "emoji": "🇨🇽",
    "category": 8,
    "name": "drapeau : Île Christmas",
    "version": "2.0"
  }, {
    "emoji": "🇨🇾",
    "category": 8,
    "name": "drapeau : Chypre",
    "version": "2.0"
  }, {
    "emoji": "🇨🇿",
    "category": 8,
    "name": "drapeau : Tchéquie",
    "version": "2.0"
  }, {
    "emoji": "🇩🇪",
    "category": 8,
    "name": "drapeau : Allemagne",
    "version": "1.0"
  }, {
    "emoji": "🇩🇬",
    "category": 8,
    "name": "drapeau : Diego Garcia",
    "version": "2.0"
  }, {
    "emoji": "🇩🇯",
    "category": 8,
    "name": "drapeau : Djibouti",
    "version": "2.0"
  }, {
    "emoji": "🇩🇰",
    "category": 8,
    "name": "drapeau : Danemark",
    "version": "2.0"
  }, {
    "emoji": "🇩🇲",
    "category": 8,
    "name": "drapeau : Dominique",
    "version": "2.0"
  }, {
    "emoji": "🇩🇴",
    "category": 8,
    "name": "drapeau : République dominicaine",
    "version": "2.0"
  }, {
    "emoji": "🇩🇿",
    "category": 8,
    "name": "drapeau : Algérie",
    "version": "2.0"
  }, {
    "emoji": "🇪🇦",
    "category": 8,
    "name": "drapeau : Ceuta et Melilla",
    "version": "2.0"
  }, {
    "emoji": "🇪🇨",
    "category": 8,
    "name": "drapeau : Équateur",
    "version": "2.0"
  }, {
    "emoji": "🇪🇪",
    "category": 8,
    "name": "drapeau : Estonie",
    "version": "2.0"
  }, {
    "emoji": "🇪🇬",
    "category": 8,
    "name": "drapeau : Égypte",
    "version": "2.0"
  }, {
    "emoji": "🇪🇭",
    "category": 8,
    "name": "drapeau : Sahara occidental",
    "version": "2.0"
  }, {
    "emoji": "🇪🇷",
    "category": 8,
    "name": "drapeau : Érythrée",
    "version": "2.0"
  }, {
    "emoji": "🇪🇸",
    "category": 8,
    "name": "drapeau : Espagne",
    "version": "1.0"
  }, {
    "emoji": "🇪🇹",
    "category": 8,
    "name": "drapeau : Éthiopie",
    "version": "2.0"
  }, {
    "emoji": "🇪🇺",
    "category": 8,
    "name": "drapeau : Union européenne",
    "version": "2.0"
  }, {
    "emoji": "🇫🇮",
    "category": 8,
    "name": "drapeau : Finlande",
    "version": "2.0"
  }, {
    "emoji": "🇫🇯",
    "category": 8,
    "name": "drapeau : Fidji",
    "version": "2.0"
  }, {
    "emoji": "🇫🇰",
    "category": 8,
    "name": "drapeau : Îles Malouines",
    "version": "2.0"
  }, {
    "emoji": "🇫🇲",
    "category": 8,
    "name": "drapeau : Micronésie",
    "version": "2.0"
  }, {
    "emoji": "🇫🇴",
    "category": 8,
    "name": "drapeau : Îles Féroé",
    "version": "2.0"
  }, {
    "emoji": "🇫🇷",
    "category": 8,
    "name": "drapeau : France",
    "version": "1.0"
  }, {
    "emoji": "🇬🇦",
    "category": 8,
    "name": "drapeau : Gabon",
    "version": "2.0"
  }, {
    "emoji": "🇬🇧",
    "category": 8,
    "name": "drapeau : Royaume-Uni",
    "version": "1.0"
  }, {
    "emoji": "🇬🇩",
    "category": 8,
    "name": "drapeau : Grenade",
    "version": "2.0"
  }, {
    "emoji": "🇬🇪",
    "category": 8,
    "name": "drapeau : Géorgie",
    "version": "2.0"
  }, {
    "emoji": "🇬🇫",
    "category": 8,
    "name": "drapeau : Guyane française",
    "version": "2.0"
  }, {
    "emoji": "🇬🇬",
    "category": 8,
    "name": "drapeau : Guernesey",
    "version": "2.0"
  }, {
    "emoji": "🇬🇭",
    "category": 8,
    "name": "drapeau : Ghana",
    "version": "2.0"
  }, {
    "emoji": "🇬🇮",
    "category": 8,
    "name": "drapeau : Gibraltar",
    "version": "2.0"
  }, {
    "emoji": "🇬🇱",
    "category": 8,
    "name": "drapeau : Groenland",
    "version": "2.0"
  }, {
    "emoji": "🇬🇲",
    "category": 8,
    "name": "drapeau : Gambie",
    "version": "2.0"
  }, {
    "emoji": "🇬🇳",
    "category": 8,
    "name": "drapeau : Guinée",
    "version": "2.0"
  }, {
    "emoji": "🇬🇵",
    "category": 8,
    "name": "drapeau : Guadeloupe",
    "version": "2.0"
  }, {
    "emoji": "🇬🇶",
    "category": 8,
    "name": "drapeau : Guinée équatoriale",
    "version": "2.0"
  }, {
    "emoji": "🇬🇷",
    "category": 8,
    "name": "drapeau : Grèce",
    "version": "2.0"
  }, {
    "emoji": "🇬🇸",
    "category": 8,
    "name": "drapeau : Géorgie du Sud-et-les Îles Sandwich du Sud",
    "version": "2.0"
  }, {
    "emoji": "🇬🇹",
    "category": 8,
    "name": "drapeau : Guatemala",
    "version": "2.0"
  }, {
    "emoji": "🇬🇺",
    "category": 8,
    "name": "drapeau : Guam",
    "version": "2.0"
  }, {
    "emoji": "🇬🇼",
    "category": 8,
    "name": "drapeau : Guinée-Bissau",
    "version": "2.0"
  }, {
    "emoji": "🇬🇾",
    "category": 8,
    "name": "drapeau : Guyana",
    "version": "2.0"
  }, {
    "emoji": "🇭🇰",
    "category": 8,
    "name": "drapeau : R.A.S. chinoise de Hong Kong",
    "version": "2.0"
  }, {
    "emoji": "🇭🇲",
    "category": 8,
    "name": "drapeau : Îles Heard-et-MacDonald",
    "version": "2.0"
  }, {
    "emoji": "🇭🇳",
    "category": 8,
    "name": "drapeau : Honduras",
    "version": "2.0"
  }, {
    "emoji": "🇭🇷",
    "category": 8,
    "name": "drapeau : Croatie",
    "version": "2.0"
  }, {
    "emoji": "🇭🇹",
    "category": 8,
    "name": "drapeau : Haïti",
    "version": "2.0"
  }, {
    "emoji": "🇭🇺",
    "category": 8,
    "name": "drapeau : Hongrie",
    "version": "2.0"
  }, {
    "emoji": "🇮🇨",
    "category": 8,
    "name": "drapeau : Îles Canaries",
    "version": "2.0"
  }, {
    "emoji": "🇮🇩",
    "category": 8,
    "name": "drapeau : Indonésie",
    "version": "2.0"
  }, {
    "emoji": "🇮🇪",
    "category": 8,
    "name": "drapeau : Irlande",
    "version": "2.0"
  }, {
    "emoji": "🇮🇱",
    "category": 8,
    "name": "drapeau : Israël",
    "version": "2.0"
  }, {
    "emoji": "🇮🇲",
    "category": 8,
    "name": "drapeau : Île de Man",
    "version": "2.0"
  }, {
    "emoji": "🇮🇳",
    "category": 8,
    "name": "drapeau : Inde",
    "version": "2.0"
  }, {
    "emoji": "🇮🇴",
    "category": 8,
    "name": "drapeau : Territoire britannique de l’océan Indien",
    "version": "2.0"
  }, {
    "emoji": "🇮🇶",
    "category": 8,
    "name": "drapeau : Irak",
    "version": "2.0"
  }, {
    "emoji": "🇮🇷",
    "category": 8,
    "name": "drapeau : Iran",
    "version": "2.0"
  }, {
    "emoji": "🇮🇸",
    "category": 8,
    "name": "drapeau : Islande",
    "version": "2.0"
  }, {
    "emoji": "🇮🇹",
    "category": 8,
    "name": "drapeau : Italie",
    "version": "1.0"
  }, {
    "emoji": "🇯🇪",
    "category": 8,
    "name": "drapeau : Jersey",
    "version": "2.0"
  }, {
    "emoji": "🇯🇲",
    "category": 8,
    "name": "drapeau : Jamaïque",
    "version": "2.0"
  }, {
    "emoji": "🇯🇴",
    "category": 8,
    "name": "drapeau : Jordanie",
    "version": "2.0"
  }, {
    "emoji": "🇯🇵",
    "category": 8,
    "name": "drapeau : Japon",
    "version": "1.0"
  }, {
    "emoji": "🇰🇪",
    "category": 8,
    "name": "drapeau : Kenya",
    "version": "2.0"
  }, {
    "emoji": "🇰🇬",
    "category": 8,
    "name": "drapeau : Kirghizstan",
    "version": "2.0"
  }, {
    "emoji": "🇰🇭",
    "category": 8,
    "name": "drapeau : Cambodge",
    "version": "2.0"
  }, {
    "emoji": "🇰🇮",
    "category": 8,
    "name": "drapeau : Kiribati",
    "version": "2.0"
  }, {
    "emoji": "🇰🇲",
    "category": 8,
    "name": "drapeau : Comores",
    "version": "2.0"
  }, {
    "emoji": "🇰🇳",
    "category": 8,
    "name": "drapeau : Saint-Christophe-et-Niévès",
    "version": "2.0"
  }, {
    "emoji": "🇰🇵",
    "category": 8,
    "name": "drapeau : Corée du Nord",
    "version": "2.0"
  }, {
    "emoji": "🇰🇷",
    "category": 8,
    "name": "drapeau : Corée du Sud",
    "version": "1.0"
  }, {
    "emoji": "🇰🇼",
    "category": 8,
    "name": "drapeau : Koweït",
    "version": "2.0"
  }, {
    "emoji": "🇰🇾",
    "category": 8,
    "name": "drapeau : Îles Caïmans",
    "version": "2.0"
  }, {
    "emoji": "🇰🇿",
    "category": 8,
    "name": "drapeau : Kazakhstan",
    "version": "2.0"
  }, {
    "emoji": "🇱🇦",
    "category": 8,
    "name": "drapeau : Laos",
    "version": "2.0"
  }, {
    "emoji": "🇱🇧",
    "category": 8,
    "name": "drapeau : Liban",
    "version": "2.0"
  }, {
    "emoji": "🇱🇨",
    "category": 8,
    "name": "drapeau : Sainte-Lucie",
    "version": "2.0"
  }, {
    "emoji": "🇱🇮",
    "category": 8,
    "name": "drapeau : Liechtenstein",
    "version": "2.0"
  }, {
    "emoji": "🇱🇰",
    "category": 8,
    "name": "drapeau : Sri Lanka",
    "version": "2.0"
  }, {
    "emoji": "🇱🇷",
    "category": 8,
    "name": "drapeau : Liberia",
    "version": "2.0"
  }, {
    "emoji": "🇱🇸",
    "category": 8,
    "name": "drapeau : Lesotho",
    "version": "2.0"
  }, {
    "emoji": "🇱🇹",
    "category": 8,
    "name": "drapeau : Lituanie",
    "version": "2.0"
  }, {
    "emoji": "🇱🇺",
    "category": 8,
    "name": "drapeau : Luxembourg",
    "version": "2.0"
  }, {
    "emoji": "🇱🇻",
    "category": 8,
    "name": "drapeau : Lettonie",
    "version": "2.0"
  }, {
    "emoji": "🇱🇾",
    "category": 8,
    "name": "drapeau : Libye",
    "version": "2.0"
  }, {
    "emoji": "🇲🇦",
    "category": 8,
    "name": "drapeau : Maroc",
    "version": "2.0"
  }, {
    "emoji": "🇲🇨",
    "category": 8,
    "name": "drapeau : Monaco",
    "version": "2.0"
  }, {
    "emoji": "🇲🇩",
    "category": 8,
    "name": "drapeau : Moldavie",
    "version": "2.0"
  }, {
    "emoji": "🇲🇪",
    "category": 8,
    "name": "drapeau : Monténégro",
    "version": "2.0"
  }, {
    "emoji": "🇲🇫",
    "category": 8,
    "name": "drapeau : Saint-Martin",
    "version": "2.0"
  }, {
    "emoji": "🇲🇬",
    "category": 8,
    "name": "drapeau : Madagascar",
    "version": "2.0"
  }, {
    "emoji": "🇲🇭",
    "category": 8,
    "name": "drapeau : Îles Marshall",
    "version": "2.0"
  }, {
    "emoji": "🇲🇰",
    "category": 8,
    "name": "drapeau : Macédoine du Nord",
    "version": "2.0"
  }, {
    "emoji": "🇲🇱",
    "category": 8,
    "name": "drapeau : Mali",
    "version": "2.0"
  }, {
    "emoji": "🇲🇲",
    "category": 8,
    "name": "drapeau : Myanmar (Birmanie)",
    "version": "2.0"
  }, {
    "emoji": "🇲🇳",
    "category": 8,
    "name": "drapeau : Mongolie",
    "version": "2.0"
  }, {
    "emoji": "🇲🇴",
    "category": 8,
    "name": "drapeau : R.A.S. chinoise de Macao",
    "version": "2.0"
  }, {
    "emoji": "🇲🇵",
    "category": 8,
    "name": "drapeau : Îles Mariannes du Nord",
    "version": "2.0"
  }, {
    "emoji": "🇲🇶",
    "category": 8,
    "name": "drapeau : Martinique",
    "version": "2.0"
  }, {
    "emoji": "🇲🇷",
    "category": 8,
    "name": "drapeau : Mauritanie",
    "version": "2.0"
  }, {
    "emoji": "🇲🇸",
    "category": 8,
    "name": "drapeau : Montserrat",
    "version": "2.0"
  }, {
    "emoji": "🇲🇹",
    "category": 8,
    "name": "drapeau : Malte",
    "version": "2.0"
  }, {
    "emoji": "🇲🇺",
    "category": 8,
    "name": "drapeau : Maurice",
    "version": "2.0"
  }, {
    "emoji": "🇲🇻",
    "category": 8,
    "name": "drapeau : Maldives",
    "version": "2.0"
  }, {
    "emoji": "🇲🇼",
    "category": 8,
    "name": "drapeau : Malawi",
    "version": "2.0"
  }, {
    "emoji": "🇲🇽",
    "category": 8,
    "name": "drapeau : Mexique",
    "version": "2.0"
  }, {
    "emoji": "🇲🇾",
    "category": 8,
    "name": "drapeau : Malaisie",
    "version": "2.0"
  }, {
    "emoji": "🇲🇿",
    "category": 8,
    "name": "drapeau : Mozambique",
    "version": "2.0"
  }, {
    "emoji": "🇳🇦",
    "category": 8,
    "name": "drapeau : Namibie",
    "version": "2.0"
  }, {
    "emoji": "🇳🇨",
    "category": 8,
    "name": "drapeau : Nouvelle-Calédonie",
    "version": "2.0"
  }, {
    "emoji": "🇳🇪",
    "category": 8,
    "name": "drapeau : Niger",
    "version": "2.0"
  }, {
    "emoji": "🇳🇫",
    "category": 8,
    "name": "drapeau : Île Norfolk",
    "version": "2.0"
  }, {
    "emoji": "🇳🇬",
    "category": 8,
    "name": "drapeau : Nigeria",
    "version": "2.0"
  }, {
    "emoji": "🇳🇮",
    "category": 8,
    "name": "drapeau : Nicaragua",
    "version": "2.0"
  }, {
    "emoji": "🇳🇱",
    "category": 8,
    "name": "drapeau : Pays-Bas",
    "version": "2.0"
  }, {
    "emoji": "🇳🇴",
    "category": 8,
    "name": "drapeau : Norvège",
    "version": "2.0"
  }, {
    "emoji": "🇳🇵",
    "category": 8,
    "name": "drapeau : Népal",
    "version": "2.0"
  }, {
    "emoji": "🇳🇷",
    "category": 8,
    "name": "drapeau : Nauru",
    "version": "2.0"
  }, {
    "emoji": "🇳🇺",
    "category": 8,
    "name": "drapeau : Niue",
    "version": "2.0"
  }, {
    "emoji": "🇳🇿",
    "category": 8,
    "name": "drapeau : Nouvelle-Zélande",
    "version": "2.0"
  }, {
    "emoji": "🇴🇲",
    "category": 8,
    "name": "drapeau : Oman",
    "version": "2.0"
  }, {
    "emoji": "🇵🇦",
    "category": 8,
    "name": "drapeau : Panama",
    "version": "2.0"
  }, {
    "emoji": "🇵🇪",
    "category": 8,
    "name": "drapeau : Pérou",
    "version": "2.0"
  }, {
    "emoji": "🇵🇫",
    "category": 8,
    "name": "drapeau : Polynésie française",
    "version": "2.0"
  }, {
    "emoji": "🇵🇬",
    "category": 8,
    "name": "drapeau : Papouasie-Nouvelle-Guinée",
    "version": "2.0"
  }, {
    "emoji": "🇵🇭",
    "category": 8,
    "name": "drapeau : Philippines",
    "version": "2.0"
  }, {
    "emoji": "🇵🇰",
    "category": 8,
    "name": "drapeau : Pakistan",
    "version": "2.0"
  }, {
    "emoji": "🇵🇱",
    "category": 8,
    "name": "drapeau : Pologne",
    "version": "2.0"
  }, {
    "emoji": "🇵🇲",
    "category": 8,
    "name": "drapeau : Saint-Pierre-et-Miquelon",
    "version": "2.0"
  }, {
    "emoji": "🇵🇳",
    "category": 8,
    "name": "drapeau : Îles Pitcairn",
    "version": "2.0"
  }, {
    "emoji": "🇵🇷",
    "category": 8,
    "name": "drapeau : Porto Rico",
    "version": "2.0"
  }, {
    "emoji": "🇵🇸",
    "category": 8,
    "name": "drapeau : Territoires palestiniens",
    "version": "2.0"
  }, {
    "emoji": "🇵🇹",
    "category": 8,
    "name": "drapeau : Portugal",
    "version": "2.0"
  }, {
    "emoji": "🇵🇼",
    "category": 8,
    "name": "drapeau : Palaos",
    "version": "2.0"
  }, {
    "emoji": "🇵🇾",
    "category": 8,
    "name": "drapeau : Paraguay",
    "version": "2.0"
  }, {
    "emoji": "🇶🇦",
    "category": 8,
    "name": "drapeau : Qatar",
    "version": "2.0"
  }, {
    "emoji": "🇷🇪",
    "category": 8,
    "name": "drapeau : La Réunion",
    "version": "2.0"
  }, {
    "emoji": "🇷🇴",
    "category": 8,
    "name": "drapeau : Roumanie",
    "version": "2.0"
  }, {
    "emoji": "🇷🇸",
    "category": 8,
    "name": "drapeau : Serbie",
    "version": "2.0"
  }, {
    "emoji": "🇷🇺",
    "category": 8,
    "name": "drapeau : Russie",
    "version": "1.0"
  }, {
    "emoji": "🇷🇼",
    "category": 8,
    "name": "drapeau : Rwanda",
    "version": "2.0"
  }, {
    "emoji": "🇸🇦",
    "category": 8,
    "name": "drapeau : Arabie saoudite",
    "version": "2.0"
  }, {
    "emoji": "🇸🇧",
    "category": 8,
    "name": "drapeau : Îles Salomon",
    "version": "2.0"
  }, {
    "emoji": "🇸🇨",
    "category": 8,
    "name": "drapeau : Seychelles",
    "version": "2.0"
  }, {
    "emoji": "🇸🇩",
    "category": 8,
    "name": "drapeau : Soudan",
    "version": "2.0"
  }, {
    "emoji": "🇸🇪",
    "category": 8,
    "name": "drapeau : Suède",
    "version": "2.0"
  }, {
    "emoji": "🇸🇬",
    "category": 8,
    "name": "drapeau : Singapour",
    "version": "2.0"
  }, {
    "emoji": "🇸🇭",
    "category": 8,
    "name": "drapeau : Sainte-Hélène",
    "version": "2.0"
  }, {
    "emoji": "🇸🇮",
    "category": 8,
    "name": "drapeau : Slovénie",
    "version": "2.0"
  }, {
    "emoji": "🇸🇯",
    "category": 8,
    "name": "drapeau : Svalbard et Jan Mayen",
    "version": "2.0"
  }, {
    "emoji": "🇸🇰",
    "category": 8,
    "name": "drapeau : Slovaquie",
    "version": "2.0"
  }, {
    "emoji": "🇸🇱",
    "category": 8,
    "name": "drapeau : Sierra Leone",
    "version": "2.0"
  }, {
    "emoji": "🇸🇲",
    "category": 8,
    "name": "drapeau : Saint-Marin",
    "version": "2.0"
  }, {
    "emoji": "🇸🇳",
    "category": 8,
    "name": "drapeau : Sénégal",
    "version": "2.0"
  }, {
    "emoji": "🇸🇴",
    "category": 8,
    "name": "drapeau : Somalie",
    "version": "2.0"
  }, {
    "emoji": "🇸🇷",
    "category": 8,
    "name": "drapeau : Suriname",
    "version": "2.0"
  }, {
    "emoji": "🇸🇸",
    "category": 8,
    "name": "drapeau : Soudan du Sud",
    "version": "2.0"
  }, {
    "emoji": "🇸🇹",
    "category": 8,
    "name": "drapeau : Sao Tomé-et-Principe",
    "version": "2.0"
  }, {
    "emoji": "🇸🇻",
    "category": 8,
    "name": "drapeau : Salvador",
    "version": "2.0"
  }, {
    "emoji": "🇸🇽",
    "category": 8,
    "name": "drapeau : Saint-Martin (partie néerlandaise)",
    "version": "2.0"
  }, {
    "emoji": "🇸🇾",
    "category": 8,
    "name": "drapeau : Syrie",
    "version": "2.0"
  }, {
    "emoji": "🇸🇿",
    "category": 8,
    "name": "drapeau : Eswatini",
    "version": "2.0"
  }, {
    "emoji": "🇹🇦",
    "category": 8,
    "name": "drapeau : Tristan da Cunha",
    "version": "2.0"
  }, {
    "emoji": "🇹🇨",
    "category": 8,
    "name": "drapeau : Îles Turques-et-Caïques",
    "version": "2.0"
  }, {
    "emoji": "🇹🇩",
    "category": 8,
    "name": "drapeau : Tchad",
    "version": "2.0"
  }, {
    "emoji": "🇹🇫",
    "category": 8,
    "name": "drapeau : Terres australes françaises",
    "version": "2.0"
  }, {
    "emoji": "🇹🇬",
    "category": 8,
    "name": "drapeau : Togo",
    "version": "2.0"
  }, {
    "emoji": "🇹🇭",
    "category": 8,
    "name": "drapeau : Thaïlande",
    "version": "2.0"
  }, {
    "emoji": "🇹🇯",
    "category": 8,
    "name": "drapeau : Tadjikistan",
    "version": "2.0"
  }, {
    "emoji": "🇹🇰",
    "category": 8,
    "name": "drapeau : Tokelau",
    "version": "2.0"
  }, {
    "emoji": "🇹🇱",
    "category": 8,
    "name": "drapeau : Timor oriental",
    "version": "2.0"
  }, {
    "emoji": "🇹🇲",
    "category": 8,
    "name": "drapeau : Turkménistan",
    "version": "2.0"
  }, {
    "emoji": "🇹🇳",
    "category": 8,
    "name": "drapeau : Tunisie",
    "version": "2.0"
  }, {
    "emoji": "🇹🇴",
    "category": 8,
    "name": "drapeau : Tonga",
    "version": "2.0"
  }, {
    "emoji": "🇹🇷",
    "category": 8,
    "name": "drapeau : Turquie",
    "version": "2.0"
  }, {
    "emoji": "🇹🇹",
    "category": 8,
    "name": "drapeau : Trinité-et-Tobago",
    "version": "2.0"
  }, {
    "emoji": "🇹🇻",
    "category": 8,
    "name": "drapeau : Tuvalu",
    "version": "2.0"
  }, {
    "emoji": "🇹🇼",
    "category": 8,
    "name": "drapeau : Taïwan",
    "version": "2.0"
  }, {
    "emoji": "🇹🇿",
    "category": 8,
    "name": "drapeau : Tanzanie",
    "version": "2.0"
  }, {
    "emoji": "🇺🇦",
    "category": 8,
    "name": "drapeau : Ukraine",
    "version": "2.0"
  }, {
    "emoji": "🇺🇬",
    "category": 8,
    "name": "drapeau : Ouganda",
    "version": "2.0"
  }, {
    "emoji": "🇺🇲",
    "category": 8,
    "name": "drapeau : Îles mineures éloignées des États-Unis",
    "version": "2.0"
  }, {
    "emoji": "🇺🇳",
    "category": 8,
    "name": "drapeau : Nations Unies",
    "version": "4.0"
  }, {
    "emoji": "🇺🇸",
    "category": 8,
    "name": "drapeau : États-Unis",
    "version": "1.0"
  }, {
    "emoji": "🇺🇾",
    "category": 8,
    "name": "drapeau : Uruguay",
    "version": "2.0"
  }, {
    "emoji": "🇺🇿",
    "category": 8,
    "name": "drapeau : Ouzbékistan",
    "version": "2.0"
  }, {
    "emoji": "🇻🇦",
    "category": 8,
    "name": "drapeau : État de la Cité du Vatican",
    "version": "2.0"
  }, {
    "emoji": "🇻🇨",
    "category": 8,
    "name": "drapeau : Saint-Vincent-et-les Grenadines",
    "version": "2.0"
  }, {
    "emoji": "🇻🇪",
    "category": 8,
    "name": "drapeau : Venezuela",
    "version": "2.0"
  }, {
    "emoji": "🇻🇬",
    "category": 8,
    "name": "drapeau : Îles Vierges britanniques",
    "version": "2.0"
  }, {
    "emoji": "🇻🇮",
    "category": 8,
    "name": "drapeau : Îles Vierges des États-Unis",
    "version": "2.0"
  }, {
    "emoji": "🇻🇳",
    "category": 8,
    "name": "drapeau : Viêt Nam",
    "version": "2.0"
  }, {
    "emoji": "🇻🇺",
    "category": 8,
    "name": "drapeau : Vanuatu",
    "version": "2.0"
  }, {
    "emoji": "🇼🇫",
    "category": 8,
    "name": "drapeau : Wallis-et-Futuna",
    "version": "2.0"
  }, {
    "emoji": "🇼🇸",
    "category": 8,
    "name": "drapeau : Samoa",
    "version": "2.0"
  }, {
    "emoji": "🇽🇰",
    "category": 8,
    "name": "drapeau : Kosovo",
    "version": "2.0"
  }, {
    "emoji": "🇾🇪",
    "category": 8,
    "name": "drapeau : Yémen",
    "version": "2.0"
  }, {
    "emoji": "🇾🇹",
    "category": 8,
    "name": "drapeau : Mayotte",
    "version": "2.0"
  }, {
    "emoji": "🇿🇦",
    "category": 8,
    "name": "drapeau : Afrique du Sud",
    "version": "2.0"
  }, {
    "emoji": "🇿🇲",
    "category": 8,
    "name": "drapeau : Zambie",
    "version": "2.0"
  }, {
    "emoji": "🇿🇼",
    "category": 8,
    "name": "drapeau : Zimbabwe",
    "version": "2.0"
  }, {
    "emoji": "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    "category": 8,
    "name": "drapeau : Angleterre",
    "version": "5.0"
  }, {
    "emoji": "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    "category": 8,
    "name": "drapeau : Écosse",
    "version": "5.0"
  }, {
    "emoji": "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    "category": 8,
    "name": "drapeau : Pays de Galles",
    "version": "5.0"
  }]
};